import React from 'react';

//Includes
// import $ from "jquery";
//import './DarwinReactLibrary/js/jquery-ui-1.12.1/jquery-ui.min.js'
//import { Textfit } from 'react-textfit'
// import posed/*, { PoseGroup }*/ from 'react-pose';
//import { easing } from "popmotion";
//import Switch from "react-switch";
//import ReactBodymovin from 'react-bodymovin'
//import copy from 'copy-to-clipboard';
//import io from 'socket.io-client';
//import ReactTooltip from 'react-tooltip';
import { Textfit } from 'react-textfit'
import { CircularProgressbarWithChildren } from 'react-circular-progressbar';

//React Components
import * as Components from './resources/Components.js';
import * as Generation from './resources/Generation.js';
import * as Helpers from './resources/Helpers.js';

//CSS
import './resources/master.min.css';

//import the Darwin API classes
import API from './resources/API.js';
import {Elements, StripeProvider} from 'react-stripe-elements';
import {StripeForm, GetStripeKey} from './resources/Stripe.js';

//import all of the images
import ImageBidlyLogoWhite from './resources/images/HallPassWhite.svg'
import ImageBidlyLogoPurple from './resources/images/HallPassColored.svg'
import ImageMailbox from './resources/images/Mailbox.svg'
import ImageBackButton from './resources/images/BackButton.svg'
import ImageHelpIcon from './resources/images/HelpIcon.svg'

//import ImageAdminAmbassador from './resources/images/AdminAmbassador.svg'
import ImageAdminReview from './resources/images/AdminReview.svg'
import ImageAdminFunctions from './resources/images/AdminFunctions.svg'
import ImageManageRegions from './resources/images/ManageRegions.svg'
import ImageAdminBusiness from './resources/images/AdminBusiness.svg'

//import all of the animations
// import darkAnimationJsonFile from './DarwinReactLibrary/animations/HexAnimation/DarwinLoadingBlack.json'
// import grayAnimationJsonFile from './DarwinReactLibrary/animations/HexAnimation/DarwinLoadingGray.json'
// import lightAnimationJsonFile from './DarwinReactLibrary/animations/HexAnimation/DarwinLoadingWhite.json'

/*
//If set to false, the deep link update timer will stop.
var deepLinkUpdateTimer = trues

function cancelDeepLinkTimer() {
  deepLinkUpdateTimer = false
}*/

export class App extends React.Component {

  constructor(props) {
    super(props)

    let testData = false

    this.state = {
      view: "Home", //The view that is currently being shown "Home", "Auth".
      subview: "Home", //The subview we are viewing: "Home", "Account"
      tertiaryView: "Home", //The tertiary view we are accessing if there is one.
      topBarTitle: "Home", //The name that is displayed on the top bar.
      render: 1, //A counter to keep track of repetetive actions.

      popup: false, //is there a popup to show
      popupType: "", //the type of popup to show ("Error", "Success")
      popupTitle: "", //the popup title if there is one
      popupDescription: "", //the popup description if there is one

      confirmation: false, //is there a confirmation to show
      confirmationTitle: "", //the title text
      confirmationDescription: "", //the description text
      confirmationAcccept: "", //the accept text
      confirmationDeny: "", //the denial text
      confirmationAction: () => {}, //the function to call when complete

      userInfo: {}, //The user's information who we are accessing.
      adminInfo: {}, //The actual user who logged in.
      accountTakeover: false, //Has an associate or admin taken over this account?.
      messages: [],//Generation.generateMessages(20), //The list of messages for this account.
      creditCardMandatory: false, //Is it mandatory that we enter a credit card.
      creditCardIssue: false, //Is there an issue with the current credit card?
      shop: {}, //The information about the selected shop.
      promotion: {}, //The information about the selected promotion.
      associate: {}, //The selected associate.
    }

    if (testData) {
      this.state.messages = Generation.generateMessages(20)
    }

    this.changeView = this.changeView.bind(this)
    this.reloadUser = this.reloadUser.bind(this)
    this.loadUserInfo = this.loadUserInfo.bind(this)
    this.logout = this.logout.bind(this)
    this.showPopup = this.showPopup.bind(this)
    this.dismissPopup = this.dismissPopup.bind(this)
    this.showConfirmation = this.showConfirmation.bind(this)

    this.readMessage = this.readMessage.bind(this)
    this.stopAccessing = this.stopAccessing.bind(this)
    this.accessAccount = this.accessAccount.bind(this)
    this.loggedInUser = this.loggedInUser.bind(this)
    this.homeAndReloadUserInfo = this.homeAndReloadUserInfo.bind(this)
    this.viewShop = this.viewShop.bind(this)
    this.viewPromotion = this.viewPromotion.bind(this)
    this.updatePromotionState = this.updatePromotionState.bind(this)
    this.createOwnerAccount = this.createOwnerAccount.bind(this)
    this.createAssociateAccount = this.createAssociateAccount.bind(this)
    this.editNewOwnerCard = this.editNewOwnerCard.bind(this)
    this.goToCreateNewRegion = this.goToCreateNewRegion.bind(this)
    this.goToShopSetRegion = this.goToShopSetRegion.bind(this)
    this.viewAssociate = this.viewAssociate.bind(this)

    console.log("Mode - " + (Helpers.isDevelopment() ? "Test" : "Live"))
    console.log("App Version - " + Helpers.getAppVersion())
  }

  componentDidMount() {
    let pathComponents = Helpers.getWindowPathComponents()

    let shouldCheckAuth = true
    switch (pathComponents[0]) {
      case "Auth":
        this.changeView("Auth")
        shouldCheckAuth = false
        break;
      case "CheckRegion":
        this.changeView("AuthCheckRegion")
        shouldCheckAuth = false
        break;
      case "PayPalToken":
        //1) Make sure the states match.
        let params = API.getAllUrlParams()
        let oldState = API.getCookie("PayPalConnectState")
        //delete the PayPalConnectState after we retreive it so it can't be used again.
        API.deleteCookie("PayPalConnectState")
        let newState = params.state
        if (oldState !== newState || oldState.length === 0) {
          //states don't match or weren't set so reload the page.
          console.log("PayPalConnectStates doesn't match!", oldState, newState)
          //change the window path
          Helpers.updateWindowPath("/")
        } else {
          //2) Send the code to our API to update this HallPass user's information.
          let code = params.code
          Helpers.updateWindowPath("/")

          let stateAccount = oldState.split("_")[0]
          API.callDarwinAPI("POST", "userPaymentInfo", {
            code: code,
            sandbox: (Helpers.isDevelopment() ? 1 : 0),
          }, (result) => {
            if ("error" in result) {
              this.showPopup("Error", "Couldn't connect to PayPal", result.error)
              return
            }
          }, {"x-access-account-id": stateAccount})
        }
        break;
      default:
        break;
    }

    //1) Check to see if we are logged in and if not redirect to the login screen
    if (shouldCheckAuth) {
      this.reloadUser()
    }
  }

  /*
  Call this to change and update the view.
  This will handle resetting the state for you.
  */
  changeView(newView) {
    switch (newView) {
      case "Auth":
        this.setState({
          view: "Auth",
          subview: "Login"
        })
        break;
      case "AuthCreateAccount":
        this.setState({
          view: "Auth",
          subview: "CreateAccount",
          tertiaryView: "Owner",
        })
        break;
      case "AuthCreateAssociate":
        this.setState({
          view: "Auth",
          subview: "CreateAccount",
          tertiaryView: "Associate",
        })
        break;
      case "AuthCheckRegion":
        this.setState({
          view: "Auth",
          subview: "CheckRegion"
        })
        break;
      case "DeactivatedAccount":
        this.setState({
          view: "DeactivatedAccount",
          subview: "Home"
        })
        break;
      case "CreditCardForm":
        this.setState({
          view: "CreditCardForm",
          subview: "Home",
          creditCardMandatory: true,
          creditCardIssue: false,
        })
        break;
      case "CreditCardFormEdit":
        this.setState({
          view: "CreditCardForm",
          subview: "Home",
          creditCardMandatory: false,
          creditCardIssue: false,
        })
        break;
      case "CreditCardFormIssue":
        this.setState({
          view: "CreditCardForm",
          subview: "Home",
          creditCardMandatory: true,
          creditCardIssue: true,
        })
        break;
      case "Admin":
        this.setState({
          view: "Home",
          subview: "Admin",
          tertiaryView: "Home",
          topBarTitle: "Administration",
          render: this.state.render + 1
        })
        break;
      case "Account":
        this.setState({
          view: "Home",
          subview: "Account",
          topBarTitle: "Account"
        })
        break;
      case "Home":
        //1) Update the window path.
        Helpers.updateWindowPath("/")
        //2) Update the state.
        this.setState({
          view: "Home",
          subview: "Home",
          topBarTitle: "Home"
        })
        break;
      case "Associate":
        //1) Update the state.
        this.setState({
          view: "Home",
          subview: "Associate",
          topBarTitle: this.state.associate.name
        })
        break;
      case "Shop":
        //1) Update the state.
        this.setState({
          view: "Home",
          subview: "Shop",
          topBarTitle: this.state.shop.shopName
        })
        break;
      case "ShopSetOwner":
        //1) Update the state.
        this.setState({
          view: "Home",
          subview: "ShopSetOwner",
          topBarTitle: "Set Shop Owner"
        })
        break;
      case "ShopSetRegion":
        //1) Update the state.
        this.setState({
          view: "Home",
          subview: "ShopSetRegion",
          topBarTitle: "Set Shop Region"
        })
        break;
      case "CreateNewRegion":
        //1) Update the state.
        this.setState({
          view: "Home",
          subview: "Admin",
          tertiaryView: "ManageRegions",
          topBarTitle: "Administration"
        })
        break;
      case "CreateShop":
        //1) Update the state.
        this.setState({
          view: "Home",
          subview: "CreateShop",
          topBarTitle: "Create Shop"
        })
        break;
      case "EditShop":
        //1) Update the state.
        this.setState({
          view: "Home",
          subview: "EditShop",
          topBarTitle: "Edit Shop"
        })
        break;
      case "CreatePromotion":
        //1) Update the state.
        this.setState({
          view: "Home",
          subview: "CreatePromotion",
          topBarTitle: "Create Promotion"
        })
        break;
      case "EditPromotion":
        //1) Update the state.
        this.setState({
          view: "Home",
          subview: "EditPromotion",
          topBarTitle: "Edit Promotion"
        })
        break;
      case "Promotion":
        //1) Update the state.
        this.setState({
          view: "Home",
          subview: "Promotion",
          topBarTitle: this.state.promotion.promoTitle
        })
        break;
      default:
        break;
    }
  }

  /*
  Reloads this user's information
  */
  reloadUser() {
    /*static checkAuthentication(authURL, authType, tradeURL, clientID, redirectURL, callback) {
      //1) See if there is an auth code and state in the url params.
      let urlParams = Darwin.getAllUrlParams();
      if ('error' in urlParams) {
        //There was an error in the authentication process.
        console.log(urlParams['error'])
      } else if ('state' in urlParams && 'code' in urlParams) {
        //1.11) Make sure the state matches.
        let requestState = Darwin.getCookie("darwin-state")
        if (urlParams["state"] === requestState) {
          //1.12) Get the PKCE Verification.
          let authCode = urlParams["code"]
          let requestPKCE = Darwin.getCookie("darwin-pkce")
          //1.13) Send the request to /access_token to trade for access_tokens.
          Darwin.callUnsecuredAPI("POST", tradeURL, {
            "grant_type": "authorization_code",
            "client_id": clientID,
            "redirect_uri": redirectURL,
            "code_verifier": requestPKCE,
            "code": authCode
          }, (result) => {
            //Check the tokens and make sure they are set.
            if (result === undefined || result["csrf_token"] === undefined || result["access_token"] === undefined || result["refresh_token"] === undefined) {
              console.log("Error Trading Auth Code For Tokens:", result)
              Darwin.redirectToAuthURL(authURL)
              return
            }
            Darwin.setCookie("darwin-csrf", result["csrf_token"], result["expires_in"]);
            Darwin.setCookie("darwin-access", result["access_token"], result["expires_in"]);
            Darwin.setCookie("darwin-refresh", result["refresh_token"], result["expires_in"]);
            Darwin.deleteCookie("darwin-state");
            Darwin.deleteCookie("darwin-pkce");
            //If not, then we need to make sure that they are accurate.
            callback(true, "traded")
          })
          return true;
        } else {
          console.log("States don't match")
          Darwin.redirectToAuthURL(authURL)
        }
      }
      if (Darwin.getCookie('darwin-csrf') !== "") {
        //2) The tokens have been set so we can continue to use the app and make API requests.
        callback(true)
        return true;
      }
      //The user is not logged in.
      Darwin.logout(authURL, authType)
      return false;
    }*/
    //2)
    API.checkAuthentication(() => {
      //2) Load the current user's information
      this.setState({
        userInfo: {},
        adminInfo: {},
        accountTakeover: false,
        messages: []
      })
      API.accessAccountID = false
      this.loadUserInfo()
    })
  }

  /*
  * Loads the user information
  */
  loadUserInfo(callback = null) {
    API.callDarwinAPI("GET", "userProfile", {}, (result) => {
      if ("error" in result) {
        this.showPopup("Error", "Couldn't get the user profile", result.error)
        return
      }
      //console.log("User Profile", result.data)
      let data = {
        userInfo: result.data.userInfo,
        messages: result.data.messages
      }
      if (!this.state.accountTakeover) {
        data['adminInfo'] = result.data.userInfo
      }
      this.setState(data, () => {
        /*if (result.data.userInfo.stripeValid === false && result.data.userInfo.accountType === "Owner" && result.data.userInfo.rate !== "0" && !this.state.accountTakeover) {
          //we need the user's credit card.
          if (result.data.userInfo.stripeIssue) {
            this.changeView("CreditCardFormIssue")
          } else {
            this.changeView("CreditCardForm")
          }
        } else */if (result.data.userInfo.accountType === "Associate" && Helpers.dateInPast(result.data.userInfo.deactivationDate)) {
          //this Ambassador account has been deactivated. Show the user a page that they will need to contact support to get back their page.
          this.changeView("DeactivatedAccount")
        } else if (callback !== null && typeof callback === "function") {
          callback()
        }
      })
    })
  }

  /*
  * Logs the user out of the program.
  */
  logout() {
    API.logout()
  }

  /*
  * Show the error with a dismiss button
  */
  showPopup(type, title, description) {
    this.setState({
      popup: true,
      popupType: type,
      popupTitle: title,
      popupDescription: description
    })
  }

  /*
  * Dismiss the error message.
  */
  dismissPopup() {
    this.setState({
      popup: false,
      popupTitle: "",
      popupDescription: "",
    })
  }

  /*
  * Shows a confirmation dialog with an optional callback passing true or false
  * to whether they have accepted the action
  */
  showConfirmation(title, description, accept, deny, action) {
    this.setState({
      confirmation: true,
      confirmationTitle: title,
      confirmationDescription: description,
      confirmationAccept: accept,
      confirmationDeny: deny,
      confirmationAction: (result) => {
        this.setState({
          confirmation: false
        })
        action(result)
      }
    })
  }

  /*
  * The message has been read so update the status in the database.
  */
  readMessage(message) {
    console.log("read message")
    this.setState(prevState => {
      let messages = prevState.messages
      for (let i = 0; i < messages.length; i = i + 1) {
        if (messages[i].messageID === message.messageID) {
          console.log("found the message")
          messages[i].readDateTime = new Date().toString()
          //Update the Database for this message that it has been read.
          API.callDarwinAPI("PUT", "readMessage/" + message.messageID, {}, (result) => {
            if ("error" in result) {
              this.showPopup("Error", "Couldn't update the message state", result.error)
              return
            }
            console.log("Read Message", result.data)
          })
          break
        }
      }
      return {
        messages: messages
      }
    })
  }

  /*
  * Go back to our account.
  */
  stopAccessing(callback = null) {
    //console.log("Stop Accessing Account")
    this.setState({
      accountTakeover: false,
      userInfo: this.state.adminInfo
    }, () => {
      API.accessAccountID = false
      this.changeView("Home")
      this.loadUserInfo(callback)
    })
  }

  /*
  Starts accessing an account if possible.
  */
  accessAccount(accountID, callback = null) {
    if (!accountID) {
      console.log("Cannot access a null account.")
      return
    }
    //console.log("Accessing Account:", accountID)
    if (this.state.userInfo.accountType === "Admin" || this.state.userInfo.accountType === "Associate") {
      this.setState({
        accountTakeover: true,
        userInfo: {
          id: accountID
        }
      }, () => {
        //load this user's information
        API.accessAccountID = accountID
        if (!callback) {
          //go to the home page if no callback
          this.changeView("Home")
        }
        this.loadUserInfo(callback)
      })
    } else {
      this.showPopup("Error", "You don't have the proper permissions to access this account.", "You must be a HallPass Associate or Admin to experience this functionality.")
    }
  }

  /*
  A user has just logged in.
  */
  loggedInUser() {
    //1) Update the view.
    this.changeView("Home")
    //2) Reload the information about the logged in user to set the accountType, messages, and userInfo
    this.reloadUser()
  }

  /*
  Returns home and reloads the user information
  */
  homeAndReloadUserInfo() {
    //1) Update the view.
    this.changeView("Home")
    //2) Reload the information about the logged in user to set the accountType, messages, and userInfo
    this.loadUserInfo()
  }

  /*
  Goes to the view shop page.
  */
  viewShop(shop, e = null, callback = null) {
    //console.log(shop)
    if (shop.portalUserID === this.state.userInfo.id) {
      //console.log("Go To Shop")
      this.setState({
        shop: shop
      }, () => {
        this.changeView("Shop")
        if (callback) {
          callback()
        }
      })
    } else {
      //console.log("Access Account")
      if (!shop.portalUserID) {
        this.setState({
          shop: shop
        }, () => {
          this.changeView("ShopSetOwner")
          if (callback) {
            callback()
          }
        })
      } else {
        this.accessAccount(shop.portalUserID, () => {
          //console.log("Now go to the shop page")
          this.setState({
            shop: shop
          }, () => {
            this.changeView("Shop")
            if (callback) {
              callback()
            }
          })
        })
      }
    }
  }

  viewPromotion(promo) {
    this.setState({
      promotion: promo
    }, () => {
      this.changeView("Promotion")
    })
  }

  updatePromotionState(promo) {
    this.setState({
      promotion: promo
    })
  }

  /*
  This will go to the create account page where you will be able to create an account for an Owner.
  */
  createOwnerAccount() {
    this.changeView("AuthCreateAccount")
  }

  /*
  This will go to the create account page where you will be able to create an associate account.
  */
  createAssociateAccount() {
    this.changeView("AuthCreateAssociate")
  }

  editNewOwnerCard(newOwnerID) {
    //1) Access this account
    this.accessAccount(newOwnerID, () => {
      //info loaded now go to the creditCardFormEdit
      this.changeView("CreditCardFormEdit")
    })
  }

  goToCreateNewRegion() {
    this.stopAccessing(() => {
      this.changeView("CreateNewRegion")
    })
  }

  goToShopSetRegion(shop) {
    //1) View the shop
    this.viewShop(shop, null, () => {
      //2) Now change the view to be ShopSetRegion
      this.changeView("ShopSetRegion")
    })
  }

  viewAssociate(associate) {
    this.setState({
      associate: associate
    }, () => {
      this.changeView("Associate")
    })
  }

  render() {

    let popupProps = {
      main: this.state.popupType,
      title: this.state.popupTitle,
      description: this.state.popupDescription,
      dismiss: this.dismissPopup,
    }
    let confirmationProps = {
      main: "Confirmation",
      title: this.state.confirmationTitle,
      description: this.state.confirmationDescription,
      accept: this.state.confirmationAccept,
      deny: this.state.confirmationDeny,
      action: this.state.confirmationAction
    }

    let headerProps = {
      topBarTitle: this.state.topBarTitle,
      userInfo: this.state.userInfo,
      accountTakeover: this.state.accountTakeover,
      goToHome: this.changeView.bind(this, "Home"),
      goToAdmin: this.changeView.bind(this, "Admin"),
      goToAccount: this.changeView.bind(this, "Account"),
      stopAccessing: this.stopAccessing,
      messages: this.state.messages,
      readMessage: this.readMessage,
    }

    let authProps = {
      loggedIn: this.loggedInUser,
      showPopup: this.showPopup,
      showConfirmation: this.showConfirmation,
      subview: this.state.subview,
      tertiaryView: this.state.tertiaryView,
      userInfo: this.state.userInfo,
      goHome: this.homeAndReloadUserInfo,
      goToEditCard: this.editNewOwnerCard,
    }

    let accountProps = {
      userInfo: this.state.userInfo,
      adminInfo: this.state.adminInfo,
      accountTakeover: this.state.accountTakeover,
      loadUserInfo: this.loadUserInfo,
      logout: this.logout,
      showPopup: this.showPopup,
      showConfirmation: this.showConfirmation,
      goToEditCard: this.changeView.bind(this, "CreditCardFormEdit")
    }

    let creditCardFormProps = {
      userInfo: this.state.userInfo,
      adminInfo: this.state.adminInfo,
      accountTakeover: this.state.accountTakeover,
      showPopup: this.showPopup,
      showConfirmation: this.showConfirmation,
      creditCardMandatory: this.state.creditCardMandatory,
      creditCardIssue: this.state.creditCardIssue,
      backFromCreditCardForm: this.homeAndReloadUserInfo
    }

    let homeProps = {
      userInfo: this.state.userInfo,
      adminInfo: this.state.adminInfo,
      accountTakeover: this.state.accountTakeover,
      showPopup: this.showPopup,
      showConfirmation: this.showConfirmation,
      goToCreateShop: this.changeView.bind(this, "CreateShop"),
      takeoverAccount: this.accessAccount,
      viewShop: this.viewShop,
      viewAssociate: this.viewAssociate,
      goToCreateAccount: this.createOwnerAccount,
      goToCreateAssociate: this.createAssociateAccount,
    }

    let associateProps = {
      userInfo: this.state.userInfo,
      adminInfo: this.state.adminInfo,
      accountTakeover: this.state.accountTakeover,
      takeoverAccount: this.accessAccount,
      finished: this.homeAndReloadUserInfo,
      showPopup: this.showPopup,
      showConfirmation: this.showConfirmation,
      associate: this.state.associate,
    }

    let shopSetOwnerProps = {
      userInfo: this.state.userInfo,
      adminInfo: this.state.adminInfo,
      accountTakeover: this.state.accountTakeover,
      finished: this.homeAndReloadUserInfo,
      showPopup: this.showPopup,
      showConfirmation: this.showConfirmation,
      shop: this.state.shop,
    }

    let shopSetRegionProps = {
      userInfo: this.state.userInfo,
      adminInfo: this.state.adminInfo,
      accountTakeover: this.state.accountTakeover,
      finished: this.homeAndReloadUserInfo,
      showPopup: this.showPopup,
      showConfirmation: this.showConfirmation,
      shop: this.state.shop,
      createNewRegion: this.goToCreateNewRegion,
    }

    let createShopProps = {
      userInfo: this.state.userInfo,
      adminInfo: this.state.adminInfo,
      accountTakeover: this.state.accountTakeover,
      finished: this.homeAndReloadUserInfo,
      showPopup: this.showPopup,
      showConfirmation: this.showConfirmation,
    }

    let shopProps = {
      userInfo: this.state.userInfo,
      adminInfo: this.state.adminInfo,
      accountTakeover: this.state.accountTakeover,
      finished: this.homeAndReloadUserInfo,
      showPopup: this.showPopup,
      showConfirmation: this.showConfirmation,
      shop: this.state.shop,
      editShop: this.changeView.bind(this, "EditShop"),
      changeShopOwner: this.changeView.bind(this, "ShopSetOwner"),
      changeShopRegion: this.changeView.bind(this, "ShopSetRegion"),
      createPromotion: this.changeView.bind(this, "CreatePromotion"),
      viewPromotion: this.viewPromotion,
    }

    let editShopProps = {
      userInfo: this.state.userInfo,
      adminInfo: this.state.adminInfo,
      accountTakeover: this.state.accountTakeover,
      showPopup: this.showPopup,
      showConfirmation: this.showConfirmation,
      finished: this.homeAndReloadUserInfo,
      shop: this.state.shop,
    }

    let createPromotionProps = {
      userInfo: this.state.userInfo,
      adminInfo: this.state.adminInfo,
      accountTakeover: this.state.accountTakeover,
      finished: this.viewShop.bind(this, this.state.shop),
      showPopup: this.showPopup,
      showConfirmation: this.showConfirmation,
      shop: this.state.shop,
    }

    let promotionProps = {
      userInfo: this.state.userInfo,
      adminInfo: this.state.adminInfo,
      accountTakeover: this.state.accountTakeover,
      finished: this.viewShop.bind(this, this.state.shop),
      showPopup: this.showPopup,
      showConfirmation: this.showConfirmation,
      shop: this.state.shop,
      promotion: this.state.promotion,
      editPromotion: this.changeView.bind(this, "EditPromotion"),
      updatePromotionState: this.updatePromotionState,
    }

    let editPromotionProps = {
      userInfo: this.state.userInfo,
      adminInfo: this.state.adminInfo,
      accountTakeover: this.state.accountTakeover,
      showPopup: this.showPopup,
      showConfirmation: this.showConfirmation,
      finished: this.viewPromotion.bind(this, this.state.promotion),
      shop: this.state.shop,
      promotion: this.state.promotion,
    }

    let adminProps = {
      tertiaryView: this.state.tertiaryView,
      userInfo: this.state.userInfo,
      adminInfo: this.state.adminInfo,
      accountTakeover: this.state.accountTakeover,
      showPopup: this.showPopup,
      showConfirmation: this.showConfirmation,
      viewShop: this.viewShop,
      shopSetRegion: this.goToShopSetRegion,
      render: this.state.render,
    }

    let deactivatedAccountProps = {
      userInfo: this.state.userInfo,
      adminInfo: this.state.adminInfo,
      accountTakeover: this.state.accountTakeover,
      showPopup: this.showPopup,
      showConfirmation: this.showConfirmation,
      logout: this.logout
    }

    return (
      <div className="App">
        {/*this.state.confirmation &&
          <Confirmation {...this.state.confirmationProps} />
        */}
        { this.state.popup &&
          <Components.Popup {...popupProps} />
        }
        { this.state.confirmation &&
          <Components.Confirmation {...confirmationProps} />
        }
        { this.state.view === "Auth" &&
          <Auth {...authProps}>
          </Auth>
        }
        { this.state.view === "CreditCardForm" &&
          <CreditCardForm {...creditCardFormProps}>
          </CreditCardForm>
        }
        { this.state.view === "DeactivatedAccount" &&
          <DeactivatedAccount {...deactivatedAccountProps}>
          </DeactivatedAccount>
        }
        { this.state.view === "Home" &&
          <span className="AppContainer">
            <Header {...headerProps} />
            <div className="MainBody">
              { this.state.subview === "Home" &&
                <Home {...homeProps} />
              }
              { this.state.subview === "CreateShop" &&
                <CreateShop {...createShopProps} />
              }
              { this.state.subview === "EditShop" &&
                <EditShop {...editShopProps} />
              }
              { this.state.subview === "Shop" &&
                <Shop {...shopProps} />
              }
              { this.state.subview === "ShopSetOwner" &&
                <ShopSetOwner {...shopSetOwnerProps} />
              }
              { this.state.subview === "ShopSetRegion" &&
                <ShopSetRegion {...shopSetRegionProps} />
              }
              { this.state.subview === "CreatePromotion" &&
                <CreatePromotion {...createPromotionProps} />
              }
              { this.state.subview === "EditPromotion" &&
                <EditPromotion {...editPromotionProps} />
              }
              { this.state.subview === "Promotion" &&
                <Promotion {...promotionProps} />
              }
              { this.state.subview === "Associate" &&
                <Associate {...associateProps} />
              }
              { this.state.subview === "Account" &&
                <Account {...accountProps} />
              }
              { this.state.subview === "Admin" &&
                <Admin {...adminProps} />
              }
            </div>
          </span>
        }
      </div>
    );
  }
}

export class Home extends React.Component {

  constructor(props) {
    super(props)

    let data = {
      filterActive: { value: "Active", valid: true },
      filterTestData: { value: "Real", valid: true },
    }
    if (Helpers.isDevelopment()) {
      data.filterTestData = { value: "Test", valid: true }
    }

    this.state = {
      shops: [],
      accounts: [],
      payout: 0,
      loading: false,
      data: data,
      forceCheck: false,
      shakeButton: false,
    }

    this._isMounted = false

    this.loadShops = this.loadShops.bind(this)

    this.submitForm = this.submitForm.bind(this)
    this.formChanged = this.formChanged.bind(this)
    this.shakeTheButton = this.shakeTheButton.bind(this)
    this.takeoverAccount = this.takeoverAccount.bind(this)
  }

  componentDidMount() {
    this._isMounted = true
    this.submitForm()
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  componentDidUpdate(prevProps) {
    if (prevProps.userInfo.id !== this.props.userInfo.id) {
      //reload the data if the user has changed.
      this.submitForm()
    }
  }

  loadShops(data) {
    let d2 = data
    d2.search = d2.search || ""
    //console.log("GET /shops", d2)
    this.setState({
      loading: true
    }, () => {
      API.callDarwinAPI("GET", "shops", d2, (result) => {
        //console.log(result)
        if (!this._isMounted) {
          return
        }
        if ("error" in result) {
          this.props.showPopup("Error", "Couldn't retreive your shops", result.error)
          this.setState({
            loading: false,
            shops: [],
            accounts: []
          })
          return
        }
        this.setState({
          loading: false,
          shops: result.data.shops,
          accounts: result.data.accounts
        })
      })
    })
  }

  /*
  * Submits the form
  */
  submitForm() {
    //1) Make sure every data element is valid.
    let valid = true
    for (let key in this.state.data) {
      if (this.state.data[key].valid === false) {
        valid = false
      }
    }
    //2) Make sure we have all of the data.
    let requiredFields = []
    requiredFields.forEach((element) => {
      if (this.state.data[element] === undefined || this.state.data[element].value === undefined) {
        console.log("invalid", element, this.state.data[element])
        valid = false
      }
    })
    //3) If valid, submit, else force check the fields for display.
    if (valid) {
      let data = {}
      for (let key in this.state.data) {
        if (key === "search" || this.state.data[key].value.length > 0) {
          data[key] = this.state.data[key].value
        }
      }
      //Submit the form
      this.loadShops(data)
    } else {
      console.log("Form not valid to submit")
      this.setState({
        forceCheck: true
      })
      //Shake the submit button as it is invalid to submit
      this.shakeTheButton()
      return
    }
  }

  /*
  * Called when data in an input form changes.
  * This will update the state.data param with the
  * name and new value of the form element.
  */
  formChanged(name, value, valid) {
    this.setState((prevState) => {
      let d = prevState.data
      d[name] = {
        value: value,
        valid: valid
      }
      return {
        data: d
      }
    }, () => {
      let searchValue = this.state.data.search ? (this.state.data.search.value.length === 0 ? "" : this.state.data.search.value) : ""
      if (["filterTestData", "filterAssigned", "filterAccountType", "filterActive", "filterBillingOptions", "filterCreditCard", "filterPayPal"].includes(name) && searchValue === "") {
        this.submitForm()
      }
    })
  }

  /*
  Shakes the button and then removes the class.
  */
  shakeTheButton() {
    this.setState({
      shakeButton: true
    }, () => {
      setTimeout(() => {
        this.setState({
          shakeButton: false
        })
      }, 1000)
    })
  }

  /*
  Takes over an account with the provided accountID
  Also, this will clear the search bar.
  */
  takeoverAccount(accountID) {
    this.formChanged("search", "", true)
    this.props.takeoverAccount(accountID)
  }

  render() {

    let filterTestDataOptions = [
      {value: "", label: "Test & Real Data"},
      {value: "Real", label: "Real Data"},
      {value: "Test", label: "Test Data"},
    ]
    let filterAssignedOptions = [
      {value: "", label: "Assigned & Unassigned Shop Owner"},
      {value: "Assigned", label: "Assigned Shop Owner"},
      {value: "Unassigned", label: "Unassigned Shop Owner"},
    ]
    let filterAccountTypeOptions = [
      {value: "", label: "Owners & Ambassadors"},
      {value: "Owners", label: "Owners"},
      {value: "Ambassadors", label: "Ambassadors"},
      {value: "Old Ambassadors", label: "Old Ambassadors"},
    ]
    let filterActiveOptions = [
      {value: "", label: "Active & Inactive Data"},
      {value: "Active", label: "Active Data"},
      {value: "Inactive", label: "Inactive Data"},
      {value: "Deactive", label: "To Be Inactive Data"},
    ]
    let filterBillingOptions = [
      {value: "", label: "All Billing Options"},
      {value: "Region", label: "Region Charged"},
      {value: "Manual", label: "Manually Charged"},
      {value: "Free", label: "Free of Charge"},
    ]
    let filterCreditCardOptions = [
      {value: "", label: "Credit Card Set & Not Set"},
      {value: "Set", label: "Credit Card Set"},
      {value: "NotSet", label: "Credit Card Not Set"},
      {value: "Issue", label: "Credit Card Issue"},
    ]
    let filterPayPalOptions = [
      {value: "", label: "PayPal Set & Not Set"},
      {value: "Set", label: "PayPal Set"},
      {value: "NotSet", label: "PayPal Not Set"},
    ]
    let showWalkthrough = this.state.shops.length === 0 && this.props.userInfo.accountType === "Owner" && !this.state.data.search

    return (
      <div className="Home">
        <div className="HomeContent">
          { this.state.loading &&
            <div className="HomeLoading">
              <Components.LoadingIndicator />
            </div>
          }
          { !this.state.loading &&
            <span>
              { showWalkthrough &&
                <span>
                  <div className="WalkthroughTitle">
                    Welcome to HallPass
                  </div>
                  <div className="WalkthroughImage">
                    <Components.DualImage image={ImageAdminBusiness} style={{width:"100px"}} />
                  </div>
                  <div className="WalkthroughDescription">
                    Let's get started by creating your first shop.
                    <br/>
                    Go ahead and click the 'Create Shop' button below.
                  </div>
                </span>
              }
              { !showWalkthrough &&
                <span>
                  <div className="InputDiv">
                    <Components.InputBottomLine type="text" name="search" placeholder="Search" validation="text" required="false" maximum={255}
                      center={true}
                      value={this.state.data.search ? this.state.data.search.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
                  </div>
                  { this.props.userInfo.accountType === "Admin" &&
                    <div className="HomeFilters">
                      { (this.state.data.search ? (this.state.data.search.value.length > 0 ? false : true) : true) &&
                        <span>
                          <Components.InputBottomLine type="filter" name="filterTestData" placeholder="none" validation="text" required="false" maximum={255}
                            options={filterTestDataOptions}
                            value={this.state.data.filterTestData ? this.state.data.filterTestData.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
                          <Components.InputBottomLine type="filter" name="filterAssigned" placeholder="none" validation="text" required="false" maximum={255}
                            options={filterAssignedOptions}
                            value={this.state.data.filterAssigned ? this.state.data.filterAssigned.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
                          <Components.InputBottomLine type="filter" name="filterAccountType" placeholder="none" validation="text" required="false" maximum={255}
                            options={filterAccountTypeOptions}
                            value={this.state.data.filterAccountType ? this.state.data.filterAccountType.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
                          <Components.InputBottomLine type="filter" name="filterActive" placeholder="none" validation="text" required="false" maximum={255}
                            options={filterActiveOptions}
                            value={this.state.data.filterActive ? this.state.data.filterActive.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
                          <Components.InputBottomLine type="filter" name="filterBillingOptions" placeholder="none" validation="text" required="false" maximum={255}
                            options={filterBillingOptions}
                            value={this.state.data.filterBillingOptions ? this.state.data.filterBillingOptions.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
                          <Components.InputBottomLine type="filter" name="filterCreditCard" placeholder="none" validation="text" required="false" maximum={255}
                            options={filterCreditCardOptions}
                            value={this.state.data.filterCreditCard ? this.state.data.filterCreditCard.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
                          <Components.InputBottomLine type="filter" name="filterPayPal" placeholder="none" validation="text" required="false" maximum={255}
                            options={filterPayPalOptions}
                            value={this.state.data.filterPayPal ? this.state.data.filterPayPal.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
                        </span>
                      }
                    </div>
                  }
                  { this.props.userInfo.accountType !== "Admin" &&
                    <div className="HomeDescription" style={{textAlign:"center", marginTop:"30px"}}>
                      Use the search box above to find a store. You can search by name, location, category, ...
                    </div>
                  }
                  <div className="HomeTitle">
                    Shops
                  </div>
                  <div className="HomeShopContainer">
                    { this.state.shops.length === 0 &&
                      <div className="HomeDescription">
                        no shops found
                      </div>
                    }
                    { this.state.shops.length > 0 &&
                      <span>
                        { this.state.shops.map((shop, i) => (
                          <Components.ShopDiv key={"shop" + i} onClick={this.props.viewShop.bind(this, shop)} {...shop} userInfo={this.props.userInfo} />
                        ))}
                      </span>
                    }
                  </div>
                  { (this.props.userInfo.accountType === "Admin" || this.props.userInfo.accountType === "Associate") &&
                    <span>
                      <div className="HomeTitle">
                        Accounts
                      </div>
                      <div className="HomeAccountContainer">
                        { this.state.accounts.length === 0 &&
                          <div className="HomeDescription">
                            no accounts found
                          </div>
                        }
                        { this.state.accounts.length > 0 &&
                          <span>
                            { this.state.accounts.map((account, i) => (
                              <Components.AccountDiv key={"account" + i} {...account}
                                onClick={() => {
                                  if (account.accountType === "Associate") {
                                    this.props.viewAssociate(account)
                                  }
                                }}
                                takeoverAccount={this.takeoverAccount}
                                accessAccountType={this.props.userInfo.accountType}
                                accessAccountID={this.props.userInfo.id} />
                            ))}
                          </span>
                        }
                      </div>
                    </span>
                  }
                </span>
              }
            </span>
          }
        </div>
        <div className="HomeBottom">
          { this.props.userInfo.accountType === "Owner" &&
            <Components.MaterialButton type="Purple" className={showWalkthrough ? "AnimationFloatBounce" : ""} onClick={this.props.goToCreateShop}>Create Shop</Components.MaterialButton>
          }
          { this.props.userInfo.accountType === "Associate" &&
            <Components.MaterialButton type="TextPurpleShadow" onClick={this.props.goToCreateAccount}>Create Owner</Components.MaterialButton>
          }
          { this.props.userInfo.accountType === "Admin" &&
            <span>
              <Components.MaterialButton type="Purple" onClick={this.props.goToCreateShop}>Create Shop</Components.MaterialButton>
              <Components.MaterialButton type="TextPurpleShadow" onClick={this.props.goToCreateAccount}>Create Owner</Components.MaterialButton>
              <Components.MaterialButton type="TextPurpleShadow" onClick={this.props.goToCreateAssociate}>Create Ambassador</Components.MaterialButton>
            </span>
          }
          { /*this.props.userInfo.accountType === "Associate" &&
            <Components.MoneyCircle value={ this.props.userInfo.nextPayout } />
          */}
        </div>
      </div>
    )
  }
}

export class Shop extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      shop: {},
      stats: {},
      promotions: [],
      region: {},

      expandedStat: false
    }

    this.loadShopInfo = this.loadShopInfo.bind(this)
    this.expandStat = this.expandStat.bind(this)
    this.loadStatisticsInformation = this.loadStatisticsInformation.bind(this)
    this.changeActivation = this.changeActivation.bind(this)
    this.promotionSelected = this.promotionSelected.bind(this)
    this.deleteShopForGood = this.deleteShopForGood.bind(this)
  }

  componentDidMount() {
    //Load the shop page data
    this.loadShopInfo()
  }

  loadShopInfo() {
    this.setState({
      loading: true,
      shop: {},
      stats: {},
      promotions: [],
      region: {},
    }, () => {
      API.callDarwinAPI("GET", "shop/" + this.props.shop.shopID, {}, (result) => {
        //console.log("shop/" + this.props.shop.shopID, result)
        if ("error" in result) {
          this.props.showPopup("Error", "Couldn't retreive the shop information", result.error)
          this.setState({
            loading: false,
          })
          return
        }
        this.setState({
          loading: false,
          shop: result.data.shop,
          stats: result.data.stats,
          promotions: result.data.promotions,
          region: result.data.region,
        })
      })
    })
  }

  /*
  Expands or closes the stat
  */
  expandStat() {
    if (this.state.expandedStat) {
      this.setState({
        expandedStat: false
      })
    } else {
      this.setState({
        expandedStat: true
      })
    }
  }

  /*
  Loads the statistic information based on the range provided
  and returns the data. This is called by StatisticsGraph
  */
  loadStatisticsInformation(callback, days = 7) {
    API.callDarwinAPI("GET", "shopStats/" + this.props.shop.shopID, {
      days: days
    }, (response) => {
      if ("error" in response) {
        this.props.showPopup("Error", "Couldn't retreive the shop statistics", response.error)
        return
      }
      callback(response.data)
    })
    return
    /*
    let data = [
      {
        "id": "Views",
        "color": "#393C51",
        "data": [
          {
            "x": "2019-01-13",
            "y": 89
          },
          {
            "x": "2019-01-14",
            "y": 102
          },
          {
            "x": "2019-01-15",
            "y": 23
          },
          {
            "x": "2019-01-16",
            "y": 109
          },
          {
            "x": "1-17",
            "y": 251
          },
          {
            "x": "1-18",
            "y": 51
          },
          {
            "x": "1-19",
            "y": 278
          },
          {
            "x": "1-20",
            "y": 272
          },
          {
            "x": "1-21",
            "y": 300
          },
          {
            "x": "1-22",
            "y": 230
          },
          {
            "x": "1-23",
            "y": 10
          },
          {
            "x": "1-24",
            "y": 297
          }
        ]
      },
      {
        "id": "Taps",
        "color": "#8B4CFF",
        "data": [
          {
            "x": "1-13",
            "y": 12
          },
          {
            "x": "1-14",
            "y": 35
          },
          {
            "x": "1-15",
            "y": 18
          },
          {
            "x": "1-16",
            "y": 24
          },
          {
            "x": "1-17",
            "y": 93
          },
          {
            "x": "1-18",
            "y": 52
          },
          {
            "x": "1-19",
            "y": 35
          },
          {
            "x": "1-20",
            "y": 212
          },
          {
            "x": "1-21",
            "y": 119
          },
          {
            "x": "1-22",
            "y": 111
          },
          {
            "x": "1-23",
            "y": 10
          },
          {
            "x": "1-24",
            "y": 140
          }
        ]
      },
      {
        "id": "Favorites",
        "color": "#FF406C",
        "data": [
          {
            "x": "1-13",
            "y": 7
          },
          {
            "x": "1-14",
            "y": 5
          },
          {
            "x": "1-15",
            "y": 6
          },
          {
            "x": "1-16",
            "y": 7
          },
          {
            "x": "1-17",
            "y": 12
          },
          {
            "x": "1-18",
            "y": 9
          },
          {
            "x": "1-19",
            "y": 8
          },
          {
            "x": "1-20",
            "y": 7
          },
          {
            "x": "1-21",
            "y": 6
          },
          {
            "x": "1-22",
            "y": 8
          },
          {
            "x": "1-23",
            "y": 7
          },
          {
            "x": "1-24",
            "y": 5
          }
        ]
      },
      {
        "id": "Uses",
        "color": "#3EC43F",
        "data": [
          {
            "x": "1-13",
            "y": 2
          },
          {
            "x": "1-14",
            "y": 3
          },
          {
            "x": "1-15",
            "y": 2
          },
          {
            "x": "1-16",
            "y": 4
          },
          {
            "x": "1-17",
            "y": 1
          },
          {
            "x": "1-18",
            "y": 0
          },
          {
            "x": "1-19",
            "y": 0
          },
          {
            "x": "1-20",
            "y": 5
          },
          {
            "x": "1-21",
            "y": 4
          },
          {
            "x": "1-22",
            "y": 3
          },
          {
            "x": "1-23",
            "y": 4
          },
          {
            "x": "1-24",
            "y": 2
          }
        ]
      },
    ]
    callback(data)*/
  }

  /*
  Change the deactivationDate.
  Pass in -2 to remove the deactivation date
  */
  changeActivation(days) {
    let title = "Your shop will be deactivated in " + days + " days."
    let description = "After " + days + " days, this shop will be deactivated."
    if (days === 0) {
      title = "Your shop will be deactivated immediately"
      description = "You can re-activate this shop at any time."
    }
    let accept = "Deactivate"
    let deny = "Cancel"
    if (days === -2) {
      title = "Reactivating this shop will make this shop show up on the map if there is an active promotion."
      description = "You can de-activate this shop at any time."
      accept = "Reactivate"
      deny = "Cancel"
    }
    this.props.showConfirmation(title, description, accept, deny, (action) => {
      if (action) {
        this.setState({
          loading: true
        }, () => {
          API.callDarwinAPI("DELETE", "shop/" + this.props.shop.shopID, {
            days: days
          }, (result) => {
            console.log("DELETE shop/" + this.props.shop.shopID, result)
            if ("error" in result) {
              this.props.showPopup("Error", "Couldn't change activation status", result.error)
              this.setState({
                loading: false
              })
              return
            }
            this.loadShopInfo()
          })
        })
      }
    })
  }

  promotionSelected(promo) {
    this.props.viewPromotion(promo)
  }

  deleteShopForGood() {
    this.props.showConfirmation("Wait!", "Are you sure you want to delete this shop. this shop will be deleted forever and there is no way to recover it. Use with caution!", "Delete Shop Forever", "Cancel", (shouldDelete) => {
      if (shouldDelete) {
        this.setState({
          loading: true
        }, () => {
          API.callDarwinAPI("DELETE", "shopForever/" + this.state.shop.shopID, {}, (response) => {
            if ("error" in response) {
              this.props.showPopup("Error", "Couldn't delete the shop", response.error)
              this.setState({
                loading: false
              })
              return
            }
            this.props.finished()
          })
        })
      }
    })
  }

  /*
  Change the manual charge setting of this shop.
  */
  manuallyCharge(chargeType) {
    if (chargeType === 0) {
      //switch to region charged
      this.props.showConfirmation("Change to Region Charged Mode", "This will only bill the shop owner if there are 1,000 users in the shop's region (all billing takes place at 5 minutes passed the hour).", "Set Region Charged Mode", "Cancel", (shouldCharge) => {
        if (shouldCharge) {
          this.setState({
            loading: true
          }, () => {
            API.callDarwinAPI("PUT", "shopManualCharge/" + this.state.shop.shopID, {charge: 0}, (response) => {
              if ("error" in response) {
                this.props.showPopup("Error", "Couldn't set shop mode", response.error)
                this.setState({
                  loading: false
                })
                return
              }
              this.loadShopInfo()
            })
          })
        }
      })
    } else if (chargeType === 1) {
      //switch to manually charged
      this.props.showConfirmation("Change to Manually Charged Mode", "Are you sure you want to manually charge this shop. This will bill the shop owner (all billing takes place at 5 minutes passed the hour).", "Set Manually Charged Mode", "Cancel", (shouldCharge) => {
        if (shouldCharge) {
          this.setState({
            loading: true
          }, () => {
            API.callDarwinAPI("PUT", "shopManualCharge/" + this.state.shop.shopID, {charge: 1}, (response) => {
              if ("error" in response) {
                this.props.showPopup("Error", "Couldn't set shop mode", response.error)
                this.setState({
                  loading: false
                })
                return
              }
              this.loadShopInfo()
            })
          })
        }
      })
    } else if (chargeType === 2) {
      //switch to free of charge
      this.props.showConfirmation("Change to Free of Charge Mode", "This will switch the shop to free of charge mode. The shop owner won't be charged no matter if the region is active.", "Set Free of Charge", "Cancel", (shouldStopCharge) => {
        if (shouldStopCharge) {
          this.setState({
            loading: true
          }, () => {
            API.callDarwinAPI("PUT", "shopManualCharge/" + this.state.shop.shopID, {charge: 2}, (response) => {
              if ("error" in response) {
                this.props.showPopup("Error", "Couldn't set shop mode", response.error)
                this.setState({
                  loading: false
                })
                return
              }
              this.loadShopInfo()
            })
          })
        }
      })
    }
  }

  render() {

    /*let showRealRegionCount = true
    if (Object.keys(this.state.region).length > 0) {
      if ((this.state.region.regionUserCount < 0.25 * this.state.region.regionUsersRequired) || (this.state.region.regionActive === "1" && this.state.region.regionUserCount < this.state.region.regionUsersRequired)) {
        showRealRegionCount = false
      }
    }*/
    let regionUserCount = parseInt(this.state.region.regionUserCount)
    let regionPremiumCount = parseInt(this.state.region.regionPremiumUserCount)
    //let regionUsersRequired = parseInt(this.state.region.regionUsersRequired)

    let showWalkthrough = this.state.promotions.length === 0 && !this.state.shop.deactivationDate

    return (
      <div className="ShopPage">
        <div className="ShopPageContent">
          { this.state.loading &&
            <Components.LoadingIndicator top="100px" />
          }
          { !this.state.loading && Object.keys(this.state.shop).length > 0 &&
            <span>
              <div className="ShopPageTop">
                <div className="ShopPageTopLeft">
                  <div className="ShopPageTitle">
                    {this.state.shop.shopName}
                    <span className="ShopCategory" style={{color:Helpers.getCategoryColor(this.state.shop.shopCategory)}}>
                      {this.state.shop.shopCategory}
                    </span>
                  </div>
                  <div className="ShopPageDescription">
                    {this.state.shop.shopAddress}
                  </div>
                  { this.state.shop.deactivationDate &&
                    <div className="ShopPageDeactivationDate">
                      { !Helpers.dateInPast(this.state.shop.deactivationDate) &&
                        <span>
                          Shop will deactivate on&nbsp;
                        </span>
                      }
                      { Helpers.dateInPast(this.state.shop.deactivationDate) &&
                        <span>
                          Shop was deactivated on&nbsp;
                        </span>
                      }
                      <span className="ShopPageDeactivationDateDate">
                        { Helpers.formatDate(this.state.shop.deactivationDate) }
                      </span>
                    </div>
                  }
                </div>
                <div className="ShopPageTopRight">
                  <div className="ShopPageRegionCircle">
                    <div className="StatisticHelp">
                      <Components.DualImage image={ImageHelpIcon} />
                      <div className="StatisticHelpPopup">
                        <div className="StatisticHelpPopupTitle">
                          HallPass Users
                        </div>
                        <div className="StatisticHelpPopupDescription">
                          There are {Helpers.formatNumber(regionPremiumCount)} premium
                          users and {Helpers.formatNumber(regionUserCount)} total users in the surrounding geographic area.
                        </div>
                      </div>
                    </div>
                    <CircularProgressbarWithChildren strokeWidth={16}
                      value={regionPremiumCount} maxValue={Math.max(regionUserCount, 1)}
                      className={""}>
                      <div className="ShopPageRegionCircleInside">
                        <div>{Helpers.formatNumber(regionPremiumCount)}</div>
                        <div className="ShopPageRegionCircleInsideBar"></div>
                        <div>{Helpers.formatNumber(Math.max(regionUserCount, 1))}</div>
                        <div className="ShopPageRegionCircleInsideBottom">Users</div>
                      </div>
                    </CircularProgressbarWithChildren>
                  </div>
                  <div className="ShopPageRegionLocation">
                    <Textfit mode="multi" max={14}>{this.state.region.regionName ? this.state.region.regionName.replace(/,/g, "") : "Unknown"}</Textfit>
                  </div>
                </div>
              </div>
              { this.state.expandedStat &&
                <span>
                  <div className="ShopPageTitle" style={{marginTop:"68px"}}>
                    Shop Statistics
                  </div>
                  <Components.StatisticsGraph close={this.expandStat} loadData={this.loadStatisticsInformation} />
                </span>
              }
              { !this.state.expandedStat &&
                <span>
                  { showWalkthrough &&
                    <span>
                      <div className="WalkthroughTitle">
                        Welcome to Your New Shop
                      </div>
                      <div className="WalkthroughImage">
                        <Components.DualImage image={ImageAdminBusiness} style={{width:"100px"}} />
                      </div>
                      <div className="WalkthroughDescription">
                        Now that your shop is setup, let's create your first promotion!
                        <br/>
                        Go ahead and click the 'Create Promotion' button below to get started.
                      </div>
                    </span>
                  }
                  { !showWalkthrough &&
                    <span>
                      <div className="ShopPageTitle" style={{marginTop:"68px"}}>
                        Weekly Statistics
                      </div>
                      <div className="ShopPageStatsContainer">
                        <Components.Statistic value={this.state.stats.views} type="Views" duration="Last 7 Days" expand={this.expandStat} />
                        <Components.Statistic value={this.state.stats.taps} type="Taps" duration="Last 7 Days" expand={this.expandStat} />
                        {/*<Components.Statistic value={this.state.stats.favorites} type="Favorites" duration="Last 7 Days" expand={this.expandStat} />*/}
                        <Components.Statistic value={this.state.stats.intended} type="Intended" duration="Last 7 Days" expand={this.expandStat} />
                        <Components.Statistic value={this.state.stats.uses} type="Uses" duration="Last 7 Days" expand={this.expandStat} />
                      </div>
                      <div className="ShopPageTitle" style={{marginTop:"20px"}}>
                        Promotions
                      </div>
                      <div className="ShopPagePromotionsContainer">
                        { this.state.promotions.map((promo, i) => (
                          <span key={"promo_" + i}>
                            <div className={"PromoDiv " + (promo.promoActivated === "1" ? "PromoDivActivated " : "") +
                              (promo.promoReviewStatus === "2" ? "PromoDivFailedReview " : "") +
                              (promo.promoReviewStatus === "1" ? "PromoDivUnderReview " : "")
                              } onClick={this.promotionSelected.bind(this, promo)}>
                              <img src={promo.promoImageURL} className="PromoDivImage" alt={promo.promoTitle} />
                              <div className="PromoDivTitle">
                                { promo.promoTitle.length >= 38 &&
                                  <Textfit mode="multi" max={12} min={12}>{promo.promoTitle}</Textfit>
                                }
                                { promo.promoTitle.length < 38 &&
                                  <Textfit mode="single" max={18} min={12}>{promo.promoTitle}</Textfit>
                                }
                              </div>
                              <div className="PromoDivDescription">
                                {promo.promoShortDescription}
                              </div>
                            </div>
                            { promo.promoActivated === "1" && (i === this.state.promotions.length - 1 || (i !== this.state.promotions.length - 1 && this.state.promotions[i + 1].promoActivated !== "1")) &&
                              <div className="PromoDivBar">
                              </div>
                            }
                          </span>
                        ))}
                      </div>
                    </span>
                  }
                </span>
              }
            </span>
          }
          { !this.state.loading && Object.keys(this.state.shop).length === 0 &&
            <span>
              There was an issue loading the shop. Go back home and try again.
            </span>
          }
        </div>
        <div className="ShopPageBottom">
          { !this.state.loading &&
            <span>
              { !Helpers.dateInPast(this.state.shop.deactivationDate) &&
                <span>
                  <Components.MaterialButton type="Green" onClick={this.props.editShop}>Edit Shop</Components.MaterialButton>
                  <Components.MaterialButton type="Purple" className={showWalkthrough ? "AnimationFloatBounce" : ""} onClick={this.props.createPromotion}>Create Promotion</Components.MaterialButton>
                </span>
              }
              { this.state.shop.deactivationDate &&
                <Components.MaterialButton type="TextPurpleShadow" onClick={this.changeActivation.bind(this, -2)}>Reactivate Shop</Components.MaterialButton>
              }
              { !this.state.shop.deactivationDate &&
                <span>
                  <Components.MaterialButton type="TextRedShadow" onClick={this.changeActivation.bind(this, 30)}>Deactivate Shop</Components.MaterialButton>
                </span>
              }
              { this.props.adminInfo.accountType === "Admin" &&
                <span>
                  { !this.state.shop.deactivationDate &&
                    <Components.MaterialButton type="TextRedShadow" onClick={this.changeActivation.bind(this, 0)}>Deactivate Immediately</Components.MaterialButton>
                  }
                  <Components.MaterialButton type="Red" onClick={this.deleteShopForGood}>Delete Shop</Components.MaterialButton>
                  <Components.MaterialButton type="TextDarkShadow" onClick={this.props.changeShopOwner}>Change Shop Owner</Components.MaterialButton>
                  <Components.MaterialButton type="TextDarkShadow" onClick={this.props.changeShopRegion}>Change Shop Region</Components.MaterialButton>
                  { this.state.shop.shopManualCharge === "0" &&
                    <Components.MaterialButton type="LightPurple" onClick={this.manuallyCharge.bind(this, 1)}>Region Charged</Components.MaterialButton>
                  }
                  { this.state.shop.shopManualCharge === "1" &&
                    <Components.MaterialButton type="LightGreen" onClick={this.manuallyCharge.bind(this, 2)}>Manually Charged</Components.MaterialButton>
                  }
                  { this.state.shop.shopManualCharge === "2" &&
                    <Components.MaterialButton type="LightRed" onClick={this.manuallyCharge.bind(this, 0)}>Free of Charge</Components.MaterialButton>
                  }
                </span>
              }
            </span>
          }
        </div>
      </div>
    )
  }
}

export class Promotion extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      stats: {},
      promotion: {},

      expandedStat: false
    }

    this.loadPromotionInfo = this.loadPromotionInfo.bind(this)
    this.expandStat = this.expandStat.bind(this)
    this.loadStatisticsInformation = this.loadStatisticsInformation.bind(this)
    this.changeActivation = this.changeActivation.bind(this)
    this.promptEditPromotion = this.promptEditPromotion.bind(this)
  }

  componentDidMount() {
    //Load the promotion page data
    this.loadPromotionInfo()
  }

  loadPromotionInfo() {
    this.setState({
      loading: true,
      promotion: {},
      stats: {},
    }, () => {
      API.callDarwinAPI("GET", "promotion/" + this.props.promotion.promoID, {}, (result) => {
        console.log("promotion", result)
        if ("error" in result) {
          this.props.showPopup("Error", "Couldn't retreive the promotion information", result.error)
          this.setState({
            loading: false,
          })
          return
        }
        this.setState({
          loading: false,
          promotion: result.data.promotion,
          stats: result.data.stats,
        })
        this.props.updatePromotionState(result.data.promotion)
      })
    })
  }

  /*
  Expands or closes the stat
  */
  expandStat() {
    if (this.state.expandedStat) {
      this.setState({
        expandedStat: false
      })
    } else {
      this.setState({
        expandedStat: true
      })
    }
  }

  /*
  Loads the statistic information based on the range provided
  and returns the data. This is called by StatisticsGraph
  */
  loadStatisticsInformation(callback, days = 7) {
    API.callDarwinAPI("GET", "promotionStats/" + this.props.promotion.promoID, {
      days: days
    }, (response) => {
      if ("error" in response) {
        this.props.showPopup("Error", "Couldn't retreive the promotion statistics", response.error)
        return
      }
      callback(response.data)
    })
    return
  }

  /*
  Changes the activation state of this promotion.
  Pass in a 0 or 1 for active.
  */
  changeActivation(active) {
    this.setState({
      loading: true,
    }, () => {
      API.callDarwinAPI("PUT", "promotionStatus/" + this.props.promotion.promoID, {
        active: active
      }, (result) => {
        //console.log("promotionStatus/" + this.props.promotion.promoID, result)
        if ("error" in result) {
          this.props.showPopup("Error", "Couldn't change the activation state", result.error)
          this.setState({
            loading: false,
          })
          return
        }
        this.loadPromotionInfo()
      })
    })
  }

  /*
  Asks to make sure you want to edit the promotion and not create another promotion.
  */
  promptEditPromotion() {
    if (this.state.promotion.promoReviewStatus === "0") {
      this.props.showConfirmation("If you want to change the deal you are offering make a new promotion. If you just want to change some text or update the image, then edit this promotion.",
        "Editing a promotion to be a completely different deal will make it difficult to accurately track stats, and people will get upset when a deal they have saved for later suddenly changes. It's best to make a new promotion unless you are updating meta data.",
        "Edit Promotion", "Cancel", (shouldEdit) => {
          if (shouldEdit) {
            this.props.editPromotion()
          }
        }
      )
    } else {
      this.props.editPromotion()
    }
  }

  /*
  Changes if this promotion is a Hall Pass Plus deal or not.
  Pass in a 0 or 1 for newValue
  */
  changeHallPassPlus(newValue) {
    this.setState({
      loading: true,
    }, () => {
      API.callDarwinAPI("PUT", "promotionHPP/" + this.props.promotion.promoID, {
        hallPassPlus: newValue
      }, (result) => {
        //console.log("promotionHPP/" + this.props.promotion.promoID, result)
        if ("error" in result) {
          this.props.showPopup("Error", "Couldn't change the HallPass + state", result.error)
          this.setState({
            loading: false,
          })
          return
        }
        this.loadPromotionInfo()
      })
    })
  }

  render() {
    return (
      <div className="PromotionPage">
        <div className="PromotionPageContent">
          { this.state.loading &&
            <Components.LoadingIndicator top="100px" />
          }
          { !this.state.loading && Object.keys(this.state.promotion).length > 0 &&
            <span>
              <div className="PromotionPageTopBar">
                <img src={ImageBackButton} alt="Back" onClick={this.props.finished} />
                <div className="PromotionPageTopBarContent">
                  <div className="PromotionPageTitle">
                    {this.props.shop.shopName}
                    <span className="PromotionCategory" style={{color:Helpers.getCategoryColor(this.props.shop.shopCategory)}}>
                      {this.props.shop.shopCategory}
                    </span>
                  </div>
                  <div className="PromotionPageDescription">
                    {this.props.shop.shopAddress}
                  </div>
                </div>
              </div>
              { this.state.promotion.promoReviewStatus === "1" &&
                <div className="PromotionPageActivatedBar">
                  <div className="PromotionPageImageContainer">
                    <Components.DualImage image={ImageHelpIcon} />
                    <div className="PromotionPageHelpPopup">
                      <div className="PromotionPageHelpPopupTitle">
                        Under Review
                      </div>
                      <div className="PromotionPageHelpPopupDescription">
                        Your promotion is under review for content. Once it passes or fails review you will be notified about next steps.
                      </div>
                    </div>
                  </div>
                  <div className="PromotionPageActivatedBarUnderReview">
                    Under Review
                  </div>
                </div>
              }
              { this.state.promotion.promoReviewStatus === "2" &&
                <div className="PromotionPageActivatedBar">
                  <div className="PromotionPageImageContainer">
                    <Components.DualImage image={ImageHelpIcon} />
                    <div className="PromotionPageHelpPopup">
                      <div className="PromotionPageHelpPopupTitle">
                        Failed Review
                      </div>
                      <div className="PromotionPageHelpPopupDescription">
                        Your promotion has failed review, you need to fix the issues listed below before this promotion will be shown to users.
                      </div>
                    </div>
                  </div>
                  <div className="PromotionPageActivatedBarFailedReview">
                    Failed Review
                  </div>
                </div>
              }
              { this.state.promotion.promoReviewStatus === "0" && this.state.promotion.promoActivated === "1" &&
                <div className="PromotionPageActivatedBar">
                  <div className="PromotionPageActivatedBarActive">
                    Active
                  </div>
                  <Components.MaterialButton type="TextRedShadow" onClick={this.changeActivation.bind(this, 0)}>Deactivate Promotion</Components.MaterialButton>
                </div>
              }
              { this.state.promotion.promoReviewStatus === "0" && this.state.promotion.promoActivated !== "1" &&
                <div className="PromotionPageActivatedBar">
                  <div className="PromotionPageActivatedBarInactive">
                    Inactive
                  </div>
                  <Components.MaterialButton type="Purple" onClick={this.changeActivation.bind(this, 1)}>Activate Promotion</Components.MaterialButton>
                </div>
              }
              { this.state.expandedStat &&
                <span>
                  <div className="PromotionPageTitle" style={{marginTop:"68px"}}>
                    Promotion Statistics
                  </div>
                  <Components.StatisticsGraph close={this.expandStat} loadData={this.loadStatisticsInformation} />
                </span>
              }
              { !this.state.expandedStat &&
                <div className="PromotionPageContentFlex">
                  { this.state.promotion.promoReviewStatus === "2" &&
                    <div className="PromotionPageReviewFailed">
                      <div className="PromotionPageReviewFailedTitle">
                        Review Failed
                      </div>
                      <div className="PromotionpageReviewFailedDescription">
                        This promotion has failed review. You need to edit the promotion and make the required changes to its content before it will become visible to users.
                      </div>
                      <div className="PromotionpageReviewFailedValue">
                        { this.state.promotion.promoReviewText ? this.state.promotion.promoReviewText :
                          "There is an issue with your promotion. It violates the terms of service. Please remove any graphic content and profanity. Also, provide a deal that is relevant to your business. If you have any questions contact your support manager. Your support manager can be found by clicking on the Account button at the top of the screen and navigating to support."
                        }
                      </div>
                    </div>
                  }
                  <div className="PromotionPageDetails">
                    <div className="PromotionPageDetailsTitle">
                      Promotion Details
                    </div>
                    <div className="PromotionPreviewBlock">
                      <Components.PromotionPreview shop={this.props.shop} promotion={this.state.promotion} shrink={false} />
                    </div>
                  </div>
                  {/* If we are not under review, or we are under review and active, then show the statistics */}
                  { (this.state.promotion.promoReviewStatus === "0" || (this.state.promotion.promoReviewStatus === "1" && this.state.promotion.promoActivated === "1")) &&
                    <div className="PromotionPageWeeklyStatistics">
                      <div className="PromotionPageWeeklyStatisticsTitle">
                        Weekly Statistics
                      </div>
                      <div className="PromotionPageStatsContainer">
                        <Components.Statistic value={this.state.stats.views} type="Views" duration="Last 7 Days" expand={this.expandStat} />
                        <Components.Statistic value={this.state.stats.taps} type="Taps" duration="Last 7 Days" expand={this.expandStat} />
                        {/*<Components.Statistic value={this.state.stats.favorites} type="Favorites" duration="Last 7 Days" expand={this.expandStat} />*/}
                        <Components.Statistic value={this.state.stats.intended} type="Intended" duration="Last 7 Days" expand={this.expandStat} />
                        <Components.Statistic value={this.state.stats.uses} type="Uses" duration="Last 7 Days" expand={this.expandStat} />
                      </div>
                    </div>
                  }
                </div>
              }
            </span>
          }
          { !this.state.loading && Object.keys(this.state.promotion).length === 0 &&
            <span>
              There was an issue loading the promotion. Go back home and try again.
            </span>
          }
        </div>
        <div className="PromotionPageBottom">
          { !this.state.loading &&
            <span>
              { !Helpers.dateInPast(this.props.shop.deactivationDate) &&
                <Components.MaterialButton type="Green" onClick={this.promptEditPromotion}>Edit Promotion</Components.MaterialButton>
              }
              { (this.props.adminInfo.accountType === "Admin" || this.props.adminInfo.accountType === "Associate") &&
                <span>
                  { this.state.promotion.promoHallPassPlus === "0" &&
                    <Components.MaterialButton type="LightGreen" onClick={this.changeHallPassPlus.bind(this, 1)}>Basic Promo</Components.MaterialButton>
                  }
                  { this.state.promotion.promoHallPassPlus === "1" &&
                    <Components.MaterialButton type="LightPurple" onClick={this.changeHallPassPlus.bind(this, 0)}>HP+ Promo</Components.MaterialButton>
                  }
                </span>
              }
            </span>
          }
        </div>
      </div>
    )
  }
}

export class ShopSetOwner extends React.Component {

  constructor(props) {
    super(props)

    let data = {}
    this.state = {
      data: data,
      forceCheck: false,
      error: undefined,
      shakeButton: false,
      ownerOptions: [],
      loading: false
    }

    this.loadOwners = this.loadOwners.bind(this)
    this.submitForm = this.submitForm.bind(this)
    this.formChanged = this.formChanged.bind(this)
    this.shakeTheButton = this.shakeTheButton.bind(this)
    this.switchOwner = this.switchOwner.bind(this)
  }

  componentDidMount() {
    this.loadOwners()
  }

  /*
  Loads the list of owners that you can pick from.
  */
  loadOwners() {
    API.callDarwinAPI("GET", "owners", {}, (result) => {
      //console.log("GET /owners", result)
      if ("error" in result) {
        this.props.showPopup("Error", "Couldn't retreive the list of owners", result.error)
        return
      }
      let data = result.data
      data.unshift({
        value: "None",
        label: "No Owner"
      })
      data.unshift({
        value: "",
        label: "Select an owner"
      })
      this.setState({
        ownerOptions: data
      })
    })
  }

  /*
  * Submits the form
  */
  submitForm() {
    //1) Make sure every data element is valid.
    let valid = true
    for (let key in this.state.data) {
      if (this.state.data[key].valid === false) {
        valid = false
      }
    }
    //2) Make sure we have all of the data.
    let requiredFields = ["owner"]
    requiredFields.forEach((element) => {
      if (this.state.data[element] === undefined || this.state.data[element].value === undefined) {
        valid = false
      }
    })
    //3) If valid, submit, else force check the fields for display.
    if (valid) {
      let data = {}
      for (let key in this.state.data) {
        data[key] = this.state.data[key].value
      }
      //Submit the form
      this.switchOwner(data)
    } else {
      console.log("Form not valid to submit")
      this.setState({
        forceCheck: true
      })
      //Shake the submit button as it is invalid to submit
      this.shakeTheButton()
      return
    }
  }

  /*
  * Called when data in an input form changes.
  * This will update the state.data param with the
  * name and new value of the form element.
  */
  formChanged(name, value, valid) {
    this.setState((prevState) => {
      let d = prevState.data
      d[name] = {
        value: value,
        valid: valid
      }
      return {
        data: d
      }
    })
  }

  /*
  Shakes the button and then removes the class.
  */
  shakeTheButton() {
    this.setState({
      shakeButton: true
    }, () => {
      setTimeout(() => {
        this.setState({
          shakeButton: false
        })
      }, 1000)
    })
  }

  /*
  Switches the owner for this shop, then exits this form.
  */
  switchOwner(data) {
    this.setState({
      loading: true
    }, () => {
      API.callDarwinAPI("PUT", "shopOwner", {
        shopID: this.props.shop.shopID,
        ownerID: data.owner
      }, (result) => {
        //console.log("PUT shopOwner", result)
        if ("error" in result) {
          this.props.showPopup("Error", "Couldn't update the shop owner", result.error)
          this.setState({
            loading: false
          })
          return
        }
        this.props.finished()
      })
    })
  }

  render() {
    return (
      <div className="ShopSetOwner">
        { this.state.loading &&
          <Components.LoadingIndicator top="100px" />
        }
        { !this.state.loading &&
          <span>
            {/* Title and information */}
            <div className="ShopSetOwnerTitle">
              Set the Shop Owner
            </div>
            { !this.props.shop.portalUserID &&
              <div className="ShopSetOwnerDescription">
                This shop has no owner. Pick an owner for this shop
                <br/>
                <span className="ShopSetOwnerDescriptionBold">
                  {this.props.shop.shopName}
                </span>
              </div>
            }
            { this.props.shop.portalUserID &&
              <div className="ShopSetOwnerDescription">
                Select the new owner for this shop
                <br/>
                <span className="ShopSetOwnerDescriptionBold">
                  {this.props.shop.shopName}
                </span>
              </div>
            }
            {/* Form */}
            <div className="InputDiv">
              <Components.InputBottomLine type="selection" options={this.state.ownerOptions} name="owner" placeholder="owner" validation="text" required="true"
                title="shop owner" description="pick the new shop owner for this shop"
                value={this.state.data.owner ? this.state.data.owner.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
            </div>
            <div className="ButtonDiv">
              <Components.MaterialButton type="Purple" size="Large" onClick={this.submitForm} shake={this.state.shakeButton}>Change Owner</Components.MaterialButton>
            </div>
          </span>
        }
      </div>
    )
  }
}

export class ShopSetRegion extends React.Component {

  constructor(props) {
    super(props)

    let data = {}
    this.state = {
      data: data,
      forceCheck: false,
      error: undefined,
      shakeButton: false,
      loading: false,
      regions: [], //for displaying on the map.
      regionOptions: [], //for selecting.

      currentLatitude: this.props.shop.shopLatitude,
      currentLongitude: this.props.shop.shopLongitude,
    }

    this.loadRegions = this.loadRegions.bind(this)
    this.submitForm = this.submitForm.bind(this)
    this.formChanged = this.formChanged.bind(this)
    this.shakeTheButton = this.shakeTheButton.bind(this)
    this.switchRegion = this.switchRegion.bind(this)
    this.mapRegionSelected = this.mapRegionSelected.bind(this)
  }

  componentDidMount() {
    this.loadRegions()
  }

  /*
  Loads the list of owners that you can pick from.
  */
  loadRegions() {
    API.callDarwinAPI("GET", "regions", {
      showNotificationOnlyRegions: 0
    }, (result) => {
      //console.log("GET /regions", result)
      if ("error" in result) {
        this.props.showPopup("Error", "Couldn't retreive the list of owners", result.error)
        return
      }
      let data = result.data.regionOptions
      //add the select a region control to the selection list.
      data.unshift({
        value: "",
        label: "Select a region"
      })
      //sort the map regions by radius for clickability
      let mapRegions = result.data.regions
      mapRegions.sort(function(a, b) {
        if (parseFloat(a.regionRadius) < parseFloat(b.regionRadius)) {
          return 1
        } else if (parseFloat(a.regionRadius) > parseFloat(b.regionRadius)) {
          return -1
        } else {
          return 0
        }
      })
      this.setState({
        mapRegionOptions: mapRegions,
        regionOptions: data,
        regions: mapRegions
      }, () => {
        //try to find the region and make that the selection
        for (let i = 0; i < this.state.regionOptions.length; i = i + 1) {
          if (this.state.regionOptions[i].value === this.props.shop.shopRegionID) {
            this.formChanged("region", this.state.regionOptions[i].value, true)
            break
          }
        }
      })
    })
  }

  /*
  * Submits the form
  */
  submitForm() {
    //1) Make sure every data element is valid.
    let valid = true
    for (let key in this.state.data) {
      if (this.state.data[key].valid === false) {
        valid = false
      }
    }
    //2) Make sure we have all of the data.
    let requiredFields = ["region"]
    requiredFields.forEach((element) => {
      if (this.state.data[element] === undefined || this.state.data[element].value === undefined) {
        valid = false
      }
    })
    //3) If valid, submit, else force check the fields for display.
    if (valid) {
      let data = {}
      for (let key in this.state.data) {
        data[key] = this.state.data[key].value
      }
      //Submit the form
      this.switchRegion(data)
    } else {
      console.log("Form not valid to submit")
      this.setState({
        forceCheck: true
      })
      //Shake the submit button as it is invalid to submit
      this.shakeTheButton()
      return
    }
  }

  /*
  * Called when data in an input form changes.
  * This will update the state.data param with the
  * name and new value of the form element.
  */
  formChanged(name, value, valid) {
    console.log("formChanged", name, value, valid)
    this.setState((prevState) => {
      let newState = {}
      let d = prevState.data
      d[name] = {
        value: value,
        valid: valid
      }
      if (name === "region") {
        //update which region was selected
        let regs = prevState.regions
        for (let i = 0; i < regs.length; i = i + 1) {
          if (regs[i].regionID === value) {
            regs[i].selected = true
            newState.currentLatitude = regs[i].latitude
            newState.currentLongitude = regs[i].longitude
          } else {
            regs[i].selected = false
          }
        }
        d.regions = regs
      }
      newState.data = d
      return newState
    })
  }

  /*
  A map region was selected so we will select that.
  */
  mapRegionSelected(region) {
    console.log("mapRegionSelected", region)
    if (region.pixel !== undefined) {
      //nothing was selected on the map so revert the selection to nothing.
      this.formChanged("region", "", false)
      return
    }
    this.formChanged("region", region.regionID, true)
  }

  /*
  Shakes the button and then removes the class.
  */
  shakeTheButton() {
    this.setState({
      shakeButton: true
    }, () => {
      setTimeout(() => {
        this.setState({
          shakeButton: false
        })
      }, 1000)
    })
  }

  /*
  Switches the region for this shop, then exits this form.
  */
  switchRegion(data) {
    this.setState({
      loading: true
    }, () => {
      API.callDarwinAPI("PUT", "shopsRegion", {
        shopID: this.props.shop.shopID,
        regionID: data.region
      }, (result) => {
        //console.log("PUT shopOwner", result)
        if ("error" in result) {
          this.props.showPopup("Error", "Couldn't update the shop region", result.error)
          this.setState({
            loading: false
          })
          return
        }
        this.props.finished()
      })
    })
  }

  render() {
    let selectedRegion = false
    for (let i = 0; i < this.state.regions.length; i = i + 1) {
      if (this.state.regions[i].selected) {
        selectedRegion = this.state.regions[i]
        break
      }
    }
    let shop = this.props.shop
    shop.selected = true
    return (
      <div className="ShopSetRegion">
        { this.state.loading &&
          <Components.LoadingIndicator top="100px" />
        }
        { !this.state.loading &&
          <span>
            {/* Title and information */}
            <div className="ShopSetRegionTitle">
              Set the Shop Region
            </div>
            { !this.props.shop.shopRegionID &&
              <div className="ShopSetRegionDescription">
                Set the region for this shop
                <br/>
                <span className="ShopSetRegionDescriptionBold">
                  {this.props.shop.shopName}
                </span>
              </div>
            }
            { this.props.shop.shopRegionID &&
              <div className="ShopSetRegionDescription">
                Select the new region for this shop
                <br/>
                <span className="ShopSetRegionDescriptionBold">
                  {this.props.shop.shopName}
                </span>
              </div>
            }
            {/* Map */}
            <div className="ShopSetRegionMap">
              <Components.GoogleMapViewRegions
                onClick={this.mapRegionSelected}
                latitude={this.state.currentLatitude} longitude={this.state.currentLongitude}
                regions={this.state.regions}
                emptyShops={[shop]}
                emptyShopOnClick={() => {}}
                />
            </div>
            {/* Form */}
            <div className="InputDiv">
              <Components.InputBottomLine type="selection" options={this.state.regionOptions} name="region" placeholder="region" validation="text" required="true"
                title="region" description="The region that will determine if this shop is free or paying"
                value={this.state.data.region ? this.state.data.region.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
            </div>
            { selectedRegion !== false &&
              <Components.RegionDiv region={selectedRegion} />
            }
            <div className="ButtonDiv">
              <Components.MaterialButton type="Green" size="Large" onClick={this.submitForm} shake={this.state.shakeButton}>Change Region</Components.MaterialButton>
            </div>
            <div className="ButtonDiv">
              <div className="ShopSetRegionCreateDescription">
                Do none of these regions work? Create a new region here.
              </div>
              <Components.MaterialButton type="Purple" size="Large" onClick={this.props.createNewRegion} shake={this.state.shakeButton}>Create New Region</Components.MaterialButton>
            </div>
          </span>
        }
      </div>
    )
  }
}

export class CreateShop extends React.Component {

  constructor(props) {
    super(props)

    let data = {}
    data.notificationRadius = {
      valid: true,
      value: "0.0568182"
    }
    this.state = {
      loading: false,
      data: data,
      forceCheck: false,
      error: undefined,
      shakeButton: false,
    }

    this.submitForm = this.submitForm.bind(this)
    this.formChanged = this.formChanged.bind(this)
    this.shakeTheButton = this.shakeTheButton.bind(this)

    this.createShop = this.createShop.bind(this)
  }

  /*
  * Submits the form
  */
  submitForm() {
    //1) Make sure every data element is valid.
    let valid = true
    for (let key in this.state.data) {
      if (this.state.data[key].valid === false) {
        valid = false
      }
    }
    //2) Make sure we have all of the data.
    let requiredFields = ["name", "description", "category", "logoImage", "shopHours", "shopHoursText", "address"]
    requiredFields.forEach((element) => {
      if (this.state.data[element] === undefined || this.state.data[element].value === undefined) {
        console.log("invalid", element, this.state.data[element])
        valid = false
      }
    })
    //3) If valid, submit, else force check the fields for display.
    if (valid) {
      let data = {}
      for (let key in this.state.data) {
        data[key] = this.state.data[key].value
      }
      //Submit the form
      this.createShop(data)
    } else {
      console.log("Form not valid to submit")
      this.setState({
        forceCheck: true
      })
      //Shake the submit button as it is invalid to submit
      this.shakeTheButton()
      return
    }
  }

  /*
  * Called when data in an input form changes.
  * This will update the state.data param with the
  * name and new value of the form element.
  */
  formChanged(name, value, valid) {
    this.setState((prevState) => {
      let d = prevState.data
      d[name] = {
        value: value,
        valid: valid
      }
      return {
        data: d
      }
    })
  }

  /*
  Shakes the button and then removes the class.
  */
  shakeTheButton() {
    this.setState({
      shakeButton: true
    }, () => {
      setTimeout(() => {
        this.setState({
          shakeButton: false
        })
      }, 1000)
    })
  }

  /*
  Goes to the create shop page.
  */
  createShop(data) {
    //Ask for confirmation first
    this.props.showConfirmation("Create Shop", "Once you create this shop, you'll then need to create a promotion for this shop.", "Create Shop", "Cancel", (create) => {
      if (create) {
        this.setState({
          loading: true
        }, () => {
          API.callDarwinAPI("POST", "shop", data, (result) => {
            if ("error" in result) {
              this.props.showPopup("Error", "Couldn't create the shop", result.error)
              this.setState({
                loading: false
              })
              return
            }
            //We have created the shop, go back home.
            this.props.finished()
          })
        })
      }
    })
  }

  render() {
    let categoryOptions = [
      {value: "", label: "Select an Option"},
      {value: "Food", label: "Food"},
      {value: "Night Life", label: "Night Life"},
      {value: "Entertainment", label: "Entertainment"},
      {value: "Services", label: "Services"},
      {value: "Fitness", label: "Fitness"},
      {value: "Retail", label: "Retail"},
    ]

    let notificationRadii = [
      {value: "0.0568182", label: "300 feet"},
      {value: "0.0189394", label: "100 feet"},
      {value: "0.0378788", label: "200 feet"},
      {value: "0.0757576", label: "400 feet"},
      {value: "0.094697", label: "500 feet"},
      {value: "0.113636", label: "600 feet"},
      {value: "0.189394", label: "1000 feet"},
    ]

    return (
      <div className="CreateShop">
        { this.state.loading &&
          <div className="StripeCheckoutLoading">
            <div>
              <Components.LoadingIndicator top="60px" />
            </div>
          </div>
        }
        <div className="CreateShopTitle">
          Create Shop
        </div>
        <div className="CreateShopDescription">
          A shop is a physical location. First you create a shop, then you create a promotion for that shop.
        </div>
        {/* Now show the form */}
        <div className="StripeCheckout">
          <div className={"StripeCheckoutContainer"}>

            <div className="StripeCheckoutInsideContainer" style={{marginBottom:"20px"}}>
              <div className="InputSection">
                Basic
              </div>
              {/* Name */}
              <div className="InputDiv">
                <Components.InputBottomLine type="text" name="name" placeholder="Jimmy Johns" validation="text" required="true" maximum={255}
                  title="name" description="The name of the shop"
                  value={this.state.data.name ? this.state.data.name.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
              {/* Short Description */}
              <div className="InputDiv">
                <Components.InputBottomLine type="text" name="description" placeholder="Sandwiches" validation="text" required="true" maximum={255}
                  title="description" description="A short description of the shop. ex. Pizza, Clothing, ..."
                  value={this.state.data.description ? this.state.data.description.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
              {/* Category */}
              <div className="InputDiv">
                <Components.InputBottomLine type="selection" options={categoryOptions} name="category" placeholder="Food" validation="text" required="true"
                  title="category" description="The type of shop"
                  value={this.state.data.category ? this.state.data.category.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
              {/* Logo Image */}
              <div className="InputDiv">
                <Components.InputBottomLine type="file" name="logoImage" placeholder="" validation="file" required="true"
                  title="logo image" description="The logo of the shop. Round images look better"
                  APIName="userFiles" APIUploadName="userFiles" showPopup={this.props.showPopup} maxSize={800}
                  value={this.state.data.logoImage ? this.state.data.logoImage.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
            </div>

            <div className="InputSectionLine"></div>
            <div className="StripeCheckoutInsideContainer" style={{marginBottom:"20px"}}>
              <div className="InputSection">
                Contact
              </div>
              {/* Shop Hours */}
              <div className="InputDiv">
                <Components.InputBottomLine type="shopHours" name="shopHours" placeholder="" validation="shopHours" required="true"
                  title="shop hours" description="The hours the shop is open"
                  value={this.state.data.shopHours ? this.state.data.shopHours.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
              {/* Shop Address */}
              <div className="InputDiv">
                <Components.InputBottomLine type="text" name="address" placeholder="1 Infinite Loop, Cupertino CA 95014" validation="text" required="true" maximum={255}
                  title="address" description="ex. 23 Sunset Blvd. Houston, TX 77004"
                  value={this.state.data.address ? this.state.data.address.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
              {/* Phone Number */}
              <div className="InputDiv">
                <Components.InputBottomLine type="text" name="phoneNumber" placeholder="(123) 456 - 7890" validation="phoneNumber10" required="false"
                  title="(phone number)" description="The number to call the shop"
                  value={this.state.data.phoneNumber ? this.state.data.phoneNumber.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
              {/* Website */}
              <div className="InputDiv">
                <Components.InputBottomLine type="text" name="website" placeholder="https://www.pizzahut.com" validation="urlSimple" required="false" maximum={255}
                  title="(website)" description="ex. https://www.mcdonalds.com"
                  value={this.state.data.website ? this.state.data.website.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
            </div>

            <div className="InputSectionLine"></div>
            <div className="StripeCheckoutInsideContainer" style={{marginBottom:"20px"}}>
              <div className="InputSection">
                Additional
              </div>
              {/* Notification Radius */}
              { this.props.adminInfo.accountType === "Admin" &&
                <div className="InputDiv">
                  <Components.InputBottomLine type="selection" options={notificationRadii} name="notificationRadius" placeholder="300 feet" validation="text" required="true" maximum={255}
                    title="(notification radius)" description="If a user passes within x distance of this shop, they will receive a notification about the active promotion"
                    value={this.state.data.notificationRadius ? this.state.data.notificationRadius.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
                </div>
              }
              {/* About */}
              <div className="InputDiv">
                <Components.InputBottomLine type="text" name="about" placeholder="In 1995, James founded ..." validation="text" required="false" maximum={20000}
                  title="(about)" description="A longer description of the shop - tell a story"
                  value={this.state.data.about ? this.state.data.about.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
              {/* Facebook URL */}
              <div className="InputDiv">
                <Components.InputBottomLine type="text" name="facebookURL" placeholder="https://www.facebook.com/myshop" validation="urlSimple" required="false" maximum={255}
                  title="(facebook url)" description="ex. https://www.facebook.com/myshop"
                  value={this.state.data.facebookURL ? this.state.data.facebookURL.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
              {/* Twitter Handle */}
              <div className="InputDiv">
                <Components.InputBottomLine type="text" name="twitterHandle" placeholder="@MyShop" validation="handle" required="false" maximum={255}
                  title="(twitter handle)" description="This handle will link to your Twitter feed"
                  value={this.state.data.twitterHandle ? this.state.data.twitterHandle.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
              {/* Instagram Handle */}
              <div className="InputDiv">
                <Components.InputBottomLine type="text" name="instagramHandle" placeholder="@MyShop" validation="handle" required="false" maximum={255}
                  title="(instagram handle)" description="This handle will link to your Instagram feed"
                  value={this.state.data.instagramHandle ? this.state.data.instagramHandle.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>

              <div className="ButtonDiv">
                <Components.MaterialButton type="Purple" size="Large" onClick={this.submitForm} shake={this.state.shakeButton}>Create Shop</Components.MaterialButton>
              </div>
              <div className="ButtonDiv">
                <Components.MaterialButton type="TextDark" size="Large" onClick={this.props.finished}>Cancel</Components.MaterialButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export class EditShop extends React.Component {

  constructor(props) {
    super(props)

    console.log("EditShop", props)
    let data = {}
    data.notificationRadius = {
      valid: true,
      value: "0.0568182"
    }
    //load in the data from props.
    let mapping = {
      "name": "shopName",
      "description": "shopShortDescription",
      "category": "shopCategory",
      "logoImage": "shopLogoURL",
      "shopHours": "shopHours",
      "shopHoursText": "shopHoursText",
      "address": "shopAddress",
      "phoneNumber": "shopPhoneNumber",
      "website": "shopWebsiteURL",
      "notificationRadius": "shopNotificationRadius",
      "about": "shopAbout",
      "facebookURL": "shopFacebookLink",
      "twitterHandle": "shopTwitterHandle",
      "instagramHandle": "shopInstagramHandle",
    }
    Object.keys(mapping).forEach((key) => {
      let value = this.props.shop[mapping[key]]
      if (value !== undefined && value !== null) {
        data[key] = {
          valid: true,
          value: value
        }
      }
    })

    this.state = {
      loading: false,
      data: data,
      forceCheck: false,
      error: undefined,
      shakeButton: false,
    }

    this.submitForm = this.submitForm.bind(this)
    this.formChanged = this.formChanged.bind(this)
    this.shakeTheButton = this.shakeTheButton.bind(this)

    this.saveShop = this.saveShop.bind(this)
  }

  /*
  * Submits the form
  */
  submitForm() {
    //1) Make sure every data element is valid.
    let valid = true
    for (let key in this.state.data) {
      if (this.state.data[key].valid === false) {
        valid = false
      }
    }
    //2) Make sure we have all of the data.
    let requiredFields = ["name", "description", "category", "logoImage", "shopHours", "shopHoursText", "address"]
    requiredFields.forEach((element) => {
      if (this.state.data[element] === undefined || this.state.data[element].value === undefined) {
        console.log("invalid", element, this.state.data[element])
        valid = false
      }
    })
    //3) If valid, submit, else force check the fields for display.
    if (valid) {
      let data = {}
      for (let key in this.state.data) {
        data[key] = this.state.data[key].value
      }
      //Submit the form
      this.saveShop(data)
    } else {
      console.log("Form not valid to submit")
      this.setState({
        forceCheck: true
      })
      //Shake the submit button as it is invalid to submit
      this.shakeTheButton()
      return
    }
  }

  /*
  * Called when data in an input form changes.
  * This will update the state.data param with the
  * name and new value of the form element.
  */
  formChanged(name, value, valid) {
    this.setState((prevState) => {
      let d = prevState.data
      d[name] = {
        value: value,
        valid: valid
      }
      return {
        data: d
      }
    })
  }

  /*
  Shakes the button and then removes the class.
  */
  shakeTheButton() {
    this.setState({
      shakeButton: true
    }, () => {
      setTimeout(() => {
        this.setState({
          shakeButton: false
        })
      }, 1000)
    })
  }

  /*
  Goes to the create shop page.
  */
  saveShop(data) {
    //Ask for confirmation first
    this.setState({
      loading: true
    }, () => {
      API.callDarwinAPI("PUT", "shop/" + this.props.shop.shopID, data, (result) => {
        console.log("PUT shop/" + this.props.shop.shopID, result)
        if ("error" in result) {
          this.props.showPopup("Error", "Couldn't save the shop", result.error)
          this.setState({
            loading: false
          })
          return
        }
        //We have saved the shop edits, go back home.
        this.props.finished()
      })
    })
  }

  render() {
    let categoryOptions = [
      {value: "", label: "Select an Option"},
      {value: "Food", label: "Food"},
      {value: "Night Life", label: "Night Life"},
      {value: "Entertainment", label: "Entertainment"},
      {value: "Services", label: "Services"},
      {value: "Fitness", label: "Fitness"},
      {value: "Retail", label: "Retail"},
    ]

    let notificationRadii = [
      {value: "0.0568182", label: "300 feet"},
      {value: "0.0189394", label: "100 feet"},
      {value: "0.0378788", label: "200 feet"},
      {value: "0.0757576", label: "400 feet"},
      {value: "0.094697", label: "500 feet"},
      {value: "0.113636", label: "600 feet"},
      {value: "0.189394", label: "1000 feet"},
    ]

    return (
      <div className="CreateShop">
        { this.state.loading &&
          <div className="StripeCheckoutLoading">
            <div>
              <Components.LoadingIndicator top="60px" />
            </div>
          </div>
        }
        <div className="CreateShopTitle">
          Edit Shop
        </div>
        <div className="CreateShopDescription">
          A shop is a physical location. First you create a shop, then you create a promotion for that shop.
        </div>
        {/* Now show the form */}
        <div className="StripeCheckout">
          <div className={"StripeCheckoutContainer"}>

            <div className="StripeCheckoutInsideContainer" style={{marginBottom:"20px"}}>
              <div className="InputSection">
                Basic
              </div>
              {/* Name */}
              <div className="InputDiv">
                <Components.InputBottomLine type="text" name="name" placeholder="Jimmy Johns" validation="text" required="true" maximum={255}
                  title="name" description="The name of the shop"
                  value={this.state.data.name ? this.state.data.name.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
              {/* Short Description */}
              <div className="InputDiv">
                <Components.InputBottomLine type="text" name="description" placeholder="Sandwiches" validation="text" required="true" maximum={255}
                  title="description" description="A short description of the shop. ex. Pizza, Clothing, ..."
                  value={this.state.data.description ? this.state.data.description.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
              {/* Category */}
              <div className="InputDiv">
                <Components.InputBottomLine type="selection" options={categoryOptions} name="category" placeholder="Food" validation="text" required="true"
                  title="category" description="The type of shop"
                  value={this.state.data.category ? this.state.data.category.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
              {/* Logo Image */}
              <div className="InputDiv">
                <Components.InputBottomLine type="file" name="logoImage" placeholder="" validation="file" required="true"
                  title="logo image" description="The logo of the shop. Round images look better"
                  APIName="userFiles" APIUploadName="userFiles" showPopup={this.props.showPopup} maxSize={800}
                  value={this.state.data.logoImage ? this.state.data.logoImage.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
            </div>

            <div className="InputSectionLine"></div>
            <div className="StripeCheckoutInsideContainer" style={{marginBottom:"20px"}}>
              <div className="InputSection">
                Contact
              </div>
              {/* Shop Hours */}
              <div className="InputDiv">
                <Components.InputBottomLine type="shopHours" name="shopHours" placeholder="" validation="shopHours" required="true"
                  title="shop hours" description="The hours the shop is open"
                  value={this.state.data.shopHours ? this.state.data.shopHours.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
              {/* Shop Address */}
              <div className="InputDiv">
                <Components.InputBottomLine type="text" name="address" placeholder="1 Infinite Loop, Cupertino CA 95014" validation="text" required="true" maximum={255}
                  title="address" description="ex. 23 Sunset Blvd. Houston, TX 77004"
                  value={this.state.data.address ? this.state.data.address.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
              {/* Phone Number */}
              <div className="InputDiv">
                <Components.InputBottomLine type="text" name="phoneNumber" placeholder="(123) 456 - 7890" validation="phoneNumber10" required="false"
                  title="(phone number)" description="The number to call the shop"
                  value={this.state.data.phoneNumber ? this.state.data.phoneNumber.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
              {/* Website */}
              <div className="InputDiv">
                <Components.InputBottomLine type="text" name="website" placeholder="https://www.pizzahut.com" validation="urlSimple" required="false" maximum={255}
                  title="(website)" description="ex. https://www.mcdonalds.com"
                  value={this.state.data.website ? this.state.data.website.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
            </div>

            <div className="InputSectionLine"></div>
            <div className="StripeCheckoutInsideContainer" style={{marginBottom:"20px"}}>
              <div className="InputSection">
                Additional
              </div>
              {/* Notification Radius */}
              { this.props.adminInfo.accountType === "Admin" &&
                <div className="InputDiv">
                  <Components.InputBottomLine type="selection" options={notificationRadii} name="notificationRadius" placeholder="300 feet" validation="text" required="true" maximum={255}
                    title="(notification radius)" description="If a user passes within x distance of this shop, they will receive a notification about the active promotion"
                    value={this.state.data.notificationRadius ? this.state.data.notificationRadius.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
                </div>
              }
              {/* About */}
              <div className="InputDiv">
                <Components.InputBottomLine type="text" name="about" placeholder="In 1995, James founded ..." validation="text" required="false" maximum={20000}
                  title="(about)" description="A longer description of the shop - tell a story"
                  value={this.state.data.about ? this.state.data.about.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
              {/* Facebook URL */}
              <div className="InputDiv">
                <Components.InputBottomLine type="text" name="facebookURL" placeholder="https://www.facebook.com/myshop" validation="urlSimple" required="false" maximum={255}
                  title="(facebook url)" description="ex. https://www.facebook.com/myshop"
                  value={this.state.data.facebookURL ? this.state.data.facebookURL.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
              {/* Twitter Handle */}
              <div className="InputDiv">
                <Components.InputBottomLine type="text" name="twitterHandle" placeholder="@MyShop" validation="handle" required="false" maximum={255}
                  title="(twitter handle)" description="This handle will link to your Twitter feed"
                  value={this.state.data.twitterHandle ? this.state.data.twitterHandle.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
              {/* Instagram Handle */}
              <div className="InputDiv">
                <Components.InputBottomLine type="text" name="instagramHandle" placeholder="@MyShop" validation="handle" required="false" maximum={255}
                  title="(instagram handle)" description="This handle will link to your Instagram feed"
                  value={this.state.data.instagramHandle ? this.state.data.instagramHandle.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>

              <div className="ButtonDiv">
                <Components.MaterialButton type="Green" size="Large" onClick={this.submitForm} shake={this.state.shakeButton}>Save Shop</Components.MaterialButton>
              </div>
              <div className="ButtonDiv">
                <Components.MaterialButton type="TextDark" size="Large" onClick={this.props.finished}>Cancel</Components.MaterialButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export class CreatePromotion extends React.Component {

  constructor(props) {
    super(props)

    let data = {}
    data.promoExpirationDate = {
      valid: true,
      value: "3000-01-01" //never expires
    }
    data.promoUseType = {
      valid: true,
      value: "1 Daily" //can use once a day
    }
    data.promoActivationDuration = {
      valid: true,
      value: "11111" //Lasts all day until 1AM Pacific Time by default.
    }
    data.promoLocationDistanceRequired = {
      valid: true,
      value: "0.094697"
    }
    data.promoValidDays = {
      valid: true,
      value: "1111111"
    }
    this.state = {
      loading: false,
      data: data,
      forceCheck: false,
      error: undefined,
      shakeButton: false,
    }

    this.submitForm = this.submitForm.bind(this)
    this.formChanged = this.formChanged.bind(this)
    this.shakeTheButton = this.shakeTheButton.bind(this)

    this.createPromotion = this.createPromotion.bind(this)
  }

  /*
  * Submits the form
  */
  submitForm() {
    //1) Make sure every data element is valid.
    let valid = true
    for (let key in this.state.data) {
      if (this.state.data[key].valid === false) {
        valid = false
      }
    }
    //2) Make sure we have all of the data.
    let requiredFields = ["promoTitle", "promoExpirationDate", "promoImageURL", "promoUseType", "promoActivationDuration", "promoLocationDistanceRequired"]
    requiredFields.forEach((element) => {
      if (this.state.data[element] === undefined || this.state.data[element].value === undefined) {
        console.log("invalid", element, this.state.data[element])
        valid = false
      }
    })
    //3) If valid, submit, else force check the fields for display.
    if (valid) {
      let data = {}
      for (let key in this.state.data) {
        data[key] = this.state.data[key].value
      }
      //Submit the form
      this.createPromotion(data)
    } else {
      console.log("Form not valid to submit")
      this.setState({
        forceCheck: true
      })
      //Shake the submit button as it is invalid to submit
      this.shakeTheButton()
      return
    }
  }

  /*
  * Called when data in an input form changes.
  * This will update the state.data param with the
  * name and new value of the form element.
  */
  formChanged(name, value, valid) {
    this.setState((prevState) => {
      let d = prevState.data
      d[name] = {
        value: value,
        valid: valid
      }
      return {
        data: d
      }
    })
  }

  /*
  Shakes the button and then removes the class.
  */
  shakeTheButton() {
    this.setState({
      shakeButton: true
    }, () => {
      setTimeout(() => {
        this.setState({
          shakeButton: false
        })
      }, 1000)
    })
  }

  /*
  Goes to the create promotion page.
  */
  createPromotion(data) {
    //Ask for confirmation first
    data['shopID'] = this.props.shop.shopID
    this.props.showConfirmation("Create Promotion", "This promotion will first be reviewed for content. After passing review, this promotion will become the active and show up on the map.", "Create Promotion", "Cancel", (create) => {
      if (create) {
        this.setState({
          loading: true
        }, () => {
          API.callDarwinAPI("POST", "promotion", data, (result) => {
            if ("error" in result) {
              this.props.showPopup("Error", "Couldn't create the promotion", result.error)
              this.setState({
                loading: false
              })
              return
            }
            //We have created the promotion, go back home.
            this.props.finished()
          })
        })
      }
    })
  }

  render() {
    let oldExpirationDateOptions = [
      {value: 7, label: "1 Week"},
      {value: 30, label: "1 Month"},
      {value: 60, label: "2 Months"},
      {value: 90, label: "3 Months"},
      {value: 180, label: "6 Months"},
      {value: 365, label: "1 Year"},
      {value: 730, label: "2 Years"},
    ]
    let expirationDateOptions = [
      {value: "3000-01-01", label: "Never"},
    ]
    for (let i = 0; i < oldExpirationDateOptions.length; i = i + 1) {
      let opt = oldExpirationDateOptions[i].value
      let today = new Date();
      today.setDate(today.getDate() + opt)

      //format today into text
      let dd = today.getDate();
      let mm = today.getMonth() + 1;
      let y = today.getFullYear().toString().substr(-2);
      let someFormattedDate = mm + '/'+ dd + '/'+ y;
      //add to the array
      expirationDateOptions.push({
        value: someFormattedDate,
        label: oldExpirationDateOptions[i].label
      })
    }

    let usageOptions = [
      {value: "1 Daily", label: "Once Daily"},
      {value: "Once", label: "Once"},
      {value: "Unlimited", label: "Unlimited"},
    ]

    let activationDistanceOptions = [
      {value: "0.0189394", label: "100 feet"},
      {value: "0.0378788", label: "200 feet"},
      {value: "0.0568182", label: "300 feet"},
      {value: "0.0757576", label: "400 feet"},
      {value: "0.094697", label: "500 feet"},
      {value: "0.113636", label: "600 feet"},
      {value: "0.189394", label: "1000 feet"},
      {value: "1.0", label: "1 mile"},
      {value: "2.0", label: "2 miles"},
      {value: "5.0", label: "5 miles"},
    ]

    let activationDurationOptions = [
      {value: "11111", label: "All Day - until midnight"},
      {value: "1800", label: "30 minutes"},
      {value: "3600", label: "1 hour"},
      {value: "7200", label: "2 hours"},
      {value: "10800", label: "3 hours"},
      {value: "14400", label: "4 hours"},
      {value: "21600", label: "6 hours"},
      {value: "43200", label: "12 hours"},
      {value: "86400", label: "24 hours"},
    ]

    let promotionData = {}
    for (let key of Object.keys(this.state.data)) {
      promotionData[key] = this.state.data[key].value
    }

    return (
      <div className="CreatePromotion">
        { this.state.loading &&
          <div className="StripeCheckoutLoading">
            <div>
              <Components.LoadingIndicator top="60px" />
            </div>
          </div>
        }
        <div className="CreatePromotionTitle">
          Create Promotion
        </div>
        <div className="CreatePromotionDescription">
          A promotion is the advertisement that is shown for your shop. This is the deal you are giving users.
          <br/>
          The better the deal, the more people will come to your door.
        </div>
        {/* Now show the form */}
        <div className="StripeCheckout">
          <div className="StripeCheckoutContainer" style={{paddingBottom:"140px"}}>

            <div className="StripeCheckoutInsideContainer">
              <div className="InputSection">
                Basic
              </div>
              {/* Title */}
              <div className="InputDiv">
                <Components.InputBottomLine type="text" name="promoTitle" placeholder="Buy 1 get 1 free" validation="text" required="true" maximum={255}
                  title="title" description="ex. 20% Off All Purchases"
                  value={this.state.data.promoTitle ? this.state.data.promoTitle.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
              {/* Short Description */}
              <div className="InputDiv">
                <Components.InputBottomLine type="text" name="promoShortDescription" placeholder="Sandwiches" validation="text" required="false" maximum={255}
                  title="(short description)" description="ex. Must present University ID"
                  value={this.state.data.promoShortDescription ? this.state.data.promoShortDescription.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
              {/* Deal Value */}
              <div className="InputDiv">
                <Components.InputBottomLine type="text" name="promoValue" placeholder="$2.00" validation="money" required="true"
                  minimum={0.0} maximum={10000.00}
                  title="deal value" description="The average value of this promotion."
                  value={this.state.data.promoValue ? this.state.data.promoValue.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
              {/* Uber Eats Link */}
              <div className="InputDiv">
                <Components.InputBottomLine type="text" name="promoUberLink" placeholder="ubereats://promo/apply?client_id=eats&promoCode=1234" validation="text" required="false" maximum={255}
                  title="(uber eats link)" description="a deep link to an Uber Eats promotion."
                  value={this.state.data.promoUberLink ? this.state.data.promoUberLink.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
              {/* Expiration Date */}
              {/*<div className="InputDiv">
                <Components.InputBottomLine type="selection" options={expirationDateOptions} name="promoExpirationDate" placeholder="Never" validation="text" required="true"
                  title="expiration date" description="The number of days before this promotion expires"
                  value={this.state.data.promoExpirationDate ? this.state.data.promoExpirationDate.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>*/}
              {/* Background Image */}
              <div className="InputDiv">
                <Components.InputBottomLine type="file" name="promoImageURL" placeholder="" validation="file" required="true"
                  title="background image" description="The main image shown for this promotion"
                  APIName="userFiles" APIUploadName="userFiles" showPopup={this.props.showPopup} maxSize={1600}
                  value={this.state.data.promoImageURL ? this.state.data.promoImageURL.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
            </div>

            <div className="InputSectionLine"></div>
            <div className="StripeCheckoutInsideContainer" style={{marginBottom:"20px"}}>
              <div className="InputSection">
                Usage
              </div>
              {/* Usage Frequency */}
              <div className="InputDiv">
                <Components.InputBottomLine type="selection" options={usageOptions} name="promoUseType" placeholder="1 Daily" validation="text" required="true"
                  title="usage frequency" description="How often this promotion can be used"
                  value={this.state.data.promoUseType ? this.state.data.promoUseType.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
              {/* Activation Distance */}
              <div className="InputDiv">
                <Components.InputBottomLine type="selection" options={activationDistanceOptions} name="promoLocationDistanceRequired" placeholder="0.094697" validation="text" required="true"
                  title="activation distance" description="How close to the shop you need to be to activate this promotion"
                  value={this.state.data.promoLocationDistanceRequired ? this.state.data.promoLocationDistanceRequired.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
              {/* Activation Duration */}
              <div className="InputDiv">
                <Components.InputBottomLine type="selection" options={activationDurationOptions} name="promoActivationDuration" placeholder="10800" validation="text" required="true"
                  title="activation duration" description="After activating, the promotion is valid for this time period"
                  value={this.state.data.promoActivationDuration ? this.state.data.promoActivationDuration.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
              {/* Valid Days */}
              <div className="InputDiv">
                <Components.InputBottomLine type="validDays" name="promoValidDays" validation="text" required="true"
                  title="valid days" description="What days of the week can this promo be used?"
                  value={this.state.data.promoValidDays ? this.state.data.promoValidDays.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>

              {/* Show the promotion here. */}
              <div className="PromotionPreviewHover">
                <Components.PromotionPreview shop={this.props.shop} promotion={promotionData} shrink={true}/>
              </div>
              <div className="PromotionPreviewInline">
                <Components.PromotionPreview shop={this.props.shop} promotion={promotionData} shrink={true}/>
              </div>

              {/* Bottom Buttons */}
              <div className="ButtonDiv">
                <Components.MaterialButton type="Purple" size="Large" onClick={this.submitForm} shake={this.state.shakeButton}>Create Promotion</Components.MaterialButton>
              </div>
              <div className="ButtonDiv">
                <Components.MaterialButton type="TextDark" size="Large" onClick={this.props.finished}>Cancel</Components.MaterialButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export class EditPromotion extends React.Component {

  constructor(props) {
    super(props)

    let data = {}
    //load in the data from props.
    let mapping = {
      "promoTitle": "promoTitle",
      "promoShortDescription": "promoShortDescription",
      "promoExpirationDate": "promoExpirationDate",
      "promoImageURL": "promoImageURL",
      "promoUseType": "promoUseType",
      "promoActivationDuration": "promoActivationDuration",
      "promoLocationDistanceRequired": "promoLocationDistanceRequired",
      "promoValue": "promoValue",
      "promoUberLink": "promoUberLink",
      "promoValidDays": "promoValidDays",
    }

    Object.keys(mapping).forEach((key) => {
      let value = this.props.promotion[mapping[key]]
      if (value !== undefined && value !== null) {
        if (key === "promoExpirationDate") {
          if (value === "3000-01-01" || value === "3000-01-01 00:00:00") {
            value = "3000-01-01"
          } else if (value.length > 8) {
            //parse the date into the format 03/31/95
            value = Helpers.formatDateShort(value)
          } else {
            //no need to parse the date
          }
          data[key] = {
            valid: true,
            value: value
          }
        } else {
          data[key] = {
            valid: true,
            value: value
          }
        }
      }
    })


    this.state = {
      loading: false,
      data: data,
      forceCheck: false,
      error: undefined,
      shakeButton: false,
    }

    this.submitForm = this.submitForm.bind(this)
    this.formChanged = this.formChanged.bind(this)
    this.shakeTheButton = this.shakeTheButton.bind(this)

    this.editPromotion = this.editPromotion.bind(this)
  }

  /*
  * Submits the form
  */
  submitForm() {
    //1) Make sure every data element is valid.
    let valid = true
    for (let key in this.state.data) {
      if (this.state.data[key].valid === false) {
        valid = false
      }
    }
    //2) Make sure we have all of the data.
    let requiredFields = ["promoTitle", "promoExpirationDate", "promoImageURL", "promoUseType", "promoActivationDuration", "promoLocationDistanceRequired"]
    requiredFields.forEach((element) => {
      if (this.state.data[element] === undefined || this.state.data[element].value === undefined) {
        console.log("invalid", element, this.state.data[element])
        valid = false
      }
    })
    //3) If valid, submit, else force check the fields for display.
    if (valid) {
      let data = {}
      for (let key in this.state.data) {
        data[key] = this.state.data[key].value
      }
      //Submit the form
      this.editPromotion(data)
    } else {
      console.log("Form not valid to submit")
      this.setState({
        forceCheck: true
      })
      //Shake the submit button as it is invalid to submit
      this.shakeTheButton()
      return
    }
  }

  /*
  * Called when data in an input form changes.
  * This will update the state.data param with the
  * name and new value of the form element.
  */
  formChanged(name, value, valid) {
    this.setState((prevState) => {
      let d = prevState.data
      d[name] = {
        value: value,
        valid: valid
      }
      return {
        data: d
      }
    })
  }

  /*
  Shakes the button and then removes the class.
  */
  shakeTheButton() {
    this.setState({
      shakeButton: true
    }, () => {
      setTimeout(() => {
        this.setState({
          shakeButton: false
        })
      }, 1000)
    })
  }

  /*
  Saves the changes
  */
  editPromotion(data) {
    //Ask for confirmation first
    data['promoID'] = this.props.promotion.promoID
    let callback = (save) => {
      if (save) {
        this.setState({
          loading: true
        }, () => {
          API.callDarwinAPI("PUT", "promotion", data, (result) => {
            if ("error" in result) {
              this.props.showPopup("Error", "Couldn't save the changes", result.error)
              this.setState({
                loading: false
              })
              return
            }
            //We have saved the changes, go back home.
            this.props.finished()
          })
        })
      }
    }

    if (this.props.promotion.promoReviewStatus === "0") {
      this.props.showConfirmation("Save Changes", "These changes will be applied instantly.", "Save Changes", "Cancel", callback)
    } else {
      callback(true)
    }
  }

  render() {
    let oldExpirationDateOptions = [
      {value: 7, label: "1 Week"},
      {value: 30, label: "1 Month"},
      {value: 60, label: "2 Months"},
      {value: 90, label: "3 Months"},
      {value: 180, label: "6 Months"},
      {value: 365, label: "1 Year"},
      {value: 730, label: "2 Years"},
    ]
    let expirationDateOptions = [
      {value: "3000-01-01", label: "Never"},
    ]
    for (let i = 0; i < oldExpirationDateOptions.length; i = i + 1) {
      let opt = oldExpirationDateOptions[i].value
      let today = new Date();
      today.setDate(today.getDate() + opt)

      //format today into text
      let dd = today.getDate();
      let mm = today.getMonth() + 1;
      let y = today.getFullYear().toString().substr(-2);
      let someFormattedDate = mm + '/'+ dd + '/'+ y;
      //add to the array
      expirationDateOptions.push({
        value: someFormattedDate,
        label: oldExpirationDateOptions[i].label
      })
    }
    //see if our value is one of the options.
    let found = false
    for (let i = 0; i < expirationDateOptions.length; i = i + 1) {
      if (expirationDateOptions[i].value === this.state.data.promoExpirationDate.value) {
        found = true
      }
    }
    if (!found) {
      expirationDateOptions.push({
        value: this.state.data.promoExpirationDate.value,
        label: this.state.data.promoExpirationDate.value,
      })
    }

    let usageOptions = [
      {value: "1 Daily", label: "Once Daily"},
      {value: "Once", label: "Once"},
      {value: "Unlimited", label: "Unlimited"},
    ]

    let activationDistanceOptions = [
      {value: "0.0189394", label: "100 feet"},
      {value: "0.0378788", label: "200 feet"},
      {value: "0.0568182", label: "300 feet"},
      {value: "0.0757576", label: "400 feet"},
      {value: "0.094697", label: "500 feet"},
      {value: "0.113636", label: "600 feet"},
      {value: "0.189394", label: "1000 feet"},
      {value: "1.0", label: "1 mile"},
      {value: "2.0", label: "2 miles"},
      {value: "5.0", label: "5 miles"},
    ]

    let activationDurationOptions = [
      {value: "11111", label: "All Day - until midnight"},
      {value: "1800", label: "30 minutes"},
      {value: "3600", label: "1 hour"},
      {value: "7200", label: "2 hours"},
      {value: "10800", label: "3 hours"},
      {value: "14400", label: "4 hours"},
      {value: "21600", label: "6 hours"},
      {value: "43200", label: "12 hours"},
      {value: "86400", label: "24 hours"},
    ]

    let promotionData = {}
    for (let key of Object.keys(this.state.data)) {
      promotionData[key] = this.state.data[key].value
    }

    return (
      <div className="CreatePromotion">
        { this.state.loading &&
          <div className="StripeCheckoutLoading">
            <div>
              <Components.LoadingIndicator top="60px" />
            </div>
          </div>
        }
        <div className="CreatePromotionTitle">
          Edit Promotion
        </div>
        <div className="CreatePromotionDescription">
          A promotion is the advertisement that is shown for your shop. This is the deal you are giving users.
          <br/>
          The better the deal, the more people will come to your door.
        </div>
        {/* Now show the form */}
        <div className="StripeCheckout">
          <div className="StripeCheckoutContainer" style={{paddingBottom:"140px"}}>

            <div className="StripeCheckoutInsideContainer">
              <div className="InputSection">
                Basic
              </div>
              {/* Title */}
              <div className="InputDiv">
                <Components.InputBottomLine type="text" name="promoTitle" placeholder="Buy 1 get 1 free" validation="text" required="true" maximum={255}
                  title="title" description="ex. 20% Off All Purchases"
                  value={this.state.data.promoTitle ? this.state.data.promoTitle.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
              {/* Short Description */}
              <div className="InputDiv">
                <Components.InputBottomLine type="text" name="promoShortDescription" placeholder="Sandwiches" validation="text" required="false" maximum={255}
                  title="(short description)" description="ex. Must present University ID"
                  value={this.state.data.promoShortDescription ? this.state.data.promoShortDescription.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
              {/* Expiration Date */}
              <div className="InputDiv">
                <Components.InputBottomLine type="selection" options={expirationDateOptions} name="promoExpirationDate" placeholder="Never" validation="text" required="true"
                  title="expiration date" description="The number of days before this promotion expires"
                  value={this.state.data.promoExpirationDate ? this.state.data.promoExpirationDate.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
              {/* Deal Value */}
              <div className="InputDiv">
                <Components.InputBottomLine type="text" name="promoValue" placeholder="$2.00" validation="money" required="true"
                  minimum={0.0} maximum={10000.00}
                  title="deal value" description="The average value of this promotion."
                  value={this.state.data.promoValue ? this.state.data.promoValue.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
              {/* Uber Eats Link */}
              <div className="InputDiv">
                <Components.InputBottomLine type="text" name="promoUberLink" placeholder="ubereats://promo/apply?client_id=eats&promoCode=1234" validation="text" required="false" maximum={255}
                  title="(uber eats link)" description="a deep link to an Uber Eats promotion."
                  value={this.state.data.promoUberLink ? this.state.data.promoUberLink.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
              {/* Background Image */}
              <div className="InputDiv">
                <Components.InputBottomLine type="file" name="promoImageURL" placeholder="" validation="file" required="true"
                  title="background image" description="The main image shown for this promotion"
                  APIName="userFiles" APIUploadName="userFiles" showPopup={this.props.showPopup} maxSize={1600}
                  value={this.state.data.promoImageURL ? this.state.data.promoImageURL.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
            </div>

            <div className="InputSectionLine"></div>
            <div className="StripeCheckoutInsideContainer" style={{marginBottom:"20px"}}>
              <div className="InputSection">
                Usage
              </div>
              {/* Usage Frequency */}
              <div className="InputDiv">
                <Components.InputBottomLine type="selection" options={usageOptions} name="promoUseType" placeholder="1 Daily" validation="text" required="true"
                  title="usage frequency" description="How often this promotion can be used"
                  value={this.state.data.promoUseType ? this.state.data.promoUseType.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
              {/* Activation Distance */}
              <div className="InputDiv">
                <Components.InputBottomLine type="selection" options={activationDistanceOptions} name="promoLocationDistanceRequired" placeholder="0.094697" validation="text" required="true"
                  title="activation distance" description="How close to the shop you need to be to activate this promotion"
                  value={this.state.data.promoLocationDistanceRequired ? this.state.data.promoLocationDistanceRequired.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
              {/* Activation Duration */}
              <div className="InputDiv">
                <Components.InputBottomLine type="selection" options={activationDurationOptions} name="promoActivationDuration" placeholder="10800" validation="text" required="true"
                  title="activation duration" description="After activating, the promotion is valid for this time period"
                  value={this.state.data.promoActivationDuration ? this.state.data.promoActivationDuration.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
              {/* Valid Days */}
              <div className="InputDiv">
                <Components.InputBottomLine type="validDays" name="promoValidDays" validation="text" required="true"
                  title="valid days" description="What days of the week can this promo be used?"
                  value={this.state.data.promoValidDays ? this.state.data.promoValidDays.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>

              {/* Show the promotion here. */}
              <div className="PromotionPreviewHover">
                <Components.PromotionPreview shop={this.props.shop} promotion={promotionData} shrink={true}/>
              </div>
              <div className="PromotionPreviewInline">
                <Components.PromotionPreview shop={this.props.shop} promotion={promotionData} shrink={true}/>
              </div>

              {/* Bottom Buttons */}
              <div className="ButtonDiv">
                <Components.MaterialButton type="Green" size="Large" onClick={this.submitForm} shake={this.state.shakeButton}>Save Changes</Components.MaterialButton>
              </div>
              <div className="ButtonDiv">
                <Components.MaterialButton type="TextDark" size="Large" onClick={this.props.finished}>Cancel</Components.MaterialButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export class Account extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      tab: "Account",
      data: {},
      forceCheck: false,
      error: undefined,
      shakeButton: false,
      paymentData: {},
      billingData: {},
      accountManger: {},
      managerOptions: [],
    }

    this.changeTab = this.changeTab.bind(this)
    this.submitForm = this.submitForm.bind(this)
    this.formChanged = this.formChanged.bind(this)
    this.shakeTheButton = this.shakeTheButton.bind(this)

    this.updateInfo = this.updateInfo.bind(this)
    this.resetPassword = this.resetPassword.bind(this)
    this.resendConfirmationEmail = this.resendConfirmationEmail.bind(this)

    this.contactAccountManager = this.contactAccountManager.bind(this)
    this.switchAccountManagers = this.switchAccountManagers.bind(this)
  }

  componentDidMount() {
    this.changeTab("Account")
  }

  /*
  * Changes the tab and resets all of the data.
  */
  changeTab(newTab) {
    //console.log(newTab + " selected")

    let data = {}
    if (newTab === "Account" && this.props.userInfo.name) {

      data.name = {
        value: this.props.userInfo.name,
        valid: true
      }
      //set the promoCode if an associate
      if (this.props.userInfo.accountType === "Associate") {
        if (this.props.userInfo.promoCode) {
          data.promoCode = {
            value: this.props.userInfo.promoCode,
            valid: true
          }
        }
        data.payoutType = {
          value: this.props.userInfo.payoutType,
          valid: true
        }
      } else if (this.props.userInfo.accountType === "Owner") {
        //set the rate if logged in as an Admin
        if (this.props.adminInfo.accountType === "Admin") {
          data.rate = {
            value: this.props.userInfo.rate,
            valid: true
          }
        }
      }
      //set the profile picture
      if (this.props.userInfo.profilePicture) {
        data.profilePicture = {
          value: this.props.userInfo.profilePicture,
          valid: true
        }
      }
      //set the phone number
      if (this.props.userInfo.phoneNumber) {
        data.phoneNumber = {
          value: this.props.userInfo.phoneNumber,
          valid: true
        }
      }
    } else if (newTab === "Support") {
      //load the support information
      this.setState({
        tab: "Loading"
      }, () => {
        //load the support information
        API.callDarwinAPI("GET", "userSupportInfo", {}, (result) => {
          if ("error" in result) {
            this.props.showPopup("Error", "Couldn't find your support information", "Some issue occurred. Please try again.")
            this.changeTab("Account")
            return
          }
          this.setState({
            tab: "Support",
            data: data,
            forceCheck: false,
            error: undefined,
            shakeButton: false,
            paymentData: {},
            billingData: {},
            accountManger: result.data,
            managerOptions: []
          }, () => {
            //load the manager options if necessary
            if (this.props.accountTakeover && this.props.adminInfo.accountType === "Admin") {
              API.callDarwinAPI("GET", "userSupportManagers", {}, (result) => {
                if ("error" in result) {
                  this.props.showPopup("Error", "Couldn't find a list of the possible userSupportManagers", "Please try again.")
                  this.changeTab("Account")
                  return
                }
                let data = result.data
                data.unshift({
                  value: "",
                  label: "Select a manager"
                })
                this.setState({
                  managerOptions: data
                })
              })
            }
          })
        })
      })
      return
    } else if (newTab === "Billing") {
      //load the billing information
      this.setState({
        tab: "Loading"
      }, () => {
        //load the billing information
        API.callDarwinAPI("GET", "userBillingInfo", {}, (result) => {
          //console.log(result)
          if ("error" in result) {
            this.props.showPopup("Error", "Couldn't find your billing information", "Some issue occurred. Please try again.")
            this.changeTab("Account")
            return
          }
          this.setState({
            tab: "Billing",
            data: data,
            forceCheck: false,
            error: undefined,
            shakeButton: false,
            paymentData: {},
            billingData: result.data,
            accountManger: {},
            managerOptions: []
          })
        })
      })
      return
    } else if (newTab === "Payments") {
      //load the payment information
      this.setState({
        tab: "Loading"
      }, () => {
        //load the billing information
        API.callDarwinAPI("GET", "userPaymentInfo", {}, (result) => {
          console.log(result)
          if ("error" in result) {
            this.props.showPopup("Error", "Couldn't find your payment information", "Some issue occurred. Please try again.")
            this.changeTab("Account")
            return
          }
          this.setState({
            tab: "Payments",
            data: data,
            forceCheck: false,
            error: undefined,
            shakeButton: false,
            paymentData: result.data,
            billingData: {},
            accountManger: {},
            managerOptions: []
          })
        })
      })
      return
    }

    this.setState({
      tab: newTab,
      data: data,
      forceCheck: false,
      error: undefined,
      shakeButton: false,
      paymentData: {},
      billingData: {},
      accountManger: {},
      managerOptions: []
    })
  }

  /*
  * Submits the form
  */
  submitForm() {
    //1) Make sure every data element is valid.
    let valid = true
    for (let key in this.state.data) {
      if (this.state.data[key].valid === false) {
        valid = false
      }
    }
    //2) Make sure we have all of the data.
    let requiredFields = []
    switch (this.state.tab) {
      case "Account":
        requiredFields = ["name"]
        break;
      case "Support":
        requiredFields = ["manager"]
        break;
      default:
        break;
    }
    requiredFields.forEach((element) => {
      if (this.state.data[element] === undefined || this.state.data[element].value === undefined) {
        valid = false
      }
    })
    //3) If valid, submit, else force check the fields for display.
    if (valid) {
      let data = {}
      for (let key in this.state.data) {
        data[key] = this.state.data[key].value
      }
      //Submit the form
      switch (this.state.tab) {
        case "Account":
          this.updateInfo(data)
          break;
        case "Support":
          this.switchAccountManagers(data)
          break;
        default:
          break;
      }
    } else {
      console.log("Form not valid to submit")
      this.setState({
        forceCheck: true
      })
      //Shake the submit button as it is invalid to submit
      this.shakeTheButton()
      return
    }
  }

  /*
  * Called when data in an input form changes.
  * This will update the state.data param with the
  * name and new value of the form element.
  */
  formChanged(name, value, valid) {
    this.setState((prevState) => {
      let d = prevState.data
      d[name] = {
        value: value,
        valid: valid
      }
      return {
        data: d
      }
    })
  }

  /*
  Shakes the button and then removes the class.
  */
  shakeTheButton() {
    this.setState({
      shakeButton: true
    }, () => {
      setTimeout(() => {
        this.setState({
          shakeButton: false
        })
      }, 1000)
    })
  }

  /*
  Logs in the user with the provided data.
  */
  updateInfo(data) {
    console.log("Login Attempt")
    //1) Show a Loading Indicator...
    this.setState({
      tab: "Loading"
    }, () => {
      //2) Submit the form.
      API.callDarwinAPI("PUT", "userProfile", data, (result) => {
        if ("error" in result) {
          //3) On Error, show the error dialog
          this.props.showPopup("Error", "Couldn't update your profile information", result.error)
        }
        //4) On Success, reload the userInfo, then switch the tab.
        this.props.loadUserInfo(() => {
          this.changeTab("Account")
        })
      })
    })
  }

  /*
  Sends a request for you to reset your password.
  */
  resetPassword() {
    this.props.showConfirmation("Are you sure you want to reset your password?", "You will receive an email with a link. Click the link the reset your password.", "Reset Password", "Cancel", (shouldReset) => {
      if (!shouldReset) {
        //nothing to do
        return
      }
      //Now, reset the password.
      //1) Show a loading indication
      this.setState({
        tab: "Loading"
      }, () => {
        //2) Reset this user's password.
        API.manualResetPassword(this.props.userInfo.email, (result) => {
          if ("error" in result) {
            //3) On Error, show the error dialog
            this.props.showPopup("Error", "Couldn't reset your password", "Some issue occurred. Please try again.")
            this.changeTab("Account")
            return
          }
          //4) On Success, show the check your email prompt.
          this.props.showPopup("Success", "Check your email", "We sent you an email with a link to reset your password. Click the link and follow the directions.")
          this.changeTab("Account")
        })
      })
    })
  }

  /*
  Resends a confirmation email for this user to login.
  Since we don't have the email, we will have to use the userID.
  */
  resendConfirmationEmail() {
    this.props.showConfirmation("Are you sure you want to send a confirmation email?", "This will send an email to this user's account containing a link. Have them click the link to verify their email and then they can login.", "Send Verification Email", "Cancel", (shouldSend) => {
      if (!shouldSend) {
        //nothing to do
        return
      }
      //Now, send the verification email based on the userID
      //1) Show a loading indication
      this.setState({
        tab: "Loading"
      }, () => {
        //2) Reset this user's password.
        API.manualResendConfirmationByID(this.props.userInfo.id, (result) => {
          if ("error" in result) {
            //3) On Error, show the error dialog
            this.props.showPopup("Error", "Couldn't send the verification email", result.error)
            this.changeTab("Account")
            return
          }
          //4) On Success, show the check your email prompt.
          this.props.showPopup("Success", "Have the user check their email", "We sent an email with a link to verify their email address. Have them click the link and follow the directions.")
          this.changeTab("Account")
        })
      })
    })
  }

  /*
  Opens up an email client to send an email to your HallPass Support Contact
  */
  contactAccountManager() {
    //open up email to talk to the account manager.
    window.location.href = "mailto:" + this.state.accountManger.email + "?subject=HallPass Support"
  }

  /*
  Switches who is the account manager for this account.
  */
  switchAccountManagers(data) {
    //1) Confirm that you want to do this.
    this.props.showConfirmation("Are you sure you want to switch the account manager for this account?", "The old account manager will no longer be in charge of this account and will not be paid for their service.", "Change Manager", "Cancel", (shouldChange) => {
      if (shouldChange) {
        //2) Show the loading indicator.
        this.setState({
          tab: "Loading"
        }, () => {
          //3) Call the API to change the manager.
          API.callDarwinAPI("PUT", "userSupportInfo", {
            managerID: data.manager
          }, (result) => {
            if ("error" in result) {
              //4) Show an error.
              this.props.showPopup("Error", "Couldn't edit the manager for this account.", "Some issue occurred. Please try again.")
              this.changeTab("Support")
              return
            }
            //5) Success, now reload the Support tab.
            this.changeTab("Support")
          })
        })
      }
    })
  }

  /*
  Downloads the billing agreement that was accepted when your credit card was entered.
  */
  viewAgreement() {
    let win = window.open("https://galaxy.darwincloud.com/Apps/16/Legal/Bidly%20Subscription.pdf", "_blank")
    win.focus()
  }

  render() {
    let tabs = []
    if (this.props.userInfo.accountType === "Admin") {
      tabs = ["Account"]
    } else if (this.props.userInfo.accountType === "Owner") {
      tabs = ["Account", "Support"]//["Account", "Billing", "Support"]
    } else if (this.props.userInfo.accountType === "Associate") {
      tabs = ["Account", "Payments", "Support"]
    }

    let tabData = {
      tabs: tabs,
      selected: this.state.tab,
      changeTab: this.changeTab
    }

    let rateOptions = [
      {value: "250", label: "$250"},
      {value: "225", label: "$225"},
      {value: "200", label: "$200"},
      {value: "175", label: "$175"},
      {value: "150", label: "$150"},
      {value: "125", label: "$125"},
      {value: "100", label: "$100"},
      {value: "90", label: "$90"},
      {value: "80", label: "$80"},
      {value: "70", label: "$70"},
      {value: "60", label: "$60"},
      {value: "50", label: "$50"},
      {value: "0", label: "Free"},
    ]

    let payoutOptions = [
      {value: "monthly", label: "Monthly"},
      {value: "once", label: "One-Time"},
    ]

    return (
      <div className="Account">
        <TabSelection {...tabData} />
        { this.state.tab === "Account" &&
          <span>
            <div className="EmailAddressTitle">
              Email Address
            </div>
            { !this.props.userInfo.id &&
              <div className="EmailAddressValue">
                Loading...
              </div>
            }
            { this.props.userInfo.id && !this.props.userInfo.email &&
              <div className="EmailAddressValue">
                Email not verified
              </div>
            }
            { this.props.userInfo.id && this.props.userInfo.email &&
              <div className="EmailAddressValue">
                { this.props.userInfo.email }
              </div>
            }
            { /* Update our account information */ }
            {/* Name */}
            <div className="InputDiv">
              <Components.InputBottomLine type="text" name="name" placeholder="name" validation="text" required="true" maximum={255}
                title="name" description="Your full name ex. John Buckner"
                value={this.state.data.name ? this.state.data.name.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
            </div>
            {/* Profile Picture */}
            <div className="InputDiv">
              <Components.InputBottomLine type="file" name="profilePicture" placeholder="" validation="file" required="false"
                title="(profile picture)" description="Your profile picture... round images look better"
                APIName="userFiles" APIUploadName="userFiles" showPopup={this.props.showPopup} maxSize={800}
                value={this.state.data.profilePicture ? this.state.data.profilePicture.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
            </div>
            {/* Phone Number */}
            <div className="InputDiv">
              <Components.InputBottomLine type="text" name="phoneNumber" placeholder="(123) 456 - 7890" validation="phoneNumber10" required="false"
                title="(phone number)" description="The number to contact you if there is an issue"
                value={this.state.data.phoneNumber ? this.state.data.phoneNumber.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
            </div>
            {/* Invite Code */}
            { this.props.userInfo.accountType === "Associate" &&
              <div className="InputDiv">
                <Components.InputBottomLine type="text" name="promoCode" placeholder="ABC123" validation="text" required="false" maximum={255}
                  title="(invite code)" description="Owners can use this code when signing up to grant you their business"
                  value={this.state.data.promoCode ? this.state.data.promoCode.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
            }
            {/* Payout Type */}
            { this.props.userInfo.accountType === "Associate" &&
              <div className="InputDiv">
                <Components.InputBottomLine type="selection" options={payoutOptions} name="payoutType" placeholder="monthly" validation="text" required="true"
                  title="payout type" description="Receive a 30% commission every month or a one time 100% commission per month. If you want a monthly commission, you are the support contact for the shops you signup."
                  value={this.state.data.payoutType ? this.state.data.payoutType.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
            }
            {/* Rate */}
            { this.props.userInfo.accountType === "Owner" && this.props.adminInfo.accountType === "Admin" &&
              <div className="InputDiv">
                <Components.InputBottomLine type="selection" options={rateOptions} name="rate" placeholder="$100" validation="text" required="true"
                  title="rate" description="The amount charged monthly per shop on this account"
                  value={this.state.data.rate ? this.state.data.rate.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
            }
            <div className="ButtonDiv">
              <Components.MaterialButton type="Purple" size="Large" onClick={this.submitForm} shake={this.state.shakeButton}>Save Changes</Components.MaterialButton>
            </div>
            { /* Buttons for resetting passwords, resending emails, logging out */ }
            { this.props.userInfo.email &&
              <div className="ButtonDiv">
                <Components.MaterialButton type="TextDark" onClick={this.resetPassword}>Reset Password</Components.MaterialButton>
              </div>
            }
            { this.props.userInfo.id && !this.props.userInfo.email &&
              <div className="ButtonDiv">
                <Components.MaterialButton type="TextDark" onClick={this.resendConfirmationEmail}>Resend Confirmation Email</Components.MaterialButton>
              </div>
            }
            <div className="ButtonDiv">
              <Components.MaterialButton type="TextRed" onClick={this.props.logout}>Logout</Components.MaterialButton>
            </div>
            <div className="AccountVersionNumber">
              { "v " + Helpers.getAppVersion() }
            </div>
          </span>
        }
        { /*this.state.tab === "Billing" &&
          <span className="Billing">
            { this.state.billingData.stripe && this.state.billingData.stripe.sources.total_count > 0 &&
              <span>
                <Components.CreditCard {...this.state.billingData.stripe.sources.data[0]} />
                <div className="ButtonDiv">
                  <Components.MaterialButton type="Red" onClick={this.props.goToEditCard}>Edit Card</Components.MaterialButton>
                </div>
                <div className="BillingText">
                  Your card will be charged at the beginning of every month for ${ Helpers.formatNumber(this.props.userInfo.nextPayment === "-1" ? "0" : this.props.userInfo.nextPayment) }.
                </div>
                <div className="ButtonDiv">
                  <Components.MaterialButton type="TextDark" onClick={this.viewAgreement.bind(this)}>View Agreement</Components.MaterialButton>
                </div>
              </span>
            }
            { !this.state.billingData.stripe &&
              <span>
                <div className="NoCreditCard">
                  <div className="NoCreditCardTitle">
                    No credit card set for this user.
                  </div>
                </div>
                <div className="ButtonDiv">
                  <Components.MaterialButton type="Red" onClick={this.props.goToEditCard}>Enter Card</Components.MaterialButton>
                </div>
                <div className="BillingText">
                  This user must enter their credit card before they can login.
                </div>
              </span>
            }
          </span>*/
        }
        { this.state.tab === "Payments" &&
          <span className="Payments">
            { this.state.paymentData.PayPal &&
              <span>
                <div className="PaymentsDescription" style={{paddingTop:"50px"}}>
                  You have connected your PayPal account.
                </div>
                <div className="PaymentsDataGroup">
                  <div className="PaymentsDataGroupTitle">PayPal Account:</div>
                  <div className="PaymentsDataGroupName">{this.state.paymentData.PayPal.name}</div>
                  <div className="PaymentsDataGroupEmail">{this.state.paymentData.PayPal.email}</div>
                </div>
                <div className="ButtonDiv">
                  <Components.PayPalButton userInfo={this.props.userInfo} />
                </div>
                <div className="PaymentsDescription" style={{paddingTop:"30px"}}>
                  { /* TODO: UPDATE THIS TEXT TO BE FOR THE AMOUNT YOU WILL ACTUALLY BE PAID EVERY MONTH. */}
                  Every month, your PayPal account will be sent a payout for the businesses you have signed up.
                </div>
              </span>
            }
            { !this.state.paymentData.PayPal &&
              <span>
                <div className="PaymentsDescription" style={{paddingTop:"50px"}}>
                  You need to connect a PayPal account to get paid. Click the button below to get started.
                </div>
                <div className="ButtonDiv">
                  <Components.PayPalButton userInfo={this.props.userInfo} />
                </div>
                <div className="PaymentsDescription" style={{paddingTop:"30px"}}>
                  { /* TODO: UPDATE THIS TEXT TO BE FOR THE AMOUNT YOU WILL ACTUALLY BE PAID EVERY MONTH. */}
                  Every month, your PayPal account will be sent a payout for the businesses you have signed up.
                </div>
              </span>
            }
          </span>
        }
        { this.state.tab === "Support" &&
          <span>
            <div className="SupportTitle">
              Account Manager
            </div>
            <div className="SupportDescription">
              Your HallPass Account Manager is
            </div>
            <div className="SupportName">
              {this.state.accountManger.name}
            </div>
            { this.state.accountManger.profilePicture &&
              <div className="SupportProfilePicture">
                <img src={this.state.accountManger.profilePicture} alt="Support Manager"/>
              </div>
            }
            { this.state.accountManger.phoneNumber &&
              <div className="SupportDescription">
                {Helpers.parsePhoneNumber(this.state.accountManger.phoneNumber)}
              </div>
            }
            <div className="SupportDescription">
              {this.state.accountManger.email}
            </div>
            <div className="ButtonDiv">
              <Components.MaterialButton type="Purple" size="Large" onClick={this.contactAccountManager}>Contact</Components.MaterialButton>
            </div>
            { this.props.accountTakeover && this.props.adminInfo.accountType === "Admin" &&
              /* Show the form for the user to edit the support manager */
              <span>
                <div className="InputDiv" style={{marginTop:"30px"}}>
                  <Components.InputBottomLine type="selection" options={this.state.managerOptions} name="manager" placeholder="Account Manager" validation="text" required="true"
                    title="Account Manager" description="Switch the Account Manager for this account."
                    value={this.state.data.manager ? this.state.data.manager.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
                </div>
                <div className="ButtonDiv">
                  <Components.MaterialButton type="TextPurpleShadow" size="Large" onClick={this.submitForm} shake={this.state.shakeButton}>Change Manager</Components.MaterialButton>
                </div>
              </span>
            }
          </span>
        }
        { this.state.tab === "Loading" &&
          <span>
            <div>
              <Components.LoadingIndicator top="60px" />
            </div>
          </span>
        }
      </div>
    )
  }
}

export class TabSelection extends React.Component {

  render() {
    return (
      <div className="TabSelection">
        { this.props.tabs.map((tab, i) => (
          <span key={i}>
            <div className={"Tab " + (this.props.selected === tab ? "TabSelected" : "")} onClick={this.props.changeTab.bind(this, tab)}>
              {tab}
            </div>
            { i !== (this.props.tabs.length - 1) &&
              <div className="TabSpacer">
              </div>
            }
          </span>
        ))}
      </div>
    )
  }
}

export class DeactivatedAccount extends React.Component {

  render() {
    return (
      <div className="DeactivatedAccount">
        <div className="DeactivatedAccountTitle">
          Your account has been deactivated
        </div>
        <div className="DeactivatedAccountDescription">
          You no longer have access to HallPass and have lost all of your accounts.
          Contact support at support@get-the-pass.com for more details.
        </div>
        <div className="DeactivatedAccountBottom">
          <Components.MaterialButton type="TextDarkShadow" onClick={this.props.logout}>Logout</Components.MaterialButton>
        </div>
      </div>
    )
  }
}

export class Associate extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      associate: {},
      stats: {},
    }

    this.loadInfo = this.loadInfo.bind(this)
    this.deactivateAccount = this.deactivateAccount.bind(this)
  }

  componentDidMount() {
    this.loadInfo()
  }

  loadInfo() {
    this.setState({
      loading: true,
      associate: {},
      stats: {},
    }, () => {
      API.callDarwinAPI("GET", "associate/" + this.props.associate.id, {}, (result) => {
        if ("error" in result) {
          this.props.showPopup("Error", "Couldn't retreive this Ambassador's information", result.error)
          this.setState({
            loading: false,
          })
          return
        }
        this.setState({
          loading: false,
          associate: result.data.associate,
          stats: result.data.stats
        })
      })
    })
  }

  deactivateAccount(deactivate) {
    let d1 = deactivate === 1 ? "Are you sure you want to deactivate this account? This ambassador will lose all of their business and will have to start over if you ever decide to reactivate them." : "Are you sure you want to reactivate this account?"
    let d2 = deactivate === 1 ? "Deactivate" : "Reactivate"
    this.props.showConfirmation("Wait", d1, d2, "Cancel", (go) => {
      if (go) {
        this.setState({
          loading: true,
        }, () => {
          API.callDarwinAPI("DELETE", "associate/" + this.props.associate.id, {
            deactivate: deactivate
          }, (result) => {
            if ("error" in result) {
              this.props.showPopup("Error", "Couldn't " + (deactivate === 1 ? "deactivate" : "reactivate") + " this ambassador", result.error)
              this.setState({
                loading: false,
              })
              return
            }
            this.loadInfo()
          })
        })
      }
    })
  }

  render() {
    return (
      <div className="ShopPage">
        <div className="ShopPageContent">
          { this.state.loading &&
            <Components.LoadingIndicator top="100px" />
          }
          { !this.state.loading && Object.keys(this.state.associate).length > 0 &&
            <span>
              <div className="ShopPageTop">
                <div className="ShopPageTopLeft">
                  <div className="ShopPageTitle">
                    {this.state.associate.name}
                  </div>
                  <div className="ShopPageDescription">
                    {this.state.associate.email}
                  </div>
                  { this.state.associate.deactivationDate &&
                    <div className="ShopPageDeactivationDate">
                      This ambassador was deactivated on&nbsp;
                      <span className="ShopPageDeactivationDateDate">
                        { Helpers.formatDate(this.state.associate.deactivationDate) }
                      </span>
                    </div>
                  }
                </div>
              </div>
              {/* Statistics */}
              <div className="ShopPageTitle" style={{marginTop:"68px"}}>
                Statistics
              </div>
              <div className="ShopPageDescription">
                The stats below represent how many shops & accounts this Ambassador has signed up and how many of those shops & accounts are paying.
              </div>
              <div className="ShopPageStatsContainer">
                <Components.Statistic value={this.state.stats.shopsSignedUp} type="Signed Up" duration="Shops" />
                <Components.Statistic value={this.state.stats.shopsPaying} type="Paying" duration="Shops" />
                <Components.Statistic value={this.state.stats.accountsSignedUp} type="Signed Up" duration="Accounts" />
                <Components.Statistic value={this.state.stats.accountsPaying} type="Paying" duration="Accounts" />
              </div>
            </span>
          }
          { !this.state.loading && Object.keys(this.state.associate).length === 0 &&
            <span>
              There was an issue loading the associate. Go back home and try again.
            </span>
          }
        </div>
        <div className="ShopPageBottom">
          { !this.state.loading &&
            <span>
              <Components.MaterialButton type="Green" onClick={() => { this.props.takeoverAccount(this.props.associate.id) }}>Access Account</Components.MaterialButton>
              { this.state.associate.deactivationDate &&
                <Components.MaterialButton type="TextRedShadow" onClick={() => { this.deactivateAccount(0) }}>Reactivate Account</Components.MaterialButton>
              }
              { !this.state.associate.deactivationDate &&
                <Components.MaterialButton type="TextRedShadow" onClick={() => { this.deactivateAccount(1) }}>Deactivate Account</Components.MaterialButton>
              }
              <Components.MoneyCircle value={ this.state.associate.nextPayout || "0" } />
            </span>
          }
        </div>
      </div>
    )
  }
}

export class CreditCardForm extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      subview: this.props.subview ? this.props.subview : "Home" //Home, Form
    }

    this.changeView = this.changeView.bind(this)
    this.visitLink = this.visitLink.bind(this)
  }

  changeView(view) {
    this.setState({
      subview: view
    })
  }

  visitLink(page) {
    let win = window.open(page, "_blank")
    win.focus()
  }

  render() {
    let stripeFormProps = {
      showPopup: this.props.showPopup,
      showConfirmation: this.props.showConfirmation,
      userInfo: this.props.userInfo,
      finished: this.props.backFromCreditCardForm,
      mandatory: this.props.creditCardMandatory,
      issue: this.props.creditCardIssue,
    }
    return (
      <span>
        { this.state.subview === "Home" &&
          <div className="CreditCardHome">
            <div className="CreditCardHomeTitle">
              HallPass Subscription
            </div>
            { this.props.creditCardIssue &&
              <div className="CreditCardHomeIssue">
                There is an issue with your credit card on file. You need to update your credit card to regain access to the portal.
              </div>
            }
            <div className="CreditCardHomeDescription">
              You are signing up for a monthly subscription to HallPass. You will be charged monthly for each shop you own that is within an 'Active' region.
              An 'Active' region is a geographic area around your shop that has 1,000 HallPass users. In other words, HallPass is free until there are 1,000 HallPass users around your shop.
              You will be given a 30 day free trial from sign-up.
              <br/><br/>
              Deactivation of your shops requires 30 days notice prior to the next billing date to assure cancellation.
              Deactivation requests submitted within the 30 day billing cycle will result in a final payment drawn from your account on your established auto draft date.
              <br/><br/>
              Prices are subject to change unless locked in by contract. Businesses will be given a 60 day notice for pricing changes.
              <br/><br/>
              All products are sold "as is". You assume the responsibility for your purchase, and no refunds will be issued.
            </div>
            <div className="CreditCardHomeLinks">
              <div className="CreditCardHomeLink" onClick={this.visitLink.bind(this, "https://app.termly.io/document/terms-of-use-for-ecommerce/d905814a-e203-4472-b312-3e50785ed417")}>
                Terms of Service
              </div>
              <div className="CreditCardHomeLink" onClick={this.visitLink.bind(this, "https://app.termly.io/document/privacy-policy/b168842b-d6d1-440c-8895-1278d30e0629")}>
                Privacy Policy
              </div>
            </div>
            <div className="CreditCardHomeButtons">
              <Components.MaterialButton type="Purple" onClick={this.changeView.bind(this, "Form")}>Accept</Components.MaterialButton>
              { !this.props.creditCardMandatory &&
                <Components.MaterialButton type="TextPurpleShadow" onClick={this.props.backFromCreditCardForm}>Skip</Components.MaterialButton>
              }
            </div>
            <div className="ButtonDiv">
              <Components.MaterialButton type="TextDark" onClick={API.logout}>Logout</Components.MaterialButton>
            </div>
          </div>
        }
        { this.state.subview === "Form" &&
          <StripeProvider apiKey={GetStripeKey(this.props.userInfo.testAccount === "1")}>
            <Elements>
              <StripeForm {...stripeFormProps} />
            </Elements>
          </StripeProvider>
        }
      </span>
    )
  }
}

export class Admin extends React.Component {

  constructor(props) {
    super(props)

    let view = props.tertiaryView || "Home"
    this.state = {
      loading: false,
      view: view
    }

    this.changeView = this.changeView.bind(this)
    this.updateSearchEngineShops = this.updateSearchEngineShops.bind(this)
    this.updateSearchEngineUsers = this.updateSearchEngineUsers.bind(this)
    this.updatePromotionActivationStates = this.updatePromotionActivationStates.bind(this)
    this.updateShopRegions = this.updateShopRegions.bind(this)
    this.setEmptyRegionNotificationTopics = this.setEmptyRegionNotificationTopics.bind(this)
    this.transferNotificationRegionUsers = this.transferNotificationRegionUsers.bind(this)
    this.recalculateNotificationSubscriptions = this.recalculateNotificationSubscriptions.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.render !== this.props.render) {
      this.changeView("Home")
    }
  }

  changeView(view) {
    //console.log("change view", view)
    this.setState({
      view: view
    })
  }

  updateSearchEngineShops() {
    this.setState({
      loading: true
    }, () => {
      API.callDarwinAPI("POST", "admin/updateAllSearchEngineShops", {}, (response) => {
        this.props.showPopup(response.error !== undefined ? "Error" : "Success", "Update All Search Engine Shops", response.error !== undefined ? response.error : response.data)
        this.setState({
          loading: false
        })
      })
    })
  }

  updateSearchEngineUsers() {
    this.setState({
      loading: true
    }, () => {
      API.callDarwinAPI("POST", "admin/updateAllSearchEngineUsers", {}, (response) => {
        this.props.showPopup(response.error !== undefined ? "Error" : "Success", "Update All Search Engine Users", response.error !== undefined ? response.error : response.data)
        this.setState({
          loading: false
        })
      })
    })
  }

  updatePromotionActivationStates() {
    this.setState({
      loading: true
    }, () => {
      API.callDarwinAPI("POST", "admin/updatePromotionActivationStates", {}, (response) => {
        this.props.showPopup(response.error !== undefined ? "Error" : "Success", "Update Promotion Activation States", response.error !== undefined ? response.error : response.data)
        this.setState({
          loading: false
        })
      })
    })
  }

  updateShopRegions() {
    this.setState({
      loading: true
    }, () => {
      API.callDarwinAPI("POST", "admin/updateShopRegions", {}, (response) => {
        this.props.showPopup(response.error !== undefined ? "Error" : "Success", "Update Shop Regions", response.error !== undefined ? response.error : response.data)
        this.setState({
          loading: false
        })
      })
    })
  }

  setEmptyRegionNotificationTopics() {
    this.setState({
      loading: true
    }, () => {
      API.callDarwinAPI("POST", "admin/setEmptyRegionNotificationTopics", {}, (response) => {
        this.props.showPopup(response.error !== undefined ? "Error" : "Success", "Set Empty Region Notification Topics", response.error !== undefined ? response.error : response.data)
        this.setState({
          loading: false
        })
      })
    })
  }

  transferNotificationRegionUsers() {
    this.setState({
      loading: true
    }, () => {
      API.callDarwinAPI("POST", "admin/transferNotificationRegionUsers", {}, (response) => {
        this.props.showPopup(response.error !== undefined ? "Error" : "Success", "Transfer Notification Region Users", response.error !== undefined ? response.error : response.data)
        this.setState({
          loading: false
        })
      })
    })
  }

  recalculateNotificationSubscriptions() {
    this.setState({
      loading: true
    }, () => {
      API.callDarwinAPI("POST", "admin/recalculateNotificationSubscriptions", {}, (response) => {
        this.props.showPopup(response.error !== undefined ? "Error" : "Success", "Recalculate Notification Subscriptions", response.error !== undefined ? response.error : response.data)
        this.setState({
          loading: false
        })
      })
    })
  }

  render() {
    return (
      <div className="Admin">
        { this.state.loading &&
          <div className="AdminLoading">
            <Components.LoadingIndicator />
          </div>
        }
        { this.state.view === "Home" &&
          <span>
            <div className="AdminTitle">
              Administration
            </div>
            { this.props.userInfo.accountType === "Admin" &&
              <span>
                <Components.AdminDiv
                  title="Promotion Review"
                  description="Review new & edited promotions for content. Approve to be shown on HallPass, deny for rework and changes."
                  color="#3EC43F"
                  image={ImageAdminReview}
                  onClick={this.changeView.bind(this, "PromotionReview")}
                />
                <Components.AdminDiv
                  title="Manage Regions"
                  description="Create, edit, and manage shop regions that determine when shops are paying and when shops are free"
                  color="#8B4CFF"
                  image={ImageManageRegions}
                  onClick={this.changeView.bind(this, "ManageRegions")}
                />
                <Components.AdminDiv
                  title="Admin Functions"
                  description="This is for internal use only to perform refreshes of the databases."
                  color="#393C51"
                  image={ImageAdminFunctions}
                  onClick={this.changeView.bind(this, "AdminFunctions")}
                />
              </span>
            }
          </span>
        }
        { this.state.view === "ManageAmbassadors" &&
          <span>
            TODO - Manage Ambassadors
          </span>
        }
        { this.state.view === "PromotionReview" &&
          <PromotionReview {...this.props} />
        }
        { this.state.view === "ManageRegions" &&
          <ManageRegions {...this.props} />
        }
        { this.state.view === "AdminFunctions" &&
          <span>
            <div className="AdminTitle">
              Admin Functions
            </div>
            <div className="AdminDescription">
              Use the functions below to call Admin only API methods for internal use. These functions may take awhile to run so use sparingly.
            </div>
            <AdminFunctionDiv
              title="Update Shop Search Engine Data"
              description="This will refresh all of the shop search engine data. This may take awhile so use sparingly."
              onClick={this.updateSearchEngineShops}
            />
            <AdminFunctionDiv
              title="Update User Search Engine Data"
              description="This will refresh all of the user search engine data. This may take awhile so use sparingly."
              onClick={this.updateSearchEngineUsers}
            />
            <AdminFunctionDiv
              title="Update Promotion Activation States"
              description="This will make sure that each shop has only one active promotion."
              onClick={this.updatePromotionActivationStates}
            />
            <AdminFunctionDiv
              title="Update Shop Regions"
              description="This will try to assign a shop to a region if the shop doesn't have on already and will update the region user counts."
              onClick={this.updateShopRegions}
            />
            <AdminFunctionDiv
              title="Set Empty Region Notification Topics"
              description="This will create a notification topic for every region that doesn't have one."
              onClick={this.setEmptyRegionNotificationTopics}
            />
            <AdminFunctionDiv
              title="Transfer Notification Region Users"
              description="This will transfer the existing notification region users to Devices."
              onClick={this.transferNotificationRegionUsers}
            />
            <AdminFunctionDiv
              title="Recalculate Notification Subscriptions"
              description="This will delete all notification subscriptions and then recreate them based on device locations. This will take awhile and may display an error for a timeout."
              onClick={this.recalculateNotificationSubscriptions}
            />
          </span>
        }
      </div>
    )
  }
}

export class ManageRegions extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      regions: [],
      selectedRegion: {},
      changesPending: false,
      currentLatitude: 33.177616,
      currentLongitude: -96.639754,
      emptyShops: [],
      selectedShop: {},

      data: {},
      forceCheck: false,
      error: undefined,
      shakeButton: false,
    }

    this.loadRegions = this.loadRegions.bind(this)
    this.loadEmptyShops = this.loadEmptyShops.bind(this)

    this.submitForm = this.submitForm.bind(this)
    this.formChanged = this.formChanged.bind(this)
    this.shakeTheButton = this.shakeTheButton.bind(this)
    this.editRegion = this.editRegion.bind(this)
    this.mapRegionSelected = this.mapRegionSelected.bind(this)
    this.regionCenterChanged = this.regionCenterChanged.bind(this)
    this.regionRadiusChanged = this.regionRadiusChanged.bind(this)
    this.createNewRegion = this.createNewRegion.bind(this)
    this.deleteRegion = this.deleteRegion.bind(this)
    this.emptyShopSelected = this.emptyShopSelected.bind(this)

    this.map = React.createRef()
  }

  componentDidMount() {
    this.loadRegions()
  }

  /*
  Loads the list of owners that you can pick from.
  */
  loadRegions() {
    this.setState({
      loading: true,
      data: {},
      regions: [],
      selectedRegion: {},
      changesPending: false,
    }, () => {
      API.callDarwinAPI("GET", "regions", {}, (result) => {
        //console.log("GET /regions", result)
        if ("error" in result) {
          this.props.showPopup("Error", "Couldn't retreive the list of regions", result.error)
          this.setState({
            loading: false
          })
          return
        }
        let regions = result.data.regions
        for (let i = 0; i < regions.length; i = i + 1) {
          regions[i].originalLatitude = regions[i].latitude
          regions[i].originalLongitude = regions[i].longitude
          regions[i].originalRegionRadius = regions[i].regionRadius
        }
        regions.sort(function(a, b) {
          if (parseFloat(a.regionRadius) < parseFloat(b.regionRadius)) {
            return 1
          } else if (parseFloat(a.regionRadius) > parseFloat(b.regionRadius)) {
            return -1
          } else {
            return 0
          }
        })
        this.setState({
          regions: result.data.regions,
          loading: false
        })
      })
    })
    this.loadEmptyShops()
  }

  /*
  Loads the shops that are not assigned to a shop and
  also the shops in the currently selected region
  */
  loadEmptyShops(overwrite = false) {
    let data = {}
    if (Object.keys(this.state.selectedRegion).length > 0) {
      data["regionID"] = this.state.selectedRegion.regionID
    }
    API.callDarwinAPI("GET", "emptyRegionShops", data, (result) => {
      console.log("GET /emptyRegionShops", result)
      if ("error" in result) {
        this.props.showPopup("Error", "Couldn't retreive the list of empty region shops", result.error)
        return
      }
      let newData = []
      if (overwrite) {
        newData = result.data.shops
      } else {
        //PARSE THE SHOPS SO WE DON'T OVERWRITE EXISTING SHOPS.
        for (let i = 0; i < result.data.shops.length; i = i + 1) {
          let found = false
          for (let j = 0; j < this.state.emptyShops.length; j = j + 1) {
            if (this.state.emptyShops[j].shopID === result.data.shops[i].shopID) {
              //add the emptyShops
              newData.push(this.state.emptyShops[j])
              found = true
              break
            }
          }
          if (!found) {
            newData.push(result.data.shops[i])
          }
        }
      }
      let newState = {
        emptyShops: newData
      }
      //If we can't find the selectedShop, then set selectedShop to {}
      let found = false
      for (let i = 0; i < newData.length; i = i + 1) {
        if (newData[i].shopID === this.state.selectedShop.shopID) {
          found = true
        }
      }
      if (!found) {
        newState.selectedShop = {}
      }
      this.setState(newState)
    })
  }

  /*
  * Submits the form
  */
  submitForm() {
    //1) Make sure every data element is valid.
    let valid = true
    for (let key in this.state.data) {
      if (this.state.data[key].valid === false) {
        valid = false
      }
    }
    //2) Make sure we have all of the data.
    let requiredFields = ["regionName", "regionUsersRequired"]
    requiredFields.forEach((element) => {
      if (this.state.data[element] === undefined || this.state.data[element].value === undefined) {
        valid = false
      }
    })
    //3) If valid, submit, else force check the fields for display.
    if (valid) {
      let data = {}
      for (let key in this.state.data) {
        data[key] = this.state.data[key].value
      }
      //Submit the form
      this.editRegion(data)
    } else {
      console.log("Form not valid to submit")
      this.setState({
        forceCheck: true
      })
      //Shake the submit button as it is invalid to submit
      this.shakeTheButton()
      return
    }
  }

  /*
  * Called when data in an input form changes.
  * This will update the state.data param with the
  * name and new value of the form element.
  */
  formChanged(name, value, valid) {
    this.setState((prevState) => {
      let newState = {
        changesPending: true
      }
      let d = prevState.data
      d[name] = {
        value: value,
        valid: valid
      }
      if (name === "region") {
        //update which region was selected
        newState.changesPending = false
        let regs = prevState.regions
        if (value === false) {
          newState.selectedRegion = {}
          for (let i = 0; i < regs.length; i = i + 1) {
            regs[i].selected = false
          }
        } else {
          for (let i = 0; i < regs.length; i = i + 1) {
            if (regs[i].regionID === value) {
              regs[i].selected = true
              newState.selectedRegion = regs[i]
              if (regs[i].regionCreated === 1) {
                newState.changesPending = true
              }
              //Reset the data to be this selected region's.
              if (regs[i].regionName.length > 0) {
                d["regionName"] = {
                  value: regs[i].regionName,
                  valid: true
                }
              } else {
                delete d["regionName"]
              }
              d["regionUsersRequired"] = {
                value: regs[i].regionUsersRequired,
                valid: true
              }
              d["regionActive"] = {
                value: regs[i].regionActive,
                valid: true
              }
              d["regionNotificationSupport"] = {
                value: regs[i].regionNotificationSupport,
                valid: true
              }
              newState.currentLatitude = regs[i].latitude
              newState.currentLongitude = regs[i].longitude
            } else {
              regs[i].selected = false
            }
          }
        }
        newState.regions = regs
        //deselect the shop
        newState.selectedShop = {}
        let shops = prevState.emptyShops
        for (let i = 0; i < shops.length; i = i + 1) {
          shops[i].selected = false
        }
        newState.emptyShops = shops
      } else if (name === "shop") {
        //update which shop was selected
        newState.changesPending = false
        let shops = prevState.emptyShops
        if (value === false) {
          newState.selectedShop = {}
          for (let i = 0; i < shops.length; i = i + 1) {
            shops[i].selected = false
          }
        } else {
          for (let i = 0; i < shops.length; i = i + 1) {
            if (shops[i].shopID === value) {
              console.log("found shop")
              shops[i].selected = true
              newState.selectedShop = shops[i]
              newState.currentLatitude = shops[i].shopLatitude
              newState.currentLongitude = shops[i].shopLongitude
            } else {
              shops[i].selected = false
            }
          }
        }
        newState.emptyShops = shops
        //deselect the region
        newState.selectedRegion = {}
        let regs = prevState.regions
        for (let i = 0; i < regs.length; i = i + 1) {
          regs[i].selected = false
        }
        newState.regions = regs
      }
      newState.data = d
      return newState
    }, () => {
      if (name === "region") {
        this.loadEmptyShops()
      }
    })
  }

  /*
  A map region was selected so we will select that.
  */
  mapRegionSelected(region, forceChanges = false) {
    if (region.pixel !== undefined) {
      //the empty map was selected so clear out the selection
      region = false
      forceChanges = false
    }

    let successCallback = (res, setNull = true) => {
      if (res) {
        this.setState((prevState) => {
          let regions = prevState.regions
          let index = 0;
          for (let i = 0; i < regions.length; i = i + 1) {
            if (regions[i].regionID === this.state.selectedRegion.regionID) {
              index = i;
              regions[i].latitude = regions[i].originalLatitude
              regions[i].longitude = regions[i].originalLongitude
              regions[i].regionRadius = regions[i].originalRegionRadius
              break
            }
          }
          if (prevState.selectedRegion.regionCreated === 1) {
            //remove this region from regions.
            regions.splice(index, 1)
            console.log(regions)
          }
          return {
            regions: regions,
          }
        }, () => {
          if (setNull) {
            this.formChanged("region", region ? region.regionID : false, true)
          }
        })
      }
    }

    let shopCallback = (res) => {
      if (res) {
        //deselect the region
        successCallback(true, false)
        //select the shop
        this.formChanged("shop", region ? region.shopID : false, true)
      }
    }

    if (region.shopID !== undefined) {
      console.log("shop selected", region)
      //a shop was selected not a region
      if (this.state.changesPending && !forceChanges) {
        if (this.state.selectedRegion.regionCreated === 1) {
          //if there are changes then prompt the user to save.
          this.props.showConfirmation("Wait!", "Your region hasn't been created yet. You need to hit the 'Create Region' button to actually create this region.", "Disregard Region", "Cancel", (res) => {
            shopCallback(res)
          })
        } else {
          //if there are changes then prompt the user to save.
          this.props.showConfirmation("Wait!", "There are unsaved changes to this region. Are you sure you want to continue?", "Continue", "Cancel", (res) => {
            shopCallback(res)
          })
        }
      } else {
        shopCallback(true)
      }
    } else {
      if ((region === false || this.state.selectedRegion.regionID !== region.regionID) && this.state.changesPending && !forceChanges) {
        //is this a new region or are we editing it?
        if (this.state.selectedRegion.regionCreated === 1) {
          //if there are changes then prompt the user to save.
          this.props.showConfirmation("Wait!", "Your region hasn't been created yet. You need to hit the 'Create Region' button to actually create this region.", "Disregard Region", "Cancel", (res) => {
            successCallback(res)
          })
        } else {
          //if there are changes then prompt the user to save.
          this.props.showConfirmation("Wait!", "There are unsaved changes to this region. Are you sure you want to continue?", "Continue", "Cancel", (res) => {
            successCallback(res)
          })
        }
      } else if (forceChanges) {
        successCallback(true)
      } else {
        this.formChanged("region", region ? region.regionID : false, true)
      }
    }
  }

  regionCenterChanged(region, latitude, longitude) {
    this.setState((prevState) => {
      let regions = prevState.regions
      for (let i = 0; i < regions.length; i = i + 1) {
        if (regions[i].regionID === region.regionID) {
          regions[i].latitude = latitude
          regions[i].longitude = longitude
          break
        }
      }
      return {
        regions: regions,
        changesPending: true
      }
    })
  }

  regionRadiusChanged(region, radius) {

    this.setState((prevState) => {
      let regions = prevState.regions
      for (let i = 0; i < regions.length; i = i + 1) {
        if (regions[i].regionID === region.regionID) {
          regions[i].regionRadius = radius / 1609.344
          break
        }
      }
      return {
        regions: regions,
        changesPending: true
      }
    })
  }

  /*
  Shakes the button and then removes the class.
  */
  shakeTheButton() {
    this.setState({
      shakeButton: true
    }, () => {
      setTimeout(() => {
        this.setState({
          shakeButton: false
        })
      }, 1000)
    })
  }

  /*
  Edits the currently selected region and saves to the database
  */
  editRegion(data) {

    let method = "PUT"
    let route = "region/" + this.state.selectedRegion.regionID
    let errorText = "Couldn't update the region"

    if (this.state.selectedRegion.regionCreated === 1) {
      //we need to create the region not edit it
      method = "POST"
      route = "region"
      errorText = "Couldn't create the region"
    }

    this.setState({
      loading: true
    }, () => {
      API.callDarwinAPI(method, route, {
        regionName: data.regionName,
        regionUsersRequired: data.regionUsersRequired,
        regionRadius: this.state.selectedRegion.regionRadius,
        latitude: this.state.selectedRegion.latitude,
        longitude: this.state.selectedRegion.longitude,
        regionActive: data.regionActive,
        regionNotificationSupport: data.regionNotificationSupport,
      }, (result) => {
        if ("error" in result) {
          this.props.showPopup("Error", errorText, result.error)
          this.setState({
            loading: false
          })
          return
        }
        //reload the data
        this.loadRegions()
        this.loadEmptyShops(true)
      })
    })
  }

  /*
  Shows the form to create the new region.
  */
  createNewRegion() {
    //1) Get the center of the map.
    let func = () => {
      if (this.map.current) {
        let center = this.map.current.getCenter()
        console.log("Center", center.lat(), center.lng())
        //2) Create a new region and add it to the regions data and the selectedRegion
        let newRegion = {
          regionID: "0",
          regionName: "",
          regionUserCount: "0",
          regionActive: "0",
          regionUsersRequired: "1000",
          regionNotificationSupport: "1",
          latitude: center.lat(),
          longitude: center.lng(),
          regionRadius: "15.0",
          shopCount: "0",
          //3) Set the new region's created property to true so we know this is a created promotion.
          regionCreated: 1,
        }
        this.setState((oldState) => {
          let newState = {}
          let oldRegions = oldState.regions
          oldRegions.push(newRegion)
          return newState
        }, () => {
          //now select the region
          this.mapRegionSelected(newRegion, true)
        })
      } else {
        console.log("this.map ref not set", this.map)
      }
    }
    if (this.state.changesPending) {
      this.props.showConfirmation("Wait!", "There are unsaved changes to this region. Are you sure you want to continue?", "Continue", "Cancel", (res) => {
        if (res) {
          func()
        }
      })
    } else {
      func()
    }
  }

  /*
  Deletes the selected region
  */
  deleteRegion() {
    this.props.showConfirmation("Delete Region?", "Are you sure you want to delete this region? This cannot be undone.", "Delete", "Cancel", (del) => {
      if (del) {
        this.setState({
          loading: true
        }, () => {
          API.callDarwinAPI("DELETE", "region/" + this.state.selectedRegion.regionID, {}, (result) => {
            //console.log("DELETE /region/" + this.state.selectedRegion.regionID, result)
            if ("error" in result) {
              this.props.showPopup("Error", "Couldn't delete the region", result.error)
              this.setState({
                loading: false
              })
              return
            }
            //reload the data
            this.loadRegions()
            this.loadEmptyShops(true)
          })
        })
      }
    })
  }

  /*
  A shop without a region was selected.
  */
  emptyShopSelected(shop) {
    this.mapRegionSelected(shop)
  }

  render() {
    let activeOptions = [
      {value: "0", label: "Inactive"},
      {value: "1", label: "Active"},
    ]
    let notificationSupportOptions = [
      {value: "0", label: "Shops Only"},
      {value: "1", label: "Shops & Notifications"},
      {value: "2", label: "Notifications Only"},
    ]
    return (
      <div className="ManageRegions">
        { this.state.loading &&
          <Components.LoadingIndicator top="100px" />
        }
        { !this.state.loading &&
          <span>
            {/* Show a title and description */}
            <div className="ManageRegionsTitle">
              Manage Regions
            </div>
            <div className="ManageRegionsDescription">
              Use the map to select a region.
              Once selected, you can set the region location and radius using the map, and edit the properties using the form below.
            </div>
            {/* Show a map */}
            <div className="ManageRegionsMap">
              <Components.GoogleMapViewRegions
                ref={this.map}
                onClick={this.mapRegionSelected}
                onCenterChanged={this.regionCenterChanged}
                onRadiusChanged={this.regionRadiusChanged}
                zoom={6}
                canEdit={true}
                latitude={this.state.currentLatitude} longitude={this.state.currentLongitude}
                emptyShops={this.state.emptyShops}
                emptyShopOnClick={this.emptyShopSelected}
                regions={this.state.regions} />
            </div>
            {/* Show the info about the selected region */}
            { Object.keys(this.state.selectedRegion).length > 0 &&
              <span>
                {/* Show the region information */}
                <Components.RegionDiv region={this.state.selectedRegion} />
                {/* Show some buttons to set the radius */}
                <div className="InputDiv">
                  <div className="inputBottomLineLightContainer">
                    <div className="inputBottomLineTitle">
                      radius
                    </div>
                    <div className="inputBottomLineDescription">
                      Pick an option below to set the radius or resize the circle on the map above.
                    </div>
                    { [5, 10, 15, 20, 25, 30, 40, 50].map((rad, i) => (
                      <Components.MaterialButton key={"radButton_" + i} type={Helpers.formatNumberDecimals(this.state.selectedRegion.regionRadius, 2) === Helpers.formatNumberDecimals(rad, 2) ? "Green" : "TextDarkShadow"} size="Small" onClick={() => {
                        this.regionRadiusChanged(this.state.selectedRegion, rad * 1609.344)
                      }} shake={this.state.shakeButton}>{rad + " mi"}</Components.MaterialButton>
                    ))}
                  </div>
                </div>
                {/* Show the latitude and longitude */}
                <div className="InputDiv">
                  <div className="inputBottomLineLightContainer">
                    <div className="inputBottomLineTitle">
                      location
                    </div>
                    <div className="inputBottomLineDescription">
                      The geographic center of this region
                    </div>
                    <div className="ManageRegionsLocation" style={{marginTop:"4px"}}>
                      {Helpers.formatNumberDecimals(this.state.selectedRegion.latitude, 6) + String.fromCharCode(176) + " latitude"}
                    </div>
                    <div className="ManageRegionsLocation">
                      {Helpers.formatNumberDecimals(this.state.selectedRegion.longitude, 6) + String.fromCharCode(176) + " longitude"}
                    </div>
                  </div>
                </div>
                {/* Show a form for setting the name */}
                <div className="InputDiv">
                  <Components.InputBottomLine type="text" name="regionName" placeholder="Waco, TX" validation="text" required="true" maximum={255}
                    title="name" description="The name of the region ex. Dallas, TX"
                    value={this.state.data.regionName ? this.state.data.regionName.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
                </div>
                {/* Show a selection box for setting the number of users required */}
                <div className="InputDiv">
                  <Components.InputBottomLine type="text" name="regionUsersRequired" placeholder="1,000" validation="positiveNumber" required="true"
                    title="users required for activation" description="The number of users required to activate this region ex. 1000"
                    value={this.state.data.regionUsersRequired ? this.state.data.regionUsersRequired.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
                </div>
                {/* Show a selection box for setting active vs. inactive */}
                <div className="InputDiv">
                  <Components.InputBottomLine type="selection" options={activeOptions} name="regionActive" placeholder="0" validation="text" required="true"
                    title="activated" description="If activated, we are charging the shops in this region"
                    value={this.state.data.regionActive ? this.state.data.regionActive.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
                </div>
                {/* Show a selection box for setting the notification support */}
                <div className="InputDiv">
                  <Components.InputBottomLine type="selection" options={notificationSupportOptions} name="regionNotificationSupport" placeholder="1" validation="text" required="true"
                    title="notification support" description="Does this region support notifications, are notifications deactivated, or does this region only support notifications and not shops."
                    value={this.state.data.regionNotificationSupport ? this.state.data.regionNotificationSupport.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
                </div>
                {/* Show the save changes and cancel button */}
                { this.state.selectedRegion.regionCreated === 1 &&
                  <span>
                    <div className="ButtonDiv">
                      <Components.MaterialButton type="Purple" size="Large" onClick={this.submitForm} shake={this.state.shakeButton}>Create Region</Components.MaterialButton>
                    </div>
                    <div className="ButtonDiv" style={{marginBottom:"30px"}}>
                      <Components.MaterialButton type="TextDark" size="Large" onClick={this.mapRegionSelected.bind(this, false)}>Cancel</Components.MaterialButton>
                    </div>
                  </span>
                }
                { this.state.selectedRegion.regionCreated !== 1 &&
                  <span>
                    <div className="ButtonDiv">
                      <Components.MaterialButton type="Green" size="Large" onClick={this.submitForm} shake={this.state.shakeButton}>Save Changes</Components.MaterialButton>
                    </div>
                    <div className="ButtonDiv">
                      <Components.MaterialButton type="Red" size="Large" onClick={this.deleteRegion} shake={this.state.shakeButton}>Delete Region</Components.MaterialButton>
                    </div>
                    <div className="ButtonDiv">
                      <Components.MaterialButton type="TextDark" size="Large" onClick={this.mapRegionSelected.bind(this, false)}>Cancel</Components.MaterialButton>
                    </div>
                  </span>
                }
              </span>
            }
            { Object.keys(this.state.selectedShop).length > 0 &&
              <span>
                <Components.ShopDiv onClick={this.props.viewShop.bind(this, this.state.selectedShop)} {...this.state.selectedShop} userInfo={this.props.userInfo} />
                <div className="ButtonDiv">
                  <Components.MaterialButton type="Green" size="Large" onClick={this.props.shopSetRegion.bind(this, this.state.selectedShop)}>Edit This Shop's Region</Components.MaterialButton>
                </div>
              </span>
            }
            {/* Show a button to create a new region */}
            { this.state.selectedRegion.regionCreated !== 1 &&
              <div className="ButtonDiv" style={{marginBottom:"30px"}}>
                <Components.MaterialButton type="Purple" size="Large" onClick={this.createNewRegion}>Create New Region</Components.MaterialButton>
              </div>
            }
          </span>
        }
      </div>
    )
  }
}

export class PromotionReview extends React.Component {

  constructor(props) {
    super(props)

    let data = {}
    this.state = {
      promotions: [],
      loading: false,

      data: data,
      forceCheck: false,
      error: undefined,
      shakeButton: false,
    }

    this.loadPromotionsForReview = this.loadPromotionsForReview.bind(this)
    this.changeStatus = this.changeStatus.bind(this)

    this.submitForm = this.submitForm.bind(this)
    this.formChanged = this.formChanged.bind(this)
    this.shakeTheButton = this.shakeTheButton.bind(this)
  }

  componentDidMount() {
    this.loadPromotionsForReview()
  }

  loadPromotionsForReview() {
    this.setState({
      loading: true
    }, () => {
      API.callDarwinAPI("GET", "promotionReviews", {}, (response) => {
        if ("error" in response) {
          console.log(response)
          this.props.showPopup("Error", "Couldn't find the promotions to be reviewed", response.error)
          this.setState({
            loading: false
          })
          return
        }
        this.setState({
          promotions: response.data.promotions,
          loading: false
        })
      })
    })
  }

  /*
  * Submits the form
  */
  submitForm() {
    //don't do anything.
  }

  /*
  * Called when data in an input form changes.
  * This will update the state.data param with the
  * name and new value of the form element.
  */
  formChanged(name, value, valid) {
    this.setState((prevState) => {
      let d = prevState.data
      d[name] = {
        value: value,
        valid: valid
      }
      return {
        data: d
      }
    })
  }

  /*
  Shakes the button and then removes the class.
  */
  shakeTheButton() {
    this.setState({
      shakeButton: true
    }, () => {
      setTimeout(() => {
        this.setState({
          shakeButton: false
        })
      }, 1000)
    })
  }

  changeStatus(promo, status) {
    let acceptStatus = status
    //1) Find the message in promoMessages
    let message = this.state.data[promo.promoID] ? this.state.data[promo.promoID].value : ""

    let callback = (newStatus) => {
      //2) Call the API
      API.callDarwinAPI("PUT", "promotionReview/" + promo.promoID, {
        passed: newStatus,
        message: message
      }, (response) => {
        if ("error" in response) {
          this.props.showPopup("Error", "Couldn't review the promotion, please try again", response.error)
          return
        }
        //3) Remove the promotion from state.promotions
        this.setState((oldState) => {
          let promos = oldState.promotions.filter(w => w.promoID !== promo.promoID)
          return {
            promotions: promos
          }
        })
      })
    }

    if (acceptStatus === 1) {
      //We are approving this, now decide if this is a premium deal.
      this.props.showConfirmation("Premium?", "Is this deal a premium deal?", "Premium", "Standard", (action) => {
        if (action) {
          //this is a premium deal.
          acceptStatus = 2
        }
        callback(acceptStatus)
      })
    } else {
      //rejected
      callback(acceptStatus)
    }
  }

  render() {
    return (
      <div className="PromotionReviewContainer">
        { this.state.loading &&
          <Components.LoadingIndicator top="100px" />
        }
        { !this.state.loading &&
          <span>
            { this.state.promotions.length === 0 &&
              <div className="PromotionReviewContainerNull">
                There are no promotions to review
              </div>
            }
            { this.state.promotions.map((promo, i) => (
              <div className="PromotionReviewBox" key={"promoPreview_" + i}>
                <Components.PromotionPreview promotion={promo} />
                <div className="PromotionReviewBoxText">
                  <Components.InputBottomLine type="text" name={promo.promoID} placeholder="Message" validation="text" required="false" maximum={10000}
                    value={this.state.data[promo.promoID] ? this.state.data[promo.promoID].value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
                </div>
                <div className="PromotionReviewBoxButtons">
                  <Components.MaterialButton type="Purple" onClick={this.changeStatus.bind(this, promo, 1)}>Approve</Components.MaterialButton>
                  <Components.MaterialButton type="Red" onClick={this.changeStatus.bind(this, promo, 0)}>Reject</Components.MaterialButton>
                </div>
              </div>
            ))}
          </span>
        }
      </div>
    )
  }
}

export class AdminFunctionDiv extends React.Component {

  render() {
    return (
      <div className="AdminFunctionDiv" onClick={this.props.onClick}>
        <div className="AdminFunctionDivTitle">
          {this.props.title}
        </div>
        <div className="AdminFunctionDivDescription">
          {this.props.description}
        </div>
      </div>
    )
  }
}

export class Auth extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      view: this.props.subview ? this.props.subview : "Login", //Login, CreateAccount, ResetPassword, Loading, Message, CheckRegion
      data: {}, //The data in the form fields
      forceCheck: false, //Should we force check the fields
      error: undefined, //Is there an error to show.
      shakeButton: false, //Should we shake the button
      regionUsers: false, //The number of users in this region - after entering in your address.
    }

    this.changeView = this.changeView.bind(this)
    this.submitForm = this.submitForm.bind(this)
    this.formChanged = this.formChanged.bind(this)
    this.shakeTheButton = this.shakeTheButton.bind(this)

    this.login = this.login.bind(this)
    this.createAccount = this.createAccount.bind(this)
    this.resendConfirmationEmail = this.resendConfirmationEmail.bind(this)
    this.submitForgotPassword = this.submitForgotPassword.bind(this)
    this.resendForgotPassword = this.resendForgotPassword.bind(this)
    this.checkRegion = this.checkRegion.bind(this)

    console.log("auth props", this.props.userInfo)
  }

  /*
  * Changes the view and resets all of the data.
  */
  changeView(newView) {
    this.setState({
      view: newView,
      data: {},
      forceCheck: false,
      error: undefined,
      shakeButton: false,
      regionUsers: false
    })
  }

  /*
  * Submits the login
  */
  submitForm() {
    //1) Make sure every data element is valid.
    let valid = true
    for (let key in this.state.data) {
      if (this.state.data[key].valid === false) {
        valid = false
      }
    }
    //2) Make sure we have all of the data.
    let requiredFields = []
    switch (this.state.view) {
      case "Login":
        requiredFields = ["email", "password"]
        break;
      case "CreateAccount":
        requiredFields = ["name", "email", "password", "confirmPassword", "phoneNumber"]
        break;
      case "ForgotPassword":
        requiredFields = ["email"]
        break;
      case "CheckRegion":
        requiredFields = ["address"]
        break;
      default:

    }
    requiredFields.forEach((element) => {
      if (this.state.data[element] === undefined || this.state.data[element].value === undefined) {
        valid = false
      }
    })
    //3) If valid, submit, else force check the fields for display.
    if (valid) {
      let data = {}
      for (let key in this.state.data) {
        data[key] = this.state.data[key].value
      }
      //Submit the form
      switch (this.state.view) {
        case "Login":
          this.login(data)
          break;
        case "CreateAccount":
          this.createAccount(data)
          break;
        case "ForgotPassword":
          this.submitForgotPassword(data)
          break;
        case "CheckRegion":
          this.checkRegion(data)
          break;
        default:
          break;
      }
    } else {
      console.log("Form not valid to submit")
      this.setState({
        forceCheck: true
      })
      //Shake the submit button as it is invalid to submit
      this.shakeTheButton()
      return
    }
  }

  /*
  * Called when data in an input form changes.
  * This will update the state.data param with the
  * name and new value of the form element.
  */
  formChanged(name, value, valid) {
    this.setState((prevState) => {
      let d = prevState.data
      d[name] = {
        value: value,
        valid: valid
      }
      return {
        data: d
      }
    })
  }

  /*
  Shakes the button and then removes the class.
  */
  shakeTheButton() {
    this.setState({
      shakeButton: true
    }, () => {
      setTimeout(() => {
        this.setState({
          shakeButton: false
        })
      }, 1000)
    })
  }

  /*
  Logs in the user with the provided data.
  */
  login(data) {
    console.log("Login Attempt")
    //1) Show a Loading Indicator...
    this.setState({
      view: "Loading"
    }, () => {
      //2) Submit the form.
      API.manualLogin(data.email, data.password, (result) => {
        if ("error" in result) {
          //3) On Error, show some error text on the screen.
          if (result.error === "Need to validate email.") {
            this.setState({
              view: "VerifyEmailAddress",
              error: undefined
            })
          } else {
            this.setState({
              view: "Login",
              error: "email or password is incorrect"
            })
          }
          return
        }
        //4) On Success, store the tokens and redirect back to the home page of the app.
        this.props.loggedIn()
      })
    })
  }

  /*
  Creates an account with the provided data.
  */
  createAccount(data) {
    let promoCode = data.promoCode ? data.promoCode : false

    let creation = () => {
      //2) Submit the form.
      API.manualCreateAccount(data.name, data.email, data.password, data.confirmPassword, (result) => {
        console.log("manual account creation", result)
        if ("error" in result) {
          //3) On Error, show some error text on the screen.
          this.setState({
            view: "CreateAccount",
            error: "an account with this email address already exists"
          })
          return
        }
        //4) On Success, show the check your email page.
        let newOwnerID = result.data
        if (Object.keys(this.props.userInfo).length > 0) {
          //we are making this account on behalf of another user so set the support account id then return home.
          let sendData = {
            ownerID: newOwnerID,
            makeAssociate: this.props.tertiaryView === "Associate" ? 1 : 0,
            phoneNumber: data.phoneNumber,
          }
          API.callDarwinAPI("PUT", "userSupportInfo2", sendData, (response) => {
            if ("error" in response) {
              //3) On Error, show some error text on the screen.
              this.setState({
                view: "CreateAccount",
                error: response.error
              })
              return
            }
            // Go back to the home page.
            this.props.goHome()
            /*if (this.props.tertiaryView === "Associate") {
              this.props.goHome()
            } else {
              this.props.goToEditCard(newOwnerID)
            }*/
          })
        } else {
          if (promoCode) {
            //we need to use this promoCode on an account to set the new accountManager
            API.callDarwinAPIUnsecured("PUT", "userSupportInfo3", {
              ownerID: newOwnerID,
              promoCode: promoCode,
              phoneNumber: data.phoneNumber,
            }, (response) => {
              console.log("userSupportInfo3", newOwnerID, promoCode, response)
              //no need to handle the response here
              this.setState({
                view: "VerifyEmailAddress",
                error: undefined
              })
            })
          } else {
            API.callDarwinAPIUnsecured("PUT", "userSupportInfo4", {
              ownerID: newOwnerID,
              phoneNumber: data.phoneNumber,
            }, (response) => {
              console.log("userSupportInfo4", response)
              //no need to handle the response here
              this.setState({
                view: "VerifyEmailAddress",
                error: undefined
              })
            })
          }
        }
      })
    }

    //1) Show a Loading Indicator...
    this.setState({
      view: "Loading"
    }, () => {
      if (promoCode) {
        API.callDarwinAPIUnsecured("GET", "userSupportInfo3", {
          promoCode: promoCode
        }, (response) => {
          if ("error" in response) {
            //promoCode is invalid so tell the user.
            this.props.showPopup("Error", "This invite code is invalid", "Make sure you have spelled it correctly and it is capitalized correctly. Invite codes are case sensitive. Please try again.")
            this.setState({
              view: "CreateAccount",
              error: "this invite code doesn't exist"
            })
            return
          }
          //promoCode is valid so create the account
          creation()
        })
      } else {
        creation()
      }
    })
  }

  /*
  Resends the confirmation email to this account.
  */
  resendConfirmationEmail() {
    //1) Show a Loading Indicator
    this.setState({
      view: "Loading"
    }, () => {
      //2) Submit the confirmation request
      API.manualResendConfirmation(this.state.data.email.value, (result) => {
        if ("error" in result) {
          //3) On Error, show some error text on the screen.
          this.setState({
            view: "VerifyEmailAddress",
            error: "Internal error - please try again. If the problem persists, try recreating your account."
          })
          return
        }
        //4) On Success, show the check your email page.
        console.log("result", result.data)
        this.setState({
          view: "VerifyEmailAddress",
          error: undefined
        })
      })
    })
  }

  /*
  Sends a forgot password reset link.
  */
  submitForgotPassword(data) {
    this.setState({
      view: "Loading"
    }, () => {
      //2) Submit the reset password request
      API.manualResetPassword(data.email, (result) => {
        if ("error" in result) {
          //3) On Error, show some error text on the screen.
          this.setState({
            view: "ForgotPassword",
            error: "There was an issue resetting your password. Make sure the email address you entered is correct and try again."
          })
          return
        }
        //4) On Success, show the check your email page.
        //console.log("result", result.data)
        this.setState({
          view: "VerifyForgotPassword",
          error: undefined
        })
      })
    })
  }

  /*
  Sends a link to your email to reset your password.
  */
  resendForgotPassword() {
    //1) Show a Loading Indicator
    this.setState({
      view: "Loading"
    }, () => {
      //2) Submit the confirmation request
      API.manualResetPassword(this.state.data.email.value, (result) => {
        if ("error" in result) {
          //3) On Error, show some error text on the screen.
          this.setState({
            view: "VerifyForgotPassword",
            error: "Internal error - please try again. If the problem persists, try recreating your account."
          })
          return
        }
        //4) On Success, show the check your email page.
        //console.log("result", result.data)
        this.setState({
          view: "VerifyForgotPassword",
          error: undefined
        })
      })
    })
  }

  /*
  Checks to see how many users are in the region surrounding this address.
  */
  checkRegion(data) {
    console.log("check region start", data)
    this.setState({
      view: "Loading"
    }, () => {
      //2) Submit the confirmation request
      API.callDarwinAPIUnsecured("GET", "regionUsers", {
        address: data.address
      }, (result) => {
        console.log("check region results", result)
        if ("error" in result) {
          this.setState({
            view: "CheckRegion",
            error: "Your address was invalid. Please try again.",
            regionUsers: false,
          })
          return
        }
        this.setState({
          view: "CheckRegion",
          error: undefined,
          regionUsers: result.data.users
        })
      })
    })
  }

  render() {

    return (
      <div className="Auth">
        { this.state.view === "Login" &&
          <div className="Container">
            <Components.DualImage image={ImageBidlyLogoPurple} hoverimage={ImageBidlyLogoPurple} style={{height:"80px"}}/>
            <div className="Title">
              Business Portal
            </div>
            { this.state.error &&
              <div className="ErrorDiv">
                { this.state.error }
              </div>
            }
            <div className="InputDiv">
              <Components.InputBottomLine type="text" name="email" placeholder="email" validation="email" required="true"
                value={this.state.data.email ? this.state.data.email.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
            </div>
            <div className="InputDiv">
              <Components.InputBottomLine type="password" name="password" placeholder="password" validation="text" required="true"
                value={this.state.data.password ? this.state.data.password.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
            </div>
            <div className="ButtonDiv">
              <Components.MaterialButton type="Purple" size="Large" onClick={this.submitForm} shake={this.state.shakeButton}>Login</Components.MaterialButton>
            </div>
            <div className="ButtonDiv">
              <Components.MaterialButton type="TextDark" onClick={this.changeView.bind(this, "ForgotPassword")}>Forgot Password</Components.MaterialButton>
              <Components.MaterialButton type="TextDark" onClick={this.changeView.bind(this, "CreateAccount")}>Create Account</Components.MaterialButton>
            </div>
          </div>
        }
        { this.state.view === "CreateAccount" &&
          <div className="Container">
            <Components.DualImage image={ImageBidlyLogoPurple} hoverimage={ImageBidlyLogoPurple} style={{height:"80px"}} onClick={this.changeView.bind(this, "Login")}/>
            <div className="Title">
              { Object.keys(this.props.userInfo).length > 0 && this.props.tertiaryView === "Associate" &&
                <span>Create Ambassador Account</span>
              }
              { Object.keys(this.props.userInfo).length > 0 && this.props.tertiaryView !== "Associate" &&
                <span>Create Owner Account</span>
              }
              { Object.keys(this.props.userInfo).length === 0 &&
                <span>Create Account</span>
              }
            </div>
            { this.state.error &&
              <div className="ErrorDiv">
                { this.state.error }
              </div>
            }
            {/* Name */}
            <div className="InputDiv">
              <Components.InputBottomLine type="text" name="name" placeholder="name" validation="text" required="true" maximum={255}
                value={this.state.data.name ? this.state.data.name.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
            </div>
            {/* Phone Number */}
            <div className="InputDiv">
              <Components.InputBottomLine type="text" name="phoneNumber" placeholder="(123) 456 - 7890" validation="phoneNumber10" required="true"
                title="phone number" description="The phone number to call for support / issues."
                value={this.state.data.phoneNumber ? this.state.data.phoneNumber.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
            </div>
            {/* Email */}
            <div className="InputDiv">
              <Components.InputBottomLine type="text" name="email" placeholder="email" validation="email" required="true" maximum={255}
                value={this.state.data.email ? this.state.data.email.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
            </div>
            {/* Password */}
            <div className="InputDiv">
              <Components.InputBottomLine type="password" name="password" placeholder="password" validation="password" required="true" maximum={255}
                value={this.state.data.password ? this.state.data.password.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
            </div>
            {/* Confirm Password */}
            <div className="InputDiv">
              <Components.InputBottomLine type="password" name="confirmPassword" placeholder="confirm password" validation="match" required="true" maximum={255} matchValue={this.state.data.password ? this.state.data.password.value : ""}
                value={this.state.data.confirmPassword ? this.state.data.confirmPassword.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
            </div>
            { Object.keys(this.props.userInfo).length === 0 &&
              <div className="InputDiv">
                <Components.InputBottomLine type="text" name="promoCode" placeholder="ABC123" validation="text" required="false" maximum={255}
                  title="invite code" description="If you have an invite code, now is the time to enter it"
                  value={this.state.data.promoCode ? this.state.data.promoCode.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
              </div>
            }
            <div className="ButtonDiv">
              <Components.MaterialButton type="Purple" size="Large" onClick={this.submitForm} shake={this.state.shakeButton}>Create Account</Components.MaterialButton>
            </div>
            <div className="ButtonDiv">
              { Object.keys(this.props.userInfo).length > 0 &&
                <Components.MaterialButton type="TextDark" onClick={this.props.goHome}>Cancel</Components.MaterialButton>
              }
              { Object.keys(this.props.userInfo).length === 0 &&
                <Components.MaterialButton type="TextDark" onClick={this.changeView.bind(this, "Login")}>Cancel</Components.MaterialButton>
              }
            </div>
            <div className="ButtonDiv" style={{paddingTop:"0px"}}>
              <Components.MaterialButton type="TextDark" size="Tiny" onClick={this.changeView.bind(this, "CheckRegion")} shake={this.state.shakeButton}>How many HallPass users are in my area?</Components.MaterialButton>
            </div>
          </div>
        }
        { this.state.view === "ForgotPassword" &&
          <div className="Container">
            <Components.DualImage image={ImageBidlyLogoPurple} hoverimage={ImageBidlyLogoPurple} style={{height:"80px"}} onClick={this.changeView.bind(this, "Login")}/>
            <div className="Title">
              Reset Password
            </div>
            <div className="InputDiv">
              <Components.InputBottomLine type="text" name="email" placeholder="email" validation="email" required="true" maximum={255}
                value={this.state.data.email ? this.state.data.email.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
            </div>
            <div className="ButtonDiv">
              <Components.MaterialButton type="Purple" size="Large" onClick={this.submitForm} shake={this.state.shakeButton}>Reset Password</Components.MaterialButton>
            </div>
            <div className="ButtonDiv">
              <Components.MaterialButton type="TextDark" onClick={this.changeView.bind(this, "Login")}>Cancel</Components.MaterialButton>
            </div>
          </div>
        }
        { this.state.view === "VerifyForgotPassword" &&
          <div className="Container">
            <Components.DualImage image={ImageBidlyLogoPurple} hoverimage={ImageBidlyLogoPurple} style={{height:"80px"}} onClick={this.changeView.bind(this, "Login")}/>
            <div className="Title">
              Reset Password
            </div>
            { this.state.error &&
              <div className="ErrorDiv">
                { this.state.error }
              </div>
            }
            <div className="Description" style={{marginTop: "30px"}}>
              An email with a link has been sent to
            </div>
            <div className="Description DescriptionDark">
              { this.state.data.email ? this.state.data.email.value : "error" }
            </div>
            <div className="Description">
              Click the link to reset your password.
            </div>
            <div className="ButtonDiv">
              <Components.MaterialButton type="Purple" size="Large" onClick={this.resendForgotPassword}>Resend Email</Components.MaterialButton>
            </div>
            <div className="ButtonDiv">
              <Components.MaterialButton type="TextDark" onClick={this.changeView.bind(this, "Login")}>Back to Login</Components.MaterialButton>
            </div>
          </div>
        }
        { this.state.view === "Loading" &&
          <div className="Container">
            <Components.DualImage image={ImageBidlyLogoPurple} hoverimage={ImageBidlyLogoPurple} style={{height:"80px"}}/>
            <div className="Title">
              Loading
            </div>
            <Components.LoadingIndicator top="60px" />
          </div>
        }
        { this.state.view === "VerifyEmailAddress" &&
          <div className="Container">
            <Components.DualImage image={ImageBidlyLogoPurple} hoverimage={ImageBidlyLogoPurple} style={{height:"80px"}} onClick={this.changeView.bind(this, "Login")}/>
            <div className="Title">
              Verify Email Address
            </div>
            { this.state.error &&
              <div className="ErrorDiv">
                { this.state.error }
              </div>
            }
            <div className="Description" style={{marginTop: "30px"}}>
              An email with a link has been sent to
            </div>
            <div className="Description DescriptionDark">
              { this.state.data.email ? this.state.data.email.value : "error" }
            </div>
            <div className="Description">
              Click the link to verify your email address.
            </div>
            <div className="ButtonDiv">
              <Components.MaterialButton type="Purple" size="Large" onClick={this.resendConfirmationEmail}>Resend Verification Email</Components.MaterialButton>
            </div>
            <div className="ButtonDiv">
              <Components.MaterialButton type="TextDark" onClick={this.changeView.bind(this, "Login")}>Back to Login</Components.MaterialButton>
            </div>
          </div>
        }
        { this.state.view === "CheckRegion" &&
          <div className="Container">
            <Components.DualImage image={ImageBidlyLogoPurple} hoverimage={ImageBidlyLogoPurple} style={{height:"80px"}} onClick={this.changeView.bind(this, "Login")}/>
            <div className="Title">
              { this.state.regionUsers === false &&
                <span>Check your address</span>
              }
              { this.state.regionUsers !== false &&
                <span>HallPass users in your area</span>
              }
            </div>
            { this.state.error &&
              <div className="ErrorDiv">
                { this.state.error }
              </div>
            }
            { this.state.regionUsers === false &&
              <span>
                <div className="InputDiv">
                  <Components.InputBottomLine type="text" name="address" placeholder="address" validation="text" required="true" maximum={255}
                    value={this.state.data.address ? this.state.data.address.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
                </div>
                <div className="ButtonDiv">
                  <Components.MaterialButton type="Purple" size="Large" onClick={this.submitForm} shake={this.state.shakeButton}>Check</Components.MaterialButton>
                </div>
                <div className="ButtonDiv">
                  <Components.MaterialButton type="TextDark" onClick={this.changeView.bind(this, "CreateAccount")}>Create Account</Components.MaterialButton>
                </div>
              </span>
            }
            { this.state.regionUsers !== false &&
              <span className="CheckRegionResults">
                <div className="CheckRegionAddress">
                  {this.state.data.address.value}
                </div>
                <div className="CheckRegionValue">
                  { this.state.regionUsers < 250 &&
                    <span>
                      There are <span className="CheckRegionValueBold">&#60; 250</span> users in your area.
                    </span>
                  }
                  { this.state.regionUsers >= 250 &&
                    <span>
                      There are <span className="CheckRegionValueBold">{Helpers.formatNumber(this.state.regionUsers)}</span> users in your area.
                    </span>
                  }
                </div>
                <div className="ButtonDiv">
                  <Components.MaterialButton type="Purple" size="Large" onClick={() => { this.setState({regionUsers: false}) }} shake={this.state.shakeButton}>Check Another</Components.MaterialButton>
                </div>
                <div className="ButtonDiv">
                  <Components.MaterialButton type="TextDark" onClick={this.changeView.bind(this, "CreateAccount")}>Create Account</Components.MaterialButton>
                </div>
              </span>
            }
          </div>
        }
      </div>
    )
  }
}

export class Header extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      messageState: "hidden"
    }
    this.toggleMessages = this.toggleMessages.bind(this)
    this.clickedMessage = this.clickedMessage.bind(this)
    this.stringToDate = this.stringToDate.bind(this)
    this.formatDate = this.formatDate.bind(this)
  }

  toggleMessages() {
    if (this.state.messageState === "hidden") {
      this.setState({
        messageState: "visible"
      })
    } else {
      this.setState({
        messageState: "hidden"
      })
    }
  }

  clickedMessage(message) {
    //console.log("clicked message: ", message)
    if (!message.readDateTime) {
      this.props.readMessage(message)
    }
  }

  stringToDate(val) {
    // Split timestamp into [ Y, M, D, h, m, s ]
    let t = val.split(/[- :]/);
    // Apply each element to the Date function
    return new Date(Date.UTC(t[0], t[1]-1, t[2], t[3], t[4], t[5]));
  }

  formatDate(date) {
    let monthNames = [
      "Jan", "Feb", "Mar",
      "Apr", "May", "June", "July",
      "Aug", "Sept", "Oct",
      "Nov", "Dec"
    ];
    return monthNames[date.getMonth()] + " " + date.getDate() + ", " + date.getFullYear()
  }

  render() {
    let newMessagesCount = this.props.messages.filter((m) => {
      return !m.readDateTime
    }).length
    return (
      <div className="Header">
        <div className="content">
          <div className="left">
            <Components.DualImage image={ImageBidlyLogoWhite} hoverimage={ImageBidlyLogoWhite} onClick={this.props.goToHome}/>
            { this.props.accountTakeover === true &&
              <Components.MaterialButton type="Green" onClick={this.props.stopAccessing}>Accessing</Components.MaterialButton>
            }
            { this.props.accountTakeover === false && this.props.userInfo.accountType === "Admin" &&
              <Components.MaterialButton type="White" onClick={this.props.goToAdmin}>Admin</Components.MaterialButton>
            }
          </div>
          <div className="middle">
            {this.props.topBarTitle}
          </div>
          <div className="right">
            <Components.MessageButton number={newMessagesCount} onClick={this.toggleMessages}/>
            <Components.MaterialButton type="White" onClick={this.props.goToAccount}>Account</Components.MaterialButton>
          </div>
        </div>
        { /* The DropDown goes here even if it is hidden. */ }
        <Components.DropDown className={"DropDown DropDown" + this.state.messageState} pose={this.state.messageState}>
          <div className="DropDownTitle">
            Messages
          </div>
          <div className="DropDownBody">
            { this.props.messages.length > 0 && this.props.messages.map((message, i) => (
              <div key={"message_" + (message.readDateTime ? "read" : "not") + "_" + i} className={"messageContainer" + (message.readDateTime ? "" : " messageContainerNew")} onClick={this.clickedMessage.bind(this, message)}>
                { !message.readDateTime &&
                  <div className="newDot">&nbsp;</div>
                }
                <div className="messageTitle">
                  {message.title}
                </div>
                <div className="messageBody">
                  {message.message}
                </div>
                <div className="messageDate">
                  {this.formatDate(this.stringToDate(message.creationDateTime))}
                </div>
              </div>
            ))}
            { this.props.messages.length === 0 &&
              <span>
                <div className="DropDownContentTitle">
                  Empty
                </div>
                <div className="DropDownContentDescription">
                  You have no messages to show.
                </div>
                <div className="DropDownContentImage">
                  <Components.DualImage image={ImageMailbox} />
                </div>
              </span>
            }
          </div>
        </Components.DropDown>
      </div>
    )
  }
}
